/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AccountIdRouteRouteImport } from './routes/$accountId/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountIdIndexRouteImport } from './routes/$accountId/index'
import { Route as AccountCreateRouteImport } from './routes/account/create'
import { Route as AccountIdSupportRouteImport } from './routes/$accountId/support'
import { Route as AccountIdErrorboundarydevtestRouteImport } from './routes/$accountId/errorboundarydevtest'
import { Route as AccountIdUserRouteRouteImport } from './routes/$accountId/_user/route'
import { Route as AccountIdAdminRouteRouteImport } from './routes/$accountId/_admin/route'
import { Route as AccountIdUserViewDataRouteImport } from './routes/$accountId/_user/view-data'
import { Route as AccountIdUserMissingServiceRouteImport } from './routes/$accountId/_user/missing-service'
import { Route as AccountIdUserUnitsRouteRouteImport } from './routes/$accountId/_user/units/route'
import { Route as AccountIdUserSensorsRouteRouteImport } from './routes/$accountId/_user/sensors/route'
import { Route as AccountIdUserPredictiveHeatControlRouteRouteImport } from './routes/$accountId/_user/predictive-heat-control/route'
import { Route as AccountIdUserGatewaysRouteRouteImport } from './routes/$accountId/_user/gateways/route'
import { Route as AccountIdUserEnergyxplorerRouteRouteImport } from './routes/$accountId/_user/energyxplorer/route'
import { Route as AccountIdUserEforsyningIntegrationRouteRouteImport } from './routes/$accountId/_user/eforsyning-integration/route'
import { Route as AccountIdUserDatahubIntegrationRouteRouteImport } from './routes/$accountId/_user/datahub-integration/route'
import { Route as AccountIdUserDashboardsRouteRouteImport } from './routes/$accountId/_user/dashboards/route'
import { Route as AccountIdUserDaluxIntegrationRouteRouteImport } from './routes/$accountId/_user/dalux-integration/route'
import { Route as AccountIdUserAlarmsRouteRouteImport } from './routes/$accountId/_user/alarms/route'
import { Route as AccountIdUserAccountRouteRouteImport } from './routes/$accountId/_user/account/route'
import { Route as AccountIdAdminServiceManagerRouteRouteImport } from './routes/$accountId/_admin/service-manager/route'
import { Route as AccountIdAdminOperationsRouteRouteImport } from './routes/$accountId/_admin/operations/route'
import { Route as AccountIdAdminDevicesRouteRouteImport } from './routes/$accountId/_admin/devices/route'
import { Route as AccountIdUserWeekscheduleManagerIndexRouteImport } from './routes/$accountId/_user/weekschedule-manager/index'
import { Route as AccountIdUserUnitsIndexRouteImport } from './routes/$accountId/_user/units/index'
import { Route as AccountIdUserSensorsIndexRouteImport } from './routes/$accountId/_user/sensors/index'
import { Route as AccountIdUserPredictiveHeatControlIndexRouteImport } from './routes/$accountId/_user/predictive-heat-control/index'
import { Route as AccountIdUserPowerbiIndexRouteImport } from './routes/$accountId/_user/powerbi/index'
import { Route as AccountIdUserGatewaysIndexRouteImport } from './routes/$accountId/_user/gateways/index'
import { Route as AccountIdUserExportDataIndexRouteImport } from './routes/$accountId/_user/export-data/index'
import { Route as AccountIdUserEnergyxplorerIndexRouteImport } from './routes/$accountId/_user/energyxplorer/index'
import { Route as AccountIdUserEforsyningIntegrationIndexRouteImport } from './routes/$accountId/_user/eforsyning-integration/index'
import { Route as AccountIdUserDatahubIntegrationIndexRouteImport } from './routes/$accountId/_user/datahub-integration/index'
import { Route as AccountIdUserDashboardsIndexRouteImport } from './routes/$accountId/_user/dashboards/index'
import { Route as AccountIdUserDaluxIntegrationIndexRouteImport } from './routes/$accountId/_user/dalux-integration/index'
import { Route as AccountIdUserAlarmsIndexRouteImport } from './routes/$accountId/_user/alarms/index'
import { Route as AccountIdAdminServiceManagerIndexRouteImport } from './routes/$accountId/_admin/service-manager/index'
import { Route as AccountIdAdminOperationsIndexRouteImport } from './routes/$accountId/_admin/operations/index'
import { Route as AccountIdAdminDevicesIndexRouteImport } from './routes/$accountId/_admin/devices/index'
import { Route as AccountIdUserUnitsCreateRouteImport } from './routes/$accountId/_user/units/create'
import { Route as AccountIdUserSensorsSensorIdRouteImport } from './routes/$accountId/_user/sensors/$sensorId'
import { Route as AccountIdUserPredictiveHeatControlCalendarRouteImport } from './routes/$accountId/_user/predictive-heat-control/calendar'
import { Route as AccountIdUserPredictiveHeatControlBuildingNameRouteImport } from './routes/$accountId/_user/predictive-heat-control/$buildingName'
import { Route as AccountIdUserPowerbiReportIdRouteImport } from './routes/$accountId/_user/powerbi/$reportId'
import { Route as AccountIdUserGatewaysCreateRouteImport } from './routes/$accountId/_user/gateways/create'
import { Route as AccountIdUserEnergyxplorerDashboardRouteImport } from './routes/$accountId/_user/energyxplorer/dashboard'
import { Route as AccountIdUserEforsyningIntegrationCreateRouteImport } from './routes/$accountId/_user/eforsyning-integration/create'
import { Route as AccountIdUserDatahubIntegrationCvrNumberRouteImport } from './routes/$accountId/_user/datahub-integration/$cvrNumber'
import { Route as AccountIdUserDashboardsWaterBasicRouteImport } from './routes/$accountId/_user/dashboards/water-basic'
import { Route as AccountIdUserDashboardsPowerBasicRouteImport } from './routes/$accountId/_user/dashboards/power-basic'
import { Route as AccountIdUserDashboardsHeatBasicRouteImport } from './routes/$accountId/_user/dashboards/heat-basic'
import { Route as AccountIdUserDashboardsCompressedAirRouteImport } from './routes/$accountId/_user/dashboards/compressed-air'
import { Route as AccountIdUserAlarmsAlarmIdRouteImport } from './routes/$accountId/_user/alarms/$alarmId'
import { Route as AccountIdUserAccountUsersRouteImport } from './routes/$accountId/_user/account/users'
import { Route as AccountIdUserAccountServicesRouteImport } from './routes/$accountId/_user/account/services'
import { Route as AccountIdUserAccountProfileRouteImport } from './routes/$accountId/_user/account/profile'
import { Route as AccountIdAdminServiceManagerManagedAccountIdRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId'
import { Route as AccountIdAdminDevicesRegisterRouteImport } from './routes/$accountId/_admin/devices/register'
import { Route as AccountIdUserUnitsUnitIdRouteRouteImport } from './routes/$accountId/_user/units/$unitId/route'
import { Route as AccountIdUserGatewaysGatewayIdRouteRouteImport } from './routes/$accountId/_user/gateways/$gatewayId/route'
import { Route as AccountIdUserEnergyxplorerPortfolioRouteRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/route'
import { Route as AccountIdUserEnergyxplorerDeepdiveRouteRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/route'
import { Route as AccountIdUserEnergyxplorerAlarmsRouteRouteImport } from './routes/$accountId/_user/energyxplorer/alarms/route'
import { Route as AccountIdUserAlarmsConfigurationRouteRouteImport } from './routes/$accountId/_user/alarms/configuration/route'
import { Route as AccountIdUserAlarmsAlarmGroupsRouteRouteImport } from './routes/$accountId/_user/alarms/alarm-groups/route'
import { Route as AccountIdAdminOperationsPredictiveHeatControlRouteRouteImport } from './routes/$accountId/_admin/operations/predictive-heat-control/route'
import { Route as AccountIdUserUnitsUnitIdIndexRouteImport } from './routes/$accountId/_user/units/$unitId/index'
import { Route as AccountIdUserGatewaysGatewayIdIndexRouteImport } from './routes/$accountId/_user/gateways/$gatewayId/index'
import { Route as AccountIdUserEnergyxplorerPortfolioIndexRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/index'
import { Route as AccountIdUserEnergyxplorerDeepdiveIndexRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/index'
import { Route as AccountIdUserEforsyningIntegrationIntegrationIdIndexRouteImport } from './routes/$accountId/_user/eforsyning-integration/$integrationId/index'
import { Route as AccountIdUserAlarmsConfigurationIndexRouteImport } from './routes/$accountId/_user/alarms/configuration/index'
import { Route as AccountIdUserAlarmsAlarmGroupsIndexRouteImport } from './routes/$accountId/_user/alarms/alarm-groups/index'
import { Route as AccountIdUserAccountServicesIndexRouteImport } from './routes/$accountId/_user/account/services/index'
import { Route as AccountIdAdminServiceManagerManagedAccountIdIndexRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/index'
import { Route as AccountIdAdminOperationsQualityOfServiceIndexRouteImport } from './routes/$accountId/_admin/operations/quality-of-service/index'
import { Route as AccountIdAdminOperationsPredictiveHeatControlIndexRouteImport } from './routes/$accountId/_admin/operations/predictive-heat-control/index'
import { Route as AccountIdAdminOperationsPortfolioAnalysisIndexRouteImport } from './routes/$accountId/_admin/operations/portfolio-analysis/index'
import { Route as AccountIdAdminOperationsDeepDiveIndexRouteImport } from './routes/$accountId/_admin/operations/deep-dive/index'
import { Route as AccountIdAdminDevicesChar8364deviceIdIndexRouteImport } from './routes/$accountId/_admin/devices/€deviceId/index'
import { Route as AccountIdAdminDevicesDeviceIdIndexRouteImport } from './routes/$accountId/_admin/devices/$deviceId/index'
import { Route as AccountIdUserUnitsUnitIdEditRouteImport } from './routes/$accountId/_user/units/$unitId/edit'
import { Route as AccountIdUserGatewaysGatewayIdEditRouteImport } from './routes/$accountId/_user/gateways/$gatewayId/edit'
import { Route as AccountIdUserEnergyxplorerPortfolioDashboardRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/dashboard'
import { Route as AccountIdUserEnergyxplorerDeepdiveDashboardRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/dashboard'
import { Route as AccountIdUserEnergyxplorerDeepdiveCreateRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/create'
import { Route as AccountIdUserEnergyxplorerAlarmsAlarmIdRouteImport } from './routes/$accountId/_user/energyxplorer/alarms/$alarmId'
import { Route as AccountIdUserEforsyningIntegrationIntegrationIdEditRouteImport } from './routes/$accountId/_user/eforsyning-integration/$integrationId/edit'
import { Route as AccountIdUserAlarmsConfigurationAlarmConfigurationIdRouteImport } from './routes/$accountId/_user/alarms/configuration/$alarmConfigurationId'
import { Route as AccountIdUserAlarmsAlarmGroupsCreateRouteImport } from './routes/$accountId/_user/alarms/alarm-groups/create'
import { Route as AccountIdUserAlarmsAlarmGroupsGroupIdRouteImport } from './routes/$accountId/_user/alarms/alarm-groups/$groupId'
import { Route as AccountIdUserAccountServicesSchedulerRouteImport } from './routes/$accountId/_user/account/services/scheduler'
import { Route as AccountIdUserAccountServicesPredictiveHeatControlRouteImport } from './routes/$accountId/_user/account/services/predictive-heat-control'
import { Route as AccountIdUserAccountServicesPowerbiRouteImport } from './routes/$accountId/_user/account/services/powerbi'
import { Route as AccountIdUserAccountServicesPortfolioAnalysisRouteImport } from './routes/$accountId/_user/account/services/portfolio-analysis'
import { Route as AccountIdUserAccountServicesJyskenergiesgRouteImport } from './routes/$accountId/_user/account/services/jyskenergiesg'
import { Route as AccountIdUserAccountServicesEnergyxplorerAnalyticsRouteImport } from './routes/$accountId/_user/account/services/energyxplorer-analytics'
import { Route as AccountIdUserAccountServicesEnergyxplorerRouteImport } from './routes/$accountId/_user/account/services/energyxplorer'
import { Route as AccountIdUserAccountServicesDevicesRouteImport } from './routes/$accountId/_user/account/services/devices'
import { Route as AccountIdUserAccountServicesDatahubIntegrationRouteImport } from './routes/$accountId/_user/account/services/datahub-integration'
import { Route as AccountIdUserAccountServicesDashboardWaterBasicRouteImport } from './routes/$accountId/_user/account/services/dashboard-water-basic'
import { Route as AccountIdUserAccountServicesDashboardPowerBasicRouteImport } from './routes/$accountId/_user/account/services/dashboard-power-basic'
import { Route as AccountIdUserAccountServicesDashboardHeatBasicRouteImport } from './routes/$accountId/_user/account/services/dashboard-heat-basic'
import { Route as AccountIdUserAccountServicesCompressedAirRouteImport } from './routes/$accountId/_user/account/services/compressed-air'
import { Route as AccountIdUserAccountServicesBasisRouteImport } from './routes/$accountId/_user/account/services/basis'
import { Route as AccountIdUserAccountServicesBasicDashboardsRouteImport } from './routes/$accountId/_user/account/services/basic-dashboards'
import { Route as AccountIdUserAccountServicesAnalyticsRouteImport } from './routes/$accountId/_user/account/services/analytics'
import { Route as AccountIdUserAccountServicesAlarmsRouteImport } from './routes/$accountId/_user/account/services/alarms'
import { Route as AccountIdAdminServiceManagerManagedAccountIdSchedulerRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/scheduler'
import { Route as AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/predictive-heat-control'
import { Route as AccountIdAdminServiceManagerManagedAccountIdPowerbiRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/powerbi'
import { Route as AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/portfolio-analysis'
import { Route as AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/jyskenergiesg'
import { Route as AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/energyxplorer-analytics'
import { Route as AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/energyxplorer'
import { Route as AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/eforsyning-integration'
import { Route as AccountIdAdminServiceManagerManagedAccountIdDevicesRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/devices'
import { Route as AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/datahub-integration'
import { Route as AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/dashboard-water-basic'
import { Route as AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/dashboard-power-basic'
import { Route as AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/dashboard-heat-basic'
import { Route as AccountIdAdminServiceManagerManagedAccountIdCompressedAirRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/compressed-air'
import { Route as AccountIdAdminServiceManagerManagedAccountIdBasisRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/basis'
import { Route as AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/basic-dashboards'
import { Route as AccountIdAdminServiceManagerManagedAccountIdAnalyticsRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/analytics'
import { Route as AccountIdAdminServiceManagerManagedAccountIdAlarmsRouteImport } from './routes/$accountId/_admin/service-manager/$managedAccountId/alarms'
import { Route as AccountIdAdminOperationsDeepDiveGroupIdRouteImport } from './routes/$accountId/_admin/operations/deep-dive/$groupId'
import { Route as AccountIdAdminDevicesDeviceIdEditRouteImport } from './routes/$accountId/_admin/devices/$deviceId/edit'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/route'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/route'
import { Route as AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteImport } from './routes/$accountId/_user/energyxplorer/alarms/advanced/route'
import { Route as AccountIdUserEnergyxplorerPortfolioOverviewIndexRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/overview/index'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/index'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/index'
import { Route as AccountIdUserEnergyxplorerAlarmsAdvancedIndexRouteImport } from './routes/$accountId/_user/energyxplorer/alarms/advanced/index'
import { Route as AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRouteImport } from './routes/$accountId/_admin/operations/predictive-heat-control/subscriptions/index'
import { Route as AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRouteImport } from './routes/$accountId/_admin/operations/predictive-heat-control/groups/index'
import { Route as AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRouteImport } from './routes/$accountId/_admin/operations/predictive-heat-control/buildings/index'
import { Route as AccountIdUserEnergyxplorerPortfolioSiteCreateRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/site/create'
import { Route as AccountIdUserEnergyxplorerPortfolioOverviewStandardRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/overview/standard'
import { Route as AccountIdUserEnergyxplorerPortfolioOverviewBuildingRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/overview/building'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/pivot'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/load-profile-analysis'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/hour-analysis'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/esg'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-analysis'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/edit'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/duration-analysis'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/create-first-node'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/consumption-overview'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/comparison-analysis'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/child-analysis'
import { Route as AccountIdUserEnergyxplorerAlarmsAdvancedCreateRouteImport } from './routes/$accountId/_user/energyxplorer/alarms/advanced/create'
import { Route as AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRouteImport } from './routes/$accountId/_user/energyxplorer/alarms/advanced/$groupId'
import { Route as AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRouteImport } from './routes/$accountId/_user/alarms/configuration/create/$alarmTypeId'
import { Route as AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRouteImport } from './routes/$accountId/_admin/operations/predictive-heat-control/groups/$groupKey'
import { Route as AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRouteImport } from './routes/$accountId/_admin/operations/predictive-heat-control/buildings/$buildingName'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/route'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/route'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/index'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/index'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/index'
import { Route as AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRouteImport } from './routes/$accountId/_admin/operations/predictive-heat-control/subscriptions/$subscriptionName/index'
import { Route as AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRouteImport } from './routes/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/index'
import { Route as AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRouteImport } from './routes/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/index'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/$preset'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/esg'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis'
import { Route as AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRouteImport } from './routes/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create'
import { Route as AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRouteImport } from './routes/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/$providerId'
import { Route as AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRouteImport } from './routes/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/$providerId'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/index'
import { Route as AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRouteImport } from './routes/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit'

const AccountIdRouteRoute = AccountIdRouteRouteImport.update({
  id: '/$accountId',
  path: '/$accountId',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIdIndexRoute = AccountIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountIdRouteRoute,
} as any)
const AccountCreateRoute = AccountCreateRouteImport.update({
  id: '/account/create',
  path: '/account/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIdSupportRoute = AccountIdSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AccountIdRouteRoute,
} as any)
const AccountIdErrorboundarydevtestRoute =
  AccountIdErrorboundarydevtestRouteImport.update({
    id: '/errorboundarydevtest',
    path: '/errorboundarydevtest',
    getParentRoute: () => AccountIdRouteRoute,
  } as any)
const AccountIdUserRouteRoute = AccountIdUserRouteRouteImport.update({
  id: '/_user',
  getParentRoute: () => AccountIdRouteRoute,
} as any)
const AccountIdAdminRouteRoute = AccountIdAdminRouteRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AccountIdRouteRoute,
} as any)
const AccountIdUserViewDataRoute = AccountIdUserViewDataRouteImport.update({
  id: '/view-data',
  path: '/view-data',
  getParentRoute: () => AccountIdUserRouteRoute,
} as any)
const AccountIdUserMissingServiceRoute =
  AccountIdUserMissingServiceRouteImport.update({
    id: '/missing-service',
    path: '/missing-service',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserUnitsRouteRoute = AccountIdUserUnitsRouteRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => AccountIdUserRouteRoute,
} as any)
const AccountIdUserSensorsRouteRoute =
  AccountIdUserSensorsRouteRouteImport.update({
    id: '/sensors',
    path: '/sensors',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserPredictiveHeatControlRouteRoute =
  AccountIdUserPredictiveHeatControlRouteRouteImport.update({
    id: '/predictive-heat-control',
    path: '/predictive-heat-control',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserGatewaysRouteRoute =
  AccountIdUserGatewaysRouteRouteImport.update({
    id: '/gateways',
    path: '/gateways',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerRouteRoute =
  AccountIdUserEnergyxplorerRouteRouteImport.update({
    id: '/energyxplorer',
    path: '/energyxplorer',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserEforsyningIntegrationRouteRoute =
  AccountIdUserEforsyningIntegrationRouteRouteImport.update({
    id: '/eforsyning-integration',
    path: '/eforsyning-integration',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserDatahubIntegrationRouteRoute =
  AccountIdUserDatahubIntegrationRouteRouteImport.update({
    id: '/datahub-integration',
    path: '/datahub-integration',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserDashboardsRouteRoute =
  AccountIdUserDashboardsRouteRouteImport.update({
    id: '/dashboards',
    path: '/dashboards',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserDaluxIntegrationRouteRoute =
  AccountIdUserDaluxIntegrationRouteRouteImport.update({
    id: '/dalux-integration',
    path: '/dalux-integration',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserAlarmsRouteRoute =
  AccountIdUserAlarmsRouteRouteImport.update({
    id: '/alarms',
    path: '/alarms',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserAccountRouteRoute =
  AccountIdUserAccountRouteRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdAdminServiceManagerRouteRoute =
  AccountIdAdminServiceManagerRouteRouteImport.update({
    id: '/service-manager',
    path: '/service-manager',
    getParentRoute: () => AccountIdAdminRouteRoute,
  } as any)
const AccountIdAdminOperationsRouteRoute =
  AccountIdAdminOperationsRouteRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => AccountIdAdminRouteRoute,
  } as any)
const AccountIdAdminDevicesRouteRoute =
  AccountIdAdminDevicesRouteRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AccountIdAdminRouteRoute,
  } as any)
const AccountIdUserWeekscheduleManagerIndexRoute =
  AccountIdUserWeekscheduleManagerIndexRouteImport.update({
    id: '/weekschedule-manager/',
    path: '/weekschedule-manager/',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserUnitsIndexRoute = AccountIdUserUnitsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountIdUserUnitsRouteRoute,
} as any)
const AccountIdUserSensorsIndexRoute =
  AccountIdUserSensorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserSensorsRouteRoute,
  } as any)
const AccountIdUserPredictiveHeatControlIndexRoute =
  AccountIdUserPredictiveHeatControlIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserPredictiveHeatControlRouteRoute,
  } as any)
const AccountIdUserPowerbiIndexRoute =
  AccountIdUserPowerbiIndexRouteImport.update({
    id: '/powerbi/',
    path: '/powerbi/',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserGatewaysIndexRoute =
  AccountIdUserGatewaysIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserGatewaysRouteRoute,
  } as any)
const AccountIdUserExportDataIndexRoute =
  AccountIdUserExportDataIndexRouteImport.update({
    id: '/export-data/',
    path: '/export-data/',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerIndexRoute =
  AccountIdUserEnergyxplorerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserEnergyxplorerRouteRoute,
  } as any)
const AccountIdUserEforsyningIntegrationIndexRoute =
  AccountIdUserEforsyningIntegrationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserEforsyningIntegrationRouteRoute,
  } as any)
const AccountIdUserDatahubIntegrationIndexRoute =
  AccountIdUserDatahubIntegrationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserDatahubIntegrationRouteRoute,
  } as any)
const AccountIdUserDashboardsIndexRoute =
  AccountIdUserDashboardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserDashboardsRouteRoute,
  } as any)
const AccountIdUserDaluxIntegrationIndexRoute =
  AccountIdUserDaluxIntegrationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserDaluxIntegrationRouteRoute,
  } as any)
const AccountIdUserAlarmsIndexRoute =
  AccountIdUserAlarmsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserAlarmsRouteRoute,
  } as any)
const AccountIdAdminServiceManagerIndexRoute =
  AccountIdAdminServiceManagerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdAdminServiceManagerRouteRoute,
  } as any)
const AccountIdAdminOperationsIndexRoute =
  AccountIdAdminOperationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdAdminOperationsRouteRoute,
  } as any)
const AccountIdAdminDevicesIndexRoute =
  AccountIdAdminDevicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdAdminDevicesRouteRoute,
  } as any)
const AccountIdUserUnitsCreateRoute =
  AccountIdUserUnitsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AccountIdUserUnitsRouteRoute,
  } as any)
const AccountIdUserSensorsSensorIdRoute =
  AccountIdUserSensorsSensorIdRouteImport.update({
    id: '/$sensorId',
    path: '/$sensorId',
    getParentRoute: () => AccountIdUserSensorsRouteRoute,
  } as any)
const AccountIdUserPredictiveHeatControlCalendarRoute =
  AccountIdUserPredictiveHeatControlCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AccountIdUserPredictiveHeatControlRouteRoute,
  } as any)
const AccountIdUserPredictiveHeatControlBuildingNameRoute =
  AccountIdUserPredictiveHeatControlBuildingNameRouteImport.update({
    id: '/$buildingName',
    path: '/$buildingName',
    getParentRoute: () => AccountIdUserPredictiveHeatControlRouteRoute,
  } as any)
const AccountIdUserPowerbiReportIdRoute =
  AccountIdUserPowerbiReportIdRouteImport.update({
    id: '/powerbi/$reportId',
    path: '/powerbi/$reportId',
    getParentRoute: () => AccountIdUserRouteRoute,
  } as any)
const AccountIdUserGatewaysCreateRoute =
  AccountIdUserGatewaysCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AccountIdUserGatewaysRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDashboardRoute =
  AccountIdUserEnergyxplorerDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AccountIdUserEnergyxplorerRouteRoute,
  } as any)
const AccountIdUserEforsyningIntegrationCreateRoute =
  AccountIdUserEforsyningIntegrationCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AccountIdUserEforsyningIntegrationRouteRoute,
  } as any)
const AccountIdUserDatahubIntegrationCvrNumberRoute =
  AccountIdUserDatahubIntegrationCvrNumberRouteImport.update({
    id: '/$cvrNumber',
    path: '/$cvrNumber',
    getParentRoute: () => AccountIdUserDatahubIntegrationRouteRoute,
  } as any)
const AccountIdUserDashboardsWaterBasicRoute =
  AccountIdUserDashboardsWaterBasicRouteImport.update({
    id: '/water-basic',
    path: '/water-basic',
    getParentRoute: () => AccountIdUserDashboardsRouteRoute,
  } as any)
const AccountIdUserDashboardsPowerBasicRoute =
  AccountIdUserDashboardsPowerBasicRouteImport.update({
    id: '/power-basic',
    path: '/power-basic',
    getParentRoute: () => AccountIdUserDashboardsRouteRoute,
  } as any)
const AccountIdUserDashboardsHeatBasicRoute =
  AccountIdUserDashboardsHeatBasicRouteImport.update({
    id: '/heat-basic',
    path: '/heat-basic',
    getParentRoute: () => AccountIdUserDashboardsRouteRoute,
  } as any)
const AccountIdUserDashboardsCompressedAirRoute =
  AccountIdUserDashboardsCompressedAirRouteImport.update({
    id: '/compressed-air',
    path: '/compressed-air',
    getParentRoute: () => AccountIdUserDashboardsRouteRoute,
  } as any)
const AccountIdUserAlarmsAlarmIdRoute =
  AccountIdUserAlarmsAlarmIdRouteImport.update({
    id: '/$alarmId',
    path: '/$alarmId',
    getParentRoute: () => AccountIdUserAlarmsRouteRoute,
  } as any)
const AccountIdUserAccountUsersRoute =
  AccountIdUserAccountUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AccountIdUserAccountRouteRoute,
  } as any)
const AccountIdUserAccountServicesRoute =
  AccountIdUserAccountServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => AccountIdUserAccountRouteRoute,
  } as any)
const AccountIdUserAccountProfileRoute =
  AccountIdUserAccountProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AccountIdUserAccountRouteRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdRoute =
  AccountIdAdminServiceManagerManagedAccountIdRouteImport.update({
    id: '/$managedAccountId',
    path: '/$managedAccountId',
    getParentRoute: () => AccountIdAdminServiceManagerRouteRoute,
  } as any)
const AccountIdAdminDevicesRegisterRoute =
  AccountIdAdminDevicesRegisterRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => AccountIdAdminDevicesRouteRoute,
  } as any)
const AccountIdUserUnitsUnitIdRouteRoute =
  AccountIdUserUnitsUnitIdRouteRouteImport.update({
    id: '/$unitId',
    path: '/$unitId',
    getParentRoute: () => AccountIdUserUnitsRouteRoute,
  } as any)
const AccountIdUserGatewaysGatewayIdRouteRoute =
  AccountIdUserGatewaysGatewayIdRouteRouteImport.update({
    id: '/$gatewayId',
    path: '/$gatewayId',
    getParentRoute: () => AccountIdUserGatewaysRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioRouteRoute =
  AccountIdUserEnergyxplorerPortfolioRouteRouteImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => AccountIdUserEnergyxplorerRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveRouteRoute =
  AccountIdUserEnergyxplorerDeepdiveRouteRouteImport.update({
    id: '/deepdive',
    path: '/deepdive',
    getParentRoute: () => AccountIdUserEnergyxplorerRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerAlarmsRouteRoute =
  AccountIdUserEnergyxplorerAlarmsRouteRouteImport.update({
    id: '/alarms',
    path: '/alarms',
    getParentRoute: () => AccountIdUserEnergyxplorerRouteRoute,
  } as any)
const AccountIdUserAlarmsConfigurationRouteRoute =
  AccountIdUserAlarmsConfigurationRouteRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AccountIdUserAlarmsRouteRoute,
  } as any)
const AccountIdUserAlarmsAlarmGroupsRouteRoute =
  AccountIdUserAlarmsAlarmGroupsRouteRouteImport.update({
    id: '/alarm-groups',
    path: '/alarm-groups',
    getParentRoute: () => AccountIdUserAlarmsRouteRoute,
  } as any)
const AccountIdAdminOperationsPredictiveHeatControlRouteRoute =
  AccountIdAdminOperationsPredictiveHeatControlRouteRouteImport.update({
    id: '/predictive-heat-control',
    path: '/predictive-heat-control',
    getParentRoute: () => AccountIdAdminOperationsRouteRoute,
  } as any)
const AccountIdUserUnitsUnitIdIndexRoute =
  AccountIdUserUnitsUnitIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserUnitsUnitIdRouteRoute,
  } as any)
const AccountIdUserGatewaysGatewayIdIndexRoute =
  AccountIdUserGatewaysGatewayIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserGatewaysGatewayIdRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioIndexRoute =
  AccountIdUserEnergyxplorerPortfolioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserEnergyxplorerPortfolioRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveIndexRoute =
  AccountIdUserEnergyxplorerDeepdiveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserEnergyxplorerDeepdiveRouteRoute,
  } as any)
const AccountIdUserEforsyningIntegrationIntegrationIdIndexRoute =
  AccountIdUserEforsyningIntegrationIntegrationIdIndexRouteImport.update({
    id: '/$integrationId/',
    path: '/$integrationId/',
    getParentRoute: () => AccountIdUserEforsyningIntegrationRouteRoute,
  } as any)
const AccountIdUserAlarmsConfigurationIndexRoute =
  AccountIdUserAlarmsConfigurationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserAlarmsConfigurationRouteRoute,
  } as any)
const AccountIdUserAlarmsAlarmGroupsIndexRoute =
  AccountIdUserAlarmsAlarmGroupsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserAlarmsAlarmGroupsRouteRoute,
  } as any)
const AccountIdUserAccountServicesIndexRoute =
  AccountIdUserAccountServicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdIndexRoute =
  AccountIdAdminServiceManagerManagedAccountIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminOperationsQualityOfServiceIndexRoute =
  AccountIdAdminOperationsQualityOfServiceIndexRouteImport.update({
    id: '/quality-of-service/',
    path: '/quality-of-service/',
    getParentRoute: () => AccountIdAdminOperationsRouteRoute,
  } as any)
const AccountIdAdminOperationsPredictiveHeatControlIndexRoute =
  AccountIdAdminOperationsPredictiveHeatControlIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AccountIdAdminOperationsPredictiveHeatControlRouteRoute,
  } as any)
const AccountIdAdminOperationsPortfolioAnalysisIndexRoute =
  AccountIdAdminOperationsPortfolioAnalysisIndexRouteImport.update({
    id: '/portfolio-analysis/',
    path: '/portfolio-analysis/',
    getParentRoute: () => AccountIdAdminOperationsRouteRoute,
  } as any)
const AccountIdAdminOperationsDeepDiveIndexRoute =
  AccountIdAdminOperationsDeepDiveIndexRouteImport.update({
    id: '/deep-dive/',
    path: '/deep-dive/',
    getParentRoute: () => AccountIdAdminOperationsRouteRoute,
  } as any)
const AccountIdAdminDevicesChar8364deviceIdIndexRoute =
  AccountIdAdminDevicesChar8364deviceIdIndexRouteImport.update({
    id: '/€deviceId/',
    path: '/€deviceId/',
    getParentRoute: () => AccountIdAdminDevicesRouteRoute,
  } as any)
const AccountIdAdminDevicesDeviceIdIndexRoute =
  AccountIdAdminDevicesDeviceIdIndexRouteImport.update({
    id: '/$deviceId/',
    path: '/$deviceId/',
    getParentRoute: () => AccountIdAdminDevicesRouteRoute,
  } as any)
const AccountIdUserUnitsUnitIdEditRoute =
  AccountIdUserUnitsUnitIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AccountIdUserUnitsUnitIdRouteRoute,
  } as any)
const AccountIdUserGatewaysGatewayIdEditRoute =
  AccountIdUserGatewaysGatewayIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AccountIdUserGatewaysGatewayIdRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioDashboardRoute =
  AccountIdUserEnergyxplorerPortfolioDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AccountIdUserEnergyxplorerPortfolioRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveDashboardRoute =
  AccountIdUserEnergyxplorerDeepdiveDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AccountIdUserEnergyxplorerDeepdiveRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveCreateRoute =
  AccountIdUserEnergyxplorerDeepdiveCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AccountIdUserEnergyxplorerDeepdiveRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerAlarmsAlarmIdRoute =
  AccountIdUserEnergyxplorerAlarmsAlarmIdRouteImport.update({
    id: '/$alarmId',
    path: '/$alarmId',
    getParentRoute: () => AccountIdUserEnergyxplorerAlarmsRouteRoute,
  } as any)
const AccountIdUserEforsyningIntegrationIntegrationIdEditRoute =
  AccountIdUserEforsyningIntegrationIntegrationIdEditRouteImport.update({
    id: '/$integrationId/edit',
    path: '/$integrationId/edit',
    getParentRoute: () => AccountIdUserEforsyningIntegrationRouteRoute,
  } as any)
const AccountIdUserAlarmsConfigurationAlarmConfigurationIdRoute =
  AccountIdUserAlarmsConfigurationAlarmConfigurationIdRouteImport.update({
    id: '/$alarmConfigurationId',
    path: '/$alarmConfigurationId',
    getParentRoute: () => AccountIdUserAlarmsConfigurationRouteRoute,
  } as any)
const AccountIdUserAlarmsAlarmGroupsCreateRoute =
  AccountIdUserAlarmsAlarmGroupsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AccountIdUserAlarmsAlarmGroupsRouteRoute,
  } as any)
const AccountIdUserAlarmsAlarmGroupsGroupIdRoute =
  AccountIdUserAlarmsAlarmGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AccountIdUserAlarmsAlarmGroupsRouteRoute,
  } as any)
const AccountIdUserAccountServicesSchedulerRoute =
  AccountIdUserAccountServicesSchedulerRouteImport.update({
    id: '/scheduler',
    path: '/scheduler',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesPredictiveHeatControlRoute =
  AccountIdUserAccountServicesPredictiveHeatControlRouteImport.update({
    id: '/predictive-heat-control',
    path: '/predictive-heat-control',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesPowerbiRoute =
  AccountIdUserAccountServicesPowerbiRouteImport.update({
    id: '/powerbi',
    path: '/powerbi',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesPortfolioAnalysisRoute =
  AccountIdUserAccountServicesPortfolioAnalysisRouteImport.update({
    id: '/portfolio-analysis',
    path: '/portfolio-analysis',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesJyskenergiesgRoute =
  AccountIdUserAccountServicesJyskenergiesgRouteImport.update({
    id: '/jyskenergiesg',
    path: '/jyskenergiesg',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesEnergyxplorerAnalyticsRoute =
  AccountIdUserAccountServicesEnergyxplorerAnalyticsRouteImport.update({
    id: '/energyxplorer-analytics',
    path: '/energyxplorer-analytics',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesEnergyxplorerRoute =
  AccountIdUserAccountServicesEnergyxplorerRouteImport.update({
    id: '/energyxplorer',
    path: '/energyxplorer',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesDevicesRoute =
  AccountIdUserAccountServicesDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesDatahubIntegrationRoute =
  AccountIdUserAccountServicesDatahubIntegrationRouteImport.update({
    id: '/datahub-integration',
    path: '/datahub-integration',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesDashboardWaterBasicRoute =
  AccountIdUserAccountServicesDashboardWaterBasicRouteImport.update({
    id: '/dashboard-water-basic',
    path: '/dashboard-water-basic',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesDashboardPowerBasicRoute =
  AccountIdUserAccountServicesDashboardPowerBasicRouteImport.update({
    id: '/dashboard-power-basic',
    path: '/dashboard-power-basic',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesDashboardHeatBasicRoute =
  AccountIdUserAccountServicesDashboardHeatBasicRouteImport.update({
    id: '/dashboard-heat-basic',
    path: '/dashboard-heat-basic',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesCompressedAirRoute =
  AccountIdUserAccountServicesCompressedAirRouteImport.update({
    id: '/compressed-air',
    path: '/compressed-air',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesBasisRoute =
  AccountIdUserAccountServicesBasisRouteImport.update({
    id: '/basis',
    path: '/basis',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesBasicDashboardsRoute =
  AccountIdUserAccountServicesBasicDashboardsRouteImport.update({
    id: '/basic-dashboards',
    path: '/basic-dashboards',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesAnalyticsRoute =
  AccountIdUserAccountServicesAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdUserAccountServicesAlarmsRoute =
  AccountIdUserAccountServicesAlarmsRouteImport.update({
    id: '/alarms',
    path: '/alarms',
    getParentRoute: () => AccountIdUserAccountServicesRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdSchedulerRoute =
  AccountIdAdminServiceManagerManagedAccountIdSchedulerRouteImport.update({
    id: '/scheduler',
    path: '/scheduler',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRoute =
  AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRouteImport.update(
    {
      id: '/predictive-heat-control',
      path: '/predictive-heat-control',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdPowerbiRoute =
  AccountIdAdminServiceManagerManagedAccountIdPowerbiRouteImport.update({
    id: '/powerbi',
    path: '/powerbi',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRoute =
  AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRouteImport.update(
    {
      id: '/portfolio-analysis',
      path: '/portfolio-analysis',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRoute =
  AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRouteImport.update({
    id: '/jyskenergiesg',
    path: '/jyskenergiesg',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRoute =
  AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRouteImport.update(
    {
      id: '/energyxplorer-analytics',
      path: '/energyxplorer-analytics',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRoute =
  AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRouteImport.update({
    id: '/energyxplorer',
    path: '/energyxplorer',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRoute =
  AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRouteImport.update(
    {
      id: '/eforsyning-integration',
      path: '/eforsyning-integration',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdDevicesRoute =
  AccountIdAdminServiceManagerManagedAccountIdDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRoute =
  AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRouteImport.update(
    {
      id: '/datahub-integration',
      path: '/datahub-integration',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRoute =
  AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRouteImport.update(
    {
      id: '/dashboard-water-basic',
      path: '/dashboard-water-basic',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRoute =
  AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRouteImport.update(
    {
      id: '/dashboard-power-basic',
      path: '/dashboard-power-basic',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRoute =
  AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRouteImport.update(
    {
      id: '/dashboard-heat-basic',
      path: '/dashboard-heat-basic',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdCompressedAirRoute =
  AccountIdAdminServiceManagerManagedAccountIdCompressedAirRouteImport.update({
    id: '/compressed-air',
    path: '/compressed-air',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdBasisRoute =
  AccountIdAdminServiceManagerManagedAccountIdBasisRouteImport.update({
    id: '/basis',
    path: '/basis',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRoute =
  AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRouteImport.update(
    {
      id: '/basic-dashboards',
      path: '/basic-dashboards',
      getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
    } as any,
  )
const AccountIdAdminServiceManagerManagedAccountIdAnalyticsRoute =
  AccountIdAdminServiceManagerManagedAccountIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminServiceManagerManagedAccountIdAlarmsRoute =
  AccountIdAdminServiceManagerManagedAccountIdAlarmsRouteImport.update({
    id: '/alarms',
    path: '/alarms',
    getParentRoute: () => AccountIdAdminServiceManagerManagedAccountIdRoute,
  } as any)
const AccountIdAdminOperationsDeepDiveGroupIdRoute =
  AccountIdAdminOperationsDeepDiveGroupIdRouteImport.update({
    id: '/deep-dive/$groupId',
    path: '/deep-dive/$groupId',
    getParentRoute: () => AccountIdAdminOperationsRouteRoute,
  } as any)
const AccountIdAdminDevicesDeviceIdEditRoute =
  AccountIdAdminDevicesDeviceIdEditRouteImport.update({
    id: '/$deviceId/edit',
    path: '/$deviceId/edit',
    getParentRoute: () => AccountIdAdminDevicesRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteImport.update({
    id: '/$analysisType',
    path: '/$analysisType',
    getParentRoute: () => AccountIdUserEnergyxplorerPortfolioRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteImport.update({
    id: '/$energyGroupId',
    path: '/$energyGroupId',
    getParentRoute: () => AccountIdUserEnergyxplorerDeepdiveRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute =
  AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteImport.update({
    id: '/advanced',
    path: '/advanced',
    getParentRoute: () => AccountIdUserEnergyxplorerAlarmsRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioOverviewIndexRoute =
  AccountIdUserEnergyxplorerPortfolioOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => AccountIdUserEnergyxplorerPortfolioRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerAlarmsAdvancedIndexRoute =
  AccountIdUserEnergyxplorerAlarmsAdvancedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute,
  } as any)
const AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRoute =
  AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRouteImport.update(
    {
      id: '/subscriptions/',
      path: '/subscriptions/',
      getParentRoute: () =>
        AccountIdAdminOperationsPredictiveHeatControlRouteRoute,
    } as any,
  )
const AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRoute =
  AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () =>
      AccountIdAdminOperationsPredictiveHeatControlRouteRoute,
  } as any)
const AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRoute =
  AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRouteImport.update(
    {
      id: '/buildings/',
      path: '/buildings/',
      getParentRoute: () =>
        AccountIdAdminOperationsPredictiveHeatControlRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioSiteCreateRoute =
  AccountIdUserEnergyxplorerPortfolioSiteCreateRouteImport.update({
    id: '/site/create',
    path: '/site/create',
    getParentRoute: () => AccountIdUserEnergyxplorerPortfolioRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioOverviewStandardRoute =
  AccountIdUserEnergyxplorerPortfolioOverviewStandardRouteImport.update({
    id: '/overview/standard',
    path: '/overview/standard',
    getParentRoute: () => AccountIdUserEnergyxplorerPortfolioRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioOverviewBuildingRoute =
  AccountIdUserEnergyxplorerPortfolioOverviewBuildingRouteImport.update({
    id: '/overview/building',
    path: '/overview/building',
    getParentRoute: () => AccountIdUserEnergyxplorerPortfolioRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRouteImport.update({
    id: '/pivot',
    path: '/pivot',
    getParentRoute: () =>
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRouteImport.update(
    {
      id: '/load-profile-analysis',
      path: '/load-profile-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRouteImport.update(
    {
      id: '/hour-analysis',
      path: '/hour-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRouteImport.update({
    id: '/esg',
    path: '/esg',
    getParentRoute: () =>
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRouteImport.update(
    {
      id: '/energy-breakdown-table',
      path: '/energy-breakdown-table',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRouteImport.update(
    {
      id: '/energy-breakdown',
      path: '/energy-breakdown',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRouteImport.update(
    {
      id: '/energy-analysis',
      path: '/energy-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRouteImport.update(
    {
      id: '/duration-analysis',
      path: '/duration-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRouteImport.update(
    {
      id: '/create-first-node',
      path: '/create-first-node',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRouteImport.update(
    {
      id: '/consumption-overview',
      path: '/consumption-overview',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRouteImport.update(
    {
      id: '/comparison-analysis',
      path: '/comparison-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRouteImport.update(
    {
      id: '/child-analysis',
      path: '/child-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerAlarmsAdvancedCreateRoute =
  AccountIdUserEnergyxplorerAlarmsAdvancedCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute,
  } as any)
const AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRoute =
  AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute,
  } as any)
const AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRoute =
  AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRouteImport.update({
    id: '/create/$alarmTypeId',
    path: '/create/$alarmTypeId',
    getParentRoute: () => AccountIdUserAlarmsConfigurationRouteRoute,
  } as any)
const AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRoute =
  AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRouteImport.update(
    {
      id: '/groups/$groupKey',
      path: '/groups/$groupKey',
      getParentRoute: () =>
        AccountIdAdminOperationsPredictiveHeatControlRouteRoute,
    } as any,
  )
const AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRoute =
  AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRouteImport.update(
    {
      id: '/buildings/$buildingName',
      path: '/buildings/$buildingName',
      getParentRoute: () =>
        AccountIdAdminOperationsPredictiveHeatControlRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteImport.update(
    {
      id: '/$energyGroupId',
      path: '/$energyGroupId',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteImport.update(
    {
      id: '/energy-initiatives',
      path: '/energy-initiatives',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRouteImport.update(
    {
      id: '/analysis/',
      path: '/analysis/',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute,
    } as any,
  )
const AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRoute =
  AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRouteImport.update(
    {
      id: '/subscriptions/$subscriptionName/',
      path: '/subscriptions/$subscriptionName/',
      getParentRoute: () =>
        AccountIdAdminOperationsPredictiveHeatControlRouteRoute,
    } as any,
  )
const AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRoute =
  AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRouteImport.update(
    {
      id: '/portfolio-analysis/utility-providers/water/',
      path: '/portfolio-analysis/utility-providers/water/',
      getParentRoute: () => AccountIdAdminOperationsRouteRoute,
    } as any,
  )
const AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRoute =
  AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRouteImport.update(
    {
      id: '/portfolio-analysis/utility-providers/heat/',
      path: '/portfolio-analysis/utility-providers/heat/',
      getParentRoute: () => AccountIdAdminOperationsRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRouteImport.update(
    {
      id: '/analysis/$preset',
      path: '/analysis/$preset',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRouteImport.update(
    {
      id: '/load-profile-analysis',
      path: '/load-profile-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRouteImport.update(
    {
      id: '/hour-analysis',
      path: '/hour-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRouteImport.update(
    {
      id: '/esg',
      path: '/esg',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRouteImport.update(
    {
      id: '/energy-breakdown-table',
      path: '/energy-breakdown-table',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRouteImport.update(
    {
      id: '/energy-breakdown',
      path: '/energy-breakdown',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRouteImport.update(
    {
      id: '/energy-analysis',
      path: '/energy-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRouteImport.update(
    {
      id: '/duration-analysis',
      path: '/duration-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRouteImport.update(
    {
      id: '/comparison-analysis',
      path: '/comparison-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRoute =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRouteImport.update(
    {
      id: '/child-analysis',
      path: '/child-analysis',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute,
    } as any,
  )
const AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRoute =
  AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRouteImport.update(
    {
      id: '/portfolio-analysis/utility-providers/water/$providerId',
      path: '/portfolio-analysis/utility-providers/water/$providerId',
      getParentRoute: () => AccountIdAdminOperationsRouteRoute,
    } as any,
  )
const AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRoute =
  AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRouteImport.update(
    {
      id: '/portfolio-analysis/utility-providers/heat/$providerId',
      path: '/portfolio-analysis/utility-providers/heat/$providerId',
      getParentRoute: () => AccountIdAdminOperationsRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRouteImport.update(
    {
      id: '/$initiativeId/',
      path: '/$initiativeId/',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute,
    } as any,
  )
const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRoute =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRouteImport.update(
    {
      id: '/$initiativeId/edit',
      path: '/$initiativeId/edit',
      getParentRoute: () =>
        AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$accountId': typeof AccountIdUserRouteRouteWithChildren
  '/$accountId/errorboundarydevtest': typeof AccountIdErrorboundarydevtestRoute
  '/$accountId/support': typeof AccountIdSupportRoute
  '/account/create': typeof AccountCreateRoute
  '/$accountId/': typeof AccountIdIndexRoute
  '/$accountId/devices': typeof AccountIdAdminDevicesRouteRouteWithChildren
  '/$accountId/operations': typeof AccountIdAdminOperationsRouteRouteWithChildren
  '/$accountId/service-manager': typeof AccountIdAdminServiceManagerRouteRouteWithChildren
  '/$accountId/account': typeof AccountIdUserAccountRouteRouteWithChildren
  '/$accountId/alarms': typeof AccountIdUserAlarmsRouteRouteWithChildren
  '/$accountId/dalux-integration': typeof AccountIdUserDaluxIntegrationRouteRouteWithChildren
  '/$accountId/dashboards': typeof AccountIdUserDashboardsRouteRouteWithChildren
  '/$accountId/datahub-integration': typeof AccountIdUserDatahubIntegrationRouteRouteWithChildren
  '/$accountId/eforsyning-integration': typeof AccountIdUserEforsyningIntegrationRouteRouteWithChildren
  '/$accountId/energyxplorer': typeof AccountIdUserEnergyxplorerRouteRouteWithChildren
  '/$accountId/gateways': typeof AccountIdUserGatewaysRouteRouteWithChildren
  '/$accountId/predictive-heat-control': typeof AccountIdUserPredictiveHeatControlRouteRouteWithChildren
  '/$accountId/sensors': typeof AccountIdUserSensorsRouteRouteWithChildren
  '/$accountId/units': typeof AccountIdUserUnitsRouteRouteWithChildren
  '/$accountId/missing-service': typeof AccountIdUserMissingServiceRoute
  '/$accountId/view-data': typeof AccountIdUserViewDataRoute
  '/$accountId/operations/predictive-heat-control': typeof AccountIdAdminOperationsPredictiveHeatControlRouteRouteWithChildren
  '/$accountId/alarms/alarm-groups': typeof AccountIdUserAlarmsAlarmGroupsRouteRouteWithChildren
  '/$accountId/alarms/configuration': typeof AccountIdUserAlarmsConfigurationRouteRouteWithChildren
  '/$accountId/energyxplorer/alarms': typeof AccountIdUserEnergyxplorerAlarmsRouteRouteWithChildren
  '/$accountId/energyxplorer/deepdive': typeof AccountIdUserEnergyxplorerDeepdiveRouteRouteWithChildren
  '/$accountId/energyxplorer/portfolio': typeof AccountIdUserEnergyxplorerPortfolioRouteRouteWithChildren
  '/$accountId/gateways/$gatewayId': typeof AccountIdUserGatewaysGatewayIdRouteRouteWithChildren
  '/$accountId/units/$unitId': typeof AccountIdUserUnitsUnitIdRouteRouteWithChildren
  '/$accountId/devices/register': typeof AccountIdAdminDevicesRegisterRoute
  '/$accountId/service-manager/$managedAccountId': typeof AccountIdAdminServiceManagerManagedAccountIdRouteWithChildren
  '/$accountId/account/profile': typeof AccountIdUserAccountProfileRoute
  '/$accountId/account/services': typeof AccountIdUserAccountServicesRouteWithChildren
  '/$accountId/account/users': typeof AccountIdUserAccountUsersRoute
  '/$accountId/alarms/$alarmId': typeof AccountIdUserAlarmsAlarmIdRoute
  '/$accountId/dashboards/compressed-air': typeof AccountIdUserDashboardsCompressedAirRoute
  '/$accountId/dashboards/heat-basic': typeof AccountIdUserDashboardsHeatBasicRoute
  '/$accountId/dashboards/power-basic': typeof AccountIdUserDashboardsPowerBasicRoute
  '/$accountId/dashboards/water-basic': typeof AccountIdUserDashboardsWaterBasicRoute
  '/$accountId/datahub-integration/$cvrNumber': typeof AccountIdUserDatahubIntegrationCvrNumberRoute
  '/$accountId/eforsyning-integration/create': typeof AccountIdUserEforsyningIntegrationCreateRoute
  '/$accountId/energyxplorer/dashboard': typeof AccountIdUserEnergyxplorerDashboardRoute
  '/$accountId/gateways/create': typeof AccountIdUserGatewaysCreateRoute
  '/$accountId/powerbi/$reportId': typeof AccountIdUserPowerbiReportIdRoute
  '/$accountId/predictive-heat-control/$buildingName': typeof AccountIdUserPredictiveHeatControlBuildingNameRoute
  '/$accountId/predictive-heat-control/calendar': typeof AccountIdUserPredictiveHeatControlCalendarRoute
  '/$accountId/sensors/$sensorId': typeof AccountIdUserSensorsSensorIdRoute
  '/$accountId/units/create': typeof AccountIdUserUnitsCreateRoute
  '/$accountId/devices/': typeof AccountIdAdminDevicesIndexRoute
  '/$accountId/operations/': typeof AccountIdAdminOperationsIndexRoute
  '/$accountId/service-manager/': typeof AccountIdAdminServiceManagerIndexRoute
  '/$accountId/alarms/': typeof AccountIdUserAlarmsIndexRoute
  '/$accountId/dalux-integration/': typeof AccountIdUserDaluxIntegrationIndexRoute
  '/$accountId/dashboards/': typeof AccountIdUserDashboardsIndexRoute
  '/$accountId/datahub-integration/': typeof AccountIdUserDatahubIntegrationIndexRoute
  '/$accountId/eforsyning-integration/': typeof AccountIdUserEforsyningIntegrationIndexRoute
  '/$accountId/energyxplorer/': typeof AccountIdUserEnergyxplorerIndexRoute
  '/$accountId/export-data/': typeof AccountIdUserExportDataIndexRoute
  '/$accountId/gateways/': typeof AccountIdUserGatewaysIndexRoute
  '/$accountId/powerbi/': typeof AccountIdUserPowerbiIndexRoute
  '/$accountId/predictive-heat-control/': typeof AccountIdUserPredictiveHeatControlIndexRoute
  '/$accountId/sensors/': typeof AccountIdUserSensorsIndexRoute
  '/$accountId/units/': typeof AccountIdUserUnitsIndexRoute
  '/$accountId/weekschedule-manager/': typeof AccountIdUserWeekscheduleManagerIndexRoute
  '/$accountId/energyxplorer/alarms/advanced': typeof AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteWithChildren
  '/$accountId/energyxplorer/deepdive/$energyGroupId': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteWithChildren
  '/$accountId/energyxplorer/portfolio/$analysisType': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteWithChildren
  '/$accountId/devices/$deviceId/edit': typeof AccountIdAdminDevicesDeviceIdEditRoute
  '/$accountId/operations/deep-dive/$groupId': typeof AccountIdAdminOperationsDeepDiveGroupIdRoute
  '/$accountId/service-manager/$managedAccountId/alarms': typeof AccountIdAdminServiceManagerManagedAccountIdAlarmsRoute
  '/$accountId/service-manager/$managedAccountId/analytics': typeof AccountIdAdminServiceManagerManagedAccountIdAnalyticsRoute
  '/$accountId/service-manager/$managedAccountId/basic-dashboards': typeof AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRoute
  '/$accountId/service-manager/$managedAccountId/basis': typeof AccountIdAdminServiceManagerManagedAccountIdBasisRoute
  '/$accountId/service-manager/$managedAccountId/compressed-air': typeof AccountIdAdminServiceManagerManagedAccountIdCompressedAirRoute
  '/$accountId/service-manager/$managedAccountId/dashboard-heat-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRoute
  '/$accountId/service-manager/$managedAccountId/dashboard-power-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRoute
  '/$accountId/service-manager/$managedAccountId/dashboard-water-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRoute
  '/$accountId/service-manager/$managedAccountId/datahub-integration': typeof AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRoute
  '/$accountId/service-manager/$managedAccountId/devices': typeof AccountIdAdminServiceManagerManagedAccountIdDevicesRoute
  '/$accountId/service-manager/$managedAccountId/eforsyning-integration': typeof AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRoute
  '/$accountId/service-manager/$managedAccountId/energyxplorer': typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRoute
  '/$accountId/service-manager/$managedAccountId/energyxplorer-analytics': typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRoute
  '/$accountId/service-manager/$managedAccountId/jyskenergiesg': typeof AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRoute
  '/$accountId/service-manager/$managedAccountId/portfolio-analysis': typeof AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRoute
  '/$accountId/service-manager/$managedAccountId/powerbi': typeof AccountIdAdminServiceManagerManagedAccountIdPowerbiRoute
  '/$accountId/service-manager/$managedAccountId/predictive-heat-control': typeof AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRoute
  '/$accountId/service-manager/$managedAccountId/scheduler': typeof AccountIdAdminServiceManagerManagedAccountIdSchedulerRoute
  '/$accountId/account/services/alarms': typeof AccountIdUserAccountServicesAlarmsRoute
  '/$accountId/account/services/analytics': typeof AccountIdUserAccountServicesAnalyticsRoute
  '/$accountId/account/services/basic-dashboards': typeof AccountIdUserAccountServicesBasicDashboardsRoute
  '/$accountId/account/services/basis': typeof AccountIdUserAccountServicesBasisRoute
  '/$accountId/account/services/compressed-air': typeof AccountIdUserAccountServicesCompressedAirRoute
  '/$accountId/account/services/dashboard-heat-basic': typeof AccountIdUserAccountServicesDashboardHeatBasicRoute
  '/$accountId/account/services/dashboard-power-basic': typeof AccountIdUserAccountServicesDashboardPowerBasicRoute
  '/$accountId/account/services/dashboard-water-basic': typeof AccountIdUserAccountServicesDashboardWaterBasicRoute
  '/$accountId/account/services/datahub-integration': typeof AccountIdUserAccountServicesDatahubIntegrationRoute
  '/$accountId/account/services/devices': typeof AccountIdUserAccountServicesDevicesRoute
  '/$accountId/account/services/energyxplorer': typeof AccountIdUserAccountServicesEnergyxplorerRoute
  '/$accountId/account/services/energyxplorer-analytics': typeof AccountIdUserAccountServicesEnergyxplorerAnalyticsRoute
  '/$accountId/account/services/jyskenergiesg': typeof AccountIdUserAccountServicesJyskenergiesgRoute
  '/$accountId/account/services/portfolio-analysis': typeof AccountIdUserAccountServicesPortfolioAnalysisRoute
  '/$accountId/account/services/powerbi': typeof AccountIdUserAccountServicesPowerbiRoute
  '/$accountId/account/services/predictive-heat-control': typeof AccountIdUserAccountServicesPredictiveHeatControlRoute
  '/$accountId/account/services/scheduler': typeof AccountIdUserAccountServicesSchedulerRoute
  '/$accountId/alarms/alarm-groups/$groupId': typeof AccountIdUserAlarmsAlarmGroupsGroupIdRoute
  '/$accountId/alarms/alarm-groups/create': typeof AccountIdUserAlarmsAlarmGroupsCreateRoute
  '/$accountId/alarms/configuration/$alarmConfigurationId': typeof AccountIdUserAlarmsConfigurationAlarmConfigurationIdRoute
  '/$accountId/eforsyning-integration/$integrationId/edit': typeof AccountIdUserEforsyningIntegrationIntegrationIdEditRoute
  '/$accountId/energyxplorer/alarms/$alarmId': typeof AccountIdUserEnergyxplorerAlarmsAlarmIdRoute
  '/$accountId/energyxplorer/deepdive/create': typeof AccountIdUserEnergyxplorerDeepdiveCreateRoute
  '/$accountId/energyxplorer/deepdive/dashboard': typeof AccountIdUserEnergyxplorerDeepdiveDashboardRoute
  '/$accountId/energyxplorer/portfolio/dashboard': typeof AccountIdUserEnergyxplorerPortfolioDashboardRoute
  '/$accountId/gateways/$gatewayId/edit': typeof AccountIdUserGatewaysGatewayIdEditRoute
  '/$accountId/units/$unitId/edit': typeof AccountIdUserUnitsUnitIdEditRoute
  '/$accountId/devices/$deviceId/': typeof AccountIdAdminDevicesDeviceIdIndexRoute
  '/$accountId/devices/€deviceId/': typeof AccountIdAdminDevicesChar8364deviceIdIndexRoute
  '/$accountId/operations/deep-dive/': typeof AccountIdAdminOperationsDeepDiveIndexRoute
  '/$accountId/operations/portfolio-analysis/': typeof AccountIdAdminOperationsPortfolioAnalysisIndexRoute
  '/$accountId/operations/predictive-heat-control/': typeof AccountIdAdminOperationsPredictiveHeatControlIndexRoute
  '/$accountId/operations/quality-of-service/': typeof AccountIdAdminOperationsQualityOfServiceIndexRoute
  '/$accountId/service-manager/$managedAccountId/': typeof AccountIdAdminServiceManagerManagedAccountIdIndexRoute
  '/$accountId/account/services/': typeof AccountIdUserAccountServicesIndexRoute
  '/$accountId/alarms/alarm-groups/': typeof AccountIdUserAlarmsAlarmGroupsIndexRoute
  '/$accountId/alarms/configuration/': typeof AccountIdUserAlarmsConfigurationIndexRoute
  '/$accountId/eforsyning-integration/$integrationId/': typeof AccountIdUserEforsyningIntegrationIntegrationIdIndexRoute
  '/$accountId/energyxplorer/deepdive/': typeof AccountIdUserEnergyxplorerDeepdiveIndexRoute
  '/$accountId/energyxplorer/portfolio/': typeof AccountIdUserEnergyxplorerPortfolioIndexRoute
  '/$accountId/gateways/$gatewayId/': typeof AccountIdUserGatewaysGatewayIdIndexRoute
  '/$accountId/units/$unitId/': typeof AccountIdUserUnitsUnitIdIndexRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteWithChildren
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteWithChildren
  '/$accountId/operations/predictive-heat-control/buildings/$buildingName': typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRoute
  '/$accountId/operations/predictive-heat-control/groups/$groupKey': typeof AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRoute
  '/$accountId/alarms/configuration/create/$alarmTypeId': typeof AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRoute
  '/$accountId/energyxplorer/alarms/advanced/$groupId': typeof AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRoute
  '/$accountId/energyxplorer/alarms/advanced/create': typeof AccountIdUserEnergyxplorerAlarmsAdvancedCreateRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/child-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/comparison-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/consumption-overview': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/create-first-node': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/duration-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/edit': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/esg': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/hour-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/load-profile-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/pivot': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRoute
  '/$accountId/energyxplorer/portfolio/overview/building': typeof AccountIdUserEnergyxplorerPortfolioOverviewBuildingRoute
  '/$accountId/energyxplorer/portfolio/overview/standard': typeof AccountIdUserEnergyxplorerPortfolioOverviewStandardRoute
  '/$accountId/energyxplorer/portfolio/site/create': typeof AccountIdUserEnergyxplorerPortfolioSiteCreateRoute
  '/$accountId/operations/predictive-heat-control/buildings/': typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRoute
  '/$accountId/operations/predictive-heat-control/groups/': typeof AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRoute
  '/$accountId/operations/predictive-heat-control/subscriptions/': typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRoute
  '/$accountId/energyxplorer/alarms/advanced/': typeof AccountIdUserEnergyxplorerAlarmsAdvancedIndexRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRoute
  '/$accountId/energyxplorer/portfolio/overview/': typeof AccountIdUserEnergyxplorerPortfolioOverviewIndexRoute
  '/$accountId/operations/portfolio-analysis/utility-providers/heat/$providerId': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRoute
  '/$accountId/operations/portfolio-analysis/utility-providers/water/$providerId': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/esg': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/analysis/$preset': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRoute
  '/$accountId/operations/portfolio-analysis/utility-providers/heat/': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRoute
  '/$accountId/operations/portfolio-analysis/utility-providers/water/': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRoute
  '/$accountId/operations/predictive-heat-control/subscriptions/$subscriptionName/': typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/analysis/': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$accountId': typeof AccountIdIndexRoute
  '/$accountId/errorboundarydevtest': typeof AccountIdErrorboundarydevtestRoute
  '/$accountId/support': typeof AccountIdSupportRoute
  '/account/create': typeof AccountCreateRoute
  '/$accountId/account': typeof AccountIdUserAccountRouteRouteWithChildren
  '/$accountId/missing-service': typeof AccountIdUserMissingServiceRoute
  '/$accountId/view-data': typeof AccountIdUserViewDataRoute
  '/$accountId/energyxplorer/alarms': typeof AccountIdUserEnergyxplorerAlarmsRouteRouteWithChildren
  '/$accountId/devices/register': typeof AccountIdAdminDevicesRegisterRoute
  '/$accountId/account/profile': typeof AccountIdUserAccountProfileRoute
  '/$accountId/account/users': typeof AccountIdUserAccountUsersRoute
  '/$accountId/alarms/$alarmId': typeof AccountIdUserAlarmsAlarmIdRoute
  '/$accountId/dashboards/compressed-air': typeof AccountIdUserDashboardsCompressedAirRoute
  '/$accountId/dashboards/heat-basic': typeof AccountIdUserDashboardsHeatBasicRoute
  '/$accountId/dashboards/power-basic': typeof AccountIdUserDashboardsPowerBasicRoute
  '/$accountId/dashboards/water-basic': typeof AccountIdUserDashboardsWaterBasicRoute
  '/$accountId/datahub-integration/$cvrNumber': typeof AccountIdUserDatahubIntegrationCvrNumberRoute
  '/$accountId/eforsyning-integration/create': typeof AccountIdUserEforsyningIntegrationCreateRoute
  '/$accountId/energyxplorer/dashboard': typeof AccountIdUserEnergyxplorerDashboardRoute
  '/$accountId/gateways/create': typeof AccountIdUserGatewaysCreateRoute
  '/$accountId/powerbi/$reportId': typeof AccountIdUserPowerbiReportIdRoute
  '/$accountId/predictive-heat-control/$buildingName': typeof AccountIdUserPredictiveHeatControlBuildingNameRoute
  '/$accountId/predictive-heat-control/calendar': typeof AccountIdUserPredictiveHeatControlCalendarRoute
  '/$accountId/sensors/$sensorId': typeof AccountIdUserSensorsSensorIdRoute
  '/$accountId/units/create': typeof AccountIdUserUnitsCreateRoute
  '/$accountId/devices': typeof AccountIdAdminDevicesIndexRoute
  '/$accountId/operations': typeof AccountIdAdminOperationsIndexRoute
  '/$accountId/service-manager': typeof AccountIdAdminServiceManagerIndexRoute
  '/$accountId/alarms': typeof AccountIdUserAlarmsIndexRoute
  '/$accountId/dalux-integration': typeof AccountIdUserDaluxIntegrationIndexRoute
  '/$accountId/dashboards': typeof AccountIdUserDashboardsIndexRoute
  '/$accountId/datahub-integration': typeof AccountIdUserDatahubIntegrationIndexRoute
  '/$accountId/eforsyning-integration': typeof AccountIdUserEforsyningIntegrationIndexRoute
  '/$accountId/energyxplorer': typeof AccountIdUserEnergyxplorerIndexRoute
  '/$accountId/export-data': typeof AccountIdUserExportDataIndexRoute
  '/$accountId/gateways': typeof AccountIdUserGatewaysIndexRoute
  '/$accountId/powerbi': typeof AccountIdUserPowerbiIndexRoute
  '/$accountId/predictive-heat-control': typeof AccountIdUserPredictiveHeatControlIndexRoute
  '/$accountId/sensors': typeof AccountIdUserSensorsIndexRoute
  '/$accountId/units': typeof AccountIdUserUnitsIndexRoute
  '/$accountId/weekschedule-manager': typeof AccountIdUserWeekscheduleManagerIndexRoute
  '/$accountId/devices/$deviceId/edit': typeof AccountIdAdminDevicesDeviceIdEditRoute
  '/$accountId/operations/deep-dive/$groupId': typeof AccountIdAdminOperationsDeepDiveGroupIdRoute
  '/$accountId/service-manager/$managedAccountId/alarms': typeof AccountIdAdminServiceManagerManagedAccountIdAlarmsRoute
  '/$accountId/service-manager/$managedAccountId/analytics': typeof AccountIdAdminServiceManagerManagedAccountIdAnalyticsRoute
  '/$accountId/service-manager/$managedAccountId/basic-dashboards': typeof AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRoute
  '/$accountId/service-manager/$managedAccountId/basis': typeof AccountIdAdminServiceManagerManagedAccountIdBasisRoute
  '/$accountId/service-manager/$managedAccountId/compressed-air': typeof AccountIdAdminServiceManagerManagedAccountIdCompressedAirRoute
  '/$accountId/service-manager/$managedAccountId/dashboard-heat-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRoute
  '/$accountId/service-manager/$managedAccountId/dashboard-power-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRoute
  '/$accountId/service-manager/$managedAccountId/dashboard-water-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRoute
  '/$accountId/service-manager/$managedAccountId/datahub-integration': typeof AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRoute
  '/$accountId/service-manager/$managedAccountId/devices': typeof AccountIdAdminServiceManagerManagedAccountIdDevicesRoute
  '/$accountId/service-manager/$managedAccountId/eforsyning-integration': typeof AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRoute
  '/$accountId/service-manager/$managedAccountId/energyxplorer': typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRoute
  '/$accountId/service-manager/$managedAccountId/energyxplorer-analytics': typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRoute
  '/$accountId/service-manager/$managedAccountId/jyskenergiesg': typeof AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRoute
  '/$accountId/service-manager/$managedAccountId/portfolio-analysis': typeof AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRoute
  '/$accountId/service-manager/$managedAccountId/powerbi': typeof AccountIdAdminServiceManagerManagedAccountIdPowerbiRoute
  '/$accountId/service-manager/$managedAccountId/predictive-heat-control': typeof AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRoute
  '/$accountId/service-manager/$managedAccountId/scheduler': typeof AccountIdAdminServiceManagerManagedAccountIdSchedulerRoute
  '/$accountId/account/services/alarms': typeof AccountIdUserAccountServicesAlarmsRoute
  '/$accountId/account/services/analytics': typeof AccountIdUserAccountServicesAnalyticsRoute
  '/$accountId/account/services/basic-dashboards': typeof AccountIdUserAccountServicesBasicDashboardsRoute
  '/$accountId/account/services/basis': typeof AccountIdUserAccountServicesBasisRoute
  '/$accountId/account/services/compressed-air': typeof AccountIdUserAccountServicesCompressedAirRoute
  '/$accountId/account/services/dashboard-heat-basic': typeof AccountIdUserAccountServicesDashboardHeatBasicRoute
  '/$accountId/account/services/dashboard-power-basic': typeof AccountIdUserAccountServicesDashboardPowerBasicRoute
  '/$accountId/account/services/dashboard-water-basic': typeof AccountIdUserAccountServicesDashboardWaterBasicRoute
  '/$accountId/account/services/datahub-integration': typeof AccountIdUserAccountServicesDatahubIntegrationRoute
  '/$accountId/account/services/devices': typeof AccountIdUserAccountServicesDevicesRoute
  '/$accountId/account/services/energyxplorer': typeof AccountIdUserAccountServicesEnergyxplorerRoute
  '/$accountId/account/services/energyxplorer-analytics': typeof AccountIdUserAccountServicesEnergyxplorerAnalyticsRoute
  '/$accountId/account/services/jyskenergiesg': typeof AccountIdUserAccountServicesJyskenergiesgRoute
  '/$accountId/account/services/portfolio-analysis': typeof AccountIdUserAccountServicesPortfolioAnalysisRoute
  '/$accountId/account/services/powerbi': typeof AccountIdUserAccountServicesPowerbiRoute
  '/$accountId/account/services/predictive-heat-control': typeof AccountIdUserAccountServicesPredictiveHeatControlRoute
  '/$accountId/account/services/scheduler': typeof AccountIdUserAccountServicesSchedulerRoute
  '/$accountId/alarms/alarm-groups/$groupId': typeof AccountIdUserAlarmsAlarmGroupsGroupIdRoute
  '/$accountId/alarms/alarm-groups/create': typeof AccountIdUserAlarmsAlarmGroupsCreateRoute
  '/$accountId/alarms/configuration/$alarmConfigurationId': typeof AccountIdUserAlarmsConfigurationAlarmConfigurationIdRoute
  '/$accountId/eforsyning-integration/$integrationId/edit': typeof AccountIdUserEforsyningIntegrationIntegrationIdEditRoute
  '/$accountId/energyxplorer/alarms/$alarmId': typeof AccountIdUserEnergyxplorerAlarmsAlarmIdRoute
  '/$accountId/energyxplorer/deepdive/create': typeof AccountIdUserEnergyxplorerDeepdiveCreateRoute
  '/$accountId/energyxplorer/deepdive/dashboard': typeof AccountIdUserEnergyxplorerDeepdiveDashboardRoute
  '/$accountId/energyxplorer/portfolio/dashboard': typeof AccountIdUserEnergyxplorerPortfolioDashboardRoute
  '/$accountId/gateways/$gatewayId/edit': typeof AccountIdUserGatewaysGatewayIdEditRoute
  '/$accountId/units/$unitId/edit': typeof AccountIdUserUnitsUnitIdEditRoute
  '/$accountId/devices/$deviceId': typeof AccountIdAdminDevicesDeviceIdIndexRoute
  '/$accountId/devices/€deviceId': typeof AccountIdAdminDevicesChar8364deviceIdIndexRoute
  '/$accountId/operations/deep-dive': typeof AccountIdAdminOperationsDeepDiveIndexRoute
  '/$accountId/operations/portfolio-analysis': typeof AccountIdAdminOperationsPortfolioAnalysisIndexRoute
  '/$accountId/operations/predictive-heat-control': typeof AccountIdAdminOperationsPredictiveHeatControlIndexRoute
  '/$accountId/operations/quality-of-service': typeof AccountIdAdminOperationsQualityOfServiceIndexRoute
  '/$accountId/service-manager/$managedAccountId': typeof AccountIdAdminServiceManagerManagedAccountIdIndexRoute
  '/$accountId/account/services': typeof AccountIdUserAccountServicesIndexRoute
  '/$accountId/alarms/alarm-groups': typeof AccountIdUserAlarmsAlarmGroupsIndexRoute
  '/$accountId/alarms/configuration': typeof AccountIdUserAlarmsConfigurationIndexRoute
  '/$accountId/eforsyning-integration/$integrationId': typeof AccountIdUserEforsyningIntegrationIntegrationIdIndexRoute
  '/$accountId/energyxplorer/deepdive': typeof AccountIdUserEnergyxplorerDeepdiveIndexRoute
  '/$accountId/energyxplorer/portfolio': typeof AccountIdUserEnergyxplorerPortfolioIndexRoute
  '/$accountId/gateways/$gatewayId': typeof AccountIdUserGatewaysGatewayIdIndexRoute
  '/$accountId/units/$unitId': typeof AccountIdUserUnitsUnitIdIndexRoute
  '/$accountId/operations/predictive-heat-control/buildings/$buildingName': typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRoute
  '/$accountId/operations/predictive-heat-control/groups/$groupKey': typeof AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRoute
  '/$accountId/alarms/configuration/create/$alarmTypeId': typeof AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRoute
  '/$accountId/energyxplorer/alarms/advanced/$groupId': typeof AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRoute
  '/$accountId/energyxplorer/alarms/advanced/create': typeof AccountIdUserEnergyxplorerAlarmsAdvancedCreateRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/child-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/comparison-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/consumption-overview': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/create-first-node': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/duration-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/edit': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/esg': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/hour-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/load-profile-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/pivot': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRoute
  '/$accountId/energyxplorer/portfolio/overview/building': typeof AccountIdUserEnergyxplorerPortfolioOverviewBuildingRoute
  '/$accountId/energyxplorer/portfolio/overview/standard': typeof AccountIdUserEnergyxplorerPortfolioOverviewStandardRoute
  '/$accountId/energyxplorer/portfolio/site/create': typeof AccountIdUserEnergyxplorerPortfolioSiteCreateRoute
  '/$accountId/operations/predictive-heat-control/buildings': typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRoute
  '/$accountId/operations/predictive-heat-control/groups': typeof AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRoute
  '/$accountId/operations/predictive-heat-control/subscriptions': typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRoute
  '/$accountId/energyxplorer/alarms/advanced': typeof AccountIdUserEnergyxplorerAlarmsAdvancedIndexRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRoute
  '/$accountId/energyxplorer/portfolio/$analysisType': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRoute
  '/$accountId/energyxplorer/portfolio/overview': typeof AccountIdUserEnergyxplorerPortfolioOverviewIndexRoute
  '/$accountId/operations/portfolio-analysis/utility-providers/heat/$providerId': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRoute
  '/$accountId/operations/portfolio-analysis/utility-providers/water/$providerId': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/esg': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/analysis/$preset': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRoute
  '/$accountId/operations/portfolio-analysis/utility-providers/heat': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRoute
  '/$accountId/operations/portfolio-analysis/utility-providers/water': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRoute
  '/$accountId/operations/predictive-heat-control/subscriptions/$subscriptionName': typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRoute
  '/$accountId/energyxplorer/portfolio/$analysisType/analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRoute
  '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$accountId': typeof AccountIdRouteRouteWithChildren
  '/$accountId/_admin': typeof AccountIdAdminRouteRouteWithChildren
  '/$accountId/_user': typeof AccountIdUserRouteRouteWithChildren
  '/$accountId/errorboundarydevtest': typeof AccountIdErrorboundarydevtestRoute
  '/$accountId/support': typeof AccountIdSupportRoute
  '/account/create': typeof AccountCreateRoute
  '/$accountId/': typeof AccountIdIndexRoute
  '/$accountId/_admin/devices': typeof AccountIdAdminDevicesRouteRouteWithChildren
  '/$accountId/_admin/operations': typeof AccountIdAdminOperationsRouteRouteWithChildren
  '/$accountId/_admin/service-manager': typeof AccountIdAdminServiceManagerRouteRouteWithChildren
  '/$accountId/_user/account': typeof AccountIdUserAccountRouteRouteWithChildren
  '/$accountId/_user/alarms': typeof AccountIdUserAlarmsRouteRouteWithChildren
  '/$accountId/_user/dalux-integration': typeof AccountIdUserDaluxIntegrationRouteRouteWithChildren
  '/$accountId/_user/dashboards': typeof AccountIdUserDashboardsRouteRouteWithChildren
  '/$accountId/_user/datahub-integration': typeof AccountIdUserDatahubIntegrationRouteRouteWithChildren
  '/$accountId/_user/eforsyning-integration': typeof AccountIdUserEforsyningIntegrationRouteRouteWithChildren
  '/$accountId/_user/energyxplorer': typeof AccountIdUserEnergyxplorerRouteRouteWithChildren
  '/$accountId/_user/gateways': typeof AccountIdUserGatewaysRouteRouteWithChildren
  '/$accountId/_user/predictive-heat-control': typeof AccountIdUserPredictiveHeatControlRouteRouteWithChildren
  '/$accountId/_user/sensors': typeof AccountIdUserSensorsRouteRouteWithChildren
  '/$accountId/_user/units': typeof AccountIdUserUnitsRouteRouteWithChildren
  '/$accountId/_user/missing-service': typeof AccountIdUserMissingServiceRoute
  '/$accountId/_user/view-data': typeof AccountIdUserViewDataRoute
  '/$accountId/_admin/operations/predictive-heat-control': typeof AccountIdAdminOperationsPredictiveHeatControlRouteRouteWithChildren
  '/$accountId/_user/alarms/alarm-groups': typeof AccountIdUserAlarmsAlarmGroupsRouteRouteWithChildren
  '/$accountId/_user/alarms/configuration': typeof AccountIdUserAlarmsConfigurationRouteRouteWithChildren
  '/$accountId/_user/energyxplorer/alarms': typeof AccountIdUserEnergyxplorerAlarmsRouteRouteWithChildren
  '/$accountId/_user/energyxplorer/deepdive': typeof AccountIdUserEnergyxplorerDeepdiveRouteRouteWithChildren
  '/$accountId/_user/energyxplorer/portfolio': typeof AccountIdUserEnergyxplorerPortfolioRouteRouteWithChildren
  '/$accountId/_user/gateways/$gatewayId': typeof AccountIdUserGatewaysGatewayIdRouteRouteWithChildren
  '/$accountId/_user/units/$unitId': typeof AccountIdUserUnitsUnitIdRouteRouteWithChildren
  '/$accountId/_admin/devices/register': typeof AccountIdAdminDevicesRegisterRoute
  '/$accountId/_admin/service-manager/$managedAccountId': typeof AccountIdAdminServiceManagerManagedAccountIdRouteWithChildren
  '/$accountId/_user/account/profile': typeof AccountIdUserAccountProfileRoute
  '/$accountId/_user/account/services': typeof AccountIdUserAccountServicesRouteWithChildren
  '/$accountId/_user/account/users': typeof AccountIdUserAccountUsersRoute
  '/$accountId/_user/alarms/$alarmId': typeof AccountIdUserAlarmsAlarmIdRoute
  '/$accountId/_user/dashboards/compressed-air': typeof AccountIdUserDashboardsCompressedAirRoute
  '/$accountId/_user/dashboards/heat-basic': typeof AccountIdUserDashboardsHeatBasicRoute
  '/$accountId/_user/dashboards/power-basic': typeof AccountIdUserDashboardsPowerBasicRoute
  '/$accountId/_user/dashboards/water-basic': typeof AccountIdUserDashboardsWaterBasicRoute
  '/$accountId/_user/datahub-integration/$cvrNumber': typeof AccountIdUserDatahubIntegrationCvrNumberRoute
  '/$accountId/_user/eforsyning-integration/create': typeof AccountIdUserEforsyningIntegrationCreateRoute
  '/$accountId/_user/energyxplorer/dashboard': typeof AccountIdUserEnergyxplorerDashboardRoute
  '/$accountId/_user/gateways/create': typeof AccountIdUserGatewaysCreateRoute
  '/$accountId/_user/powerbi/$reportId': typeof AccountIdUserPowerbiReportIdRoute
  '/$accountId/_user/predictive-heat-control/$buildingName': typeof AccountIdUserPredictiveHeatControlBuildingNameRoute
  '/$accountId/_user/predictive-heat-control/calendar': typeof AccountIdUserPredictiveHeatControlCalendarRoute
  '/$accountId/_user/sensors/$sensorId': typeof AccountIdUserSensorsSensorIdRoute
  '/$accountId/_user/units/create': typeof AccountIdUserUnitsCreateRoute
  '/$accountId/_admin/devices/': typeof AccountIdAdminDevicesIndexRoute
  '/$accountId/_admin/operations/': typeof AccountIdAdminOperationsIndexRoute
  '/$accountId/_admin/service-manager/': typeof AccountIdAdminServiceManagerIndexRoute
  '/$accountId/_user/alarms/': typeof AccountIdUserAlarmsIndexRoute
  '/$accountId/_user/dalux-integration/': typeof AccountIdUserDaluxIntegrationIndexRoute
  '/$accountId/_user/dashboards/': typeof AccountIdUserDashboardsIndexRoute
  '/$accountId/_user/datahub-integration/': typeof AccountIdUserDatahubIntegrationIndexRoute
  '/$accountId/_user/eforsyning-integration/': typeof AccountIdUserEforsyningIntegrationIndexRoute
  '/$accountId/_user/energyxplorer/': typeof AccountIdUserEnergyxplorerIndexRoute
  '/$accountId/_user/export-data/': typeof AccountIdUserExportDataIndexRoute
  '/$accountId/_user/gateways/': typeof AccountIdUserGatewaysIndexRoute
  '/$accountId/_user/powerbi/': typeof AccountIdUserPowerbiIndexRoute
  '/$accountId/_user/predictive-heat-control/': typeof AccountIdUserPredictiveHeatControlIndexRoute
  '/$accountId/_user/sensors/': typeof AccountIdUserSensorsIndexRoute
  '/$accountId/_user/units/': typeof AccountIdUserUnitsIndexRoute
  '/$accountId/_user/weekschedule-manager/': typeof AccountIdUserWeekscheduleManagerIndexRoute
  '/$accountId/_user/energyxplorer/alarms/advanced': typeof AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteWithChildren
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteWithChildren
  '/$accountId/_user/energyxplorer/portfolio/$analysisType': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteWithChildren
  '/$accountId/_admin/devices/$deviceId/edit': typeof AccountIdAdminDevicesDeviceIdEditRoute
  '/$accountId/_admin/operations/deep-dive/$groupId': typeof AccountIdAdminOperationsDeepDiveGroupIdRoute
  '/$accountId/_admin/service-manager/$managedAccountId/alarms': typeof AccountIdAdminServiceManagerManagedAccountIdAlarmsRoute
  '/$accountId/_admin/service-manager/$managedAccountId/analytics': typeof AccountIdAdminServiceManagerManagedAccountIdAnalyticsRoute
  '/$accountId/_admin/service-manager/$managedAccountId/basic-dashboards': typeof AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRoute
  '/$accountId/_admin/service-manager/$managedAccountId/basis': typeof AccountIdAdminServiceManagerManagedAccountIdBasisRoute
  '/$accountId/_admin/service-manager/$managedAccountId/compressed-air': typeof AccountIdAdminServiceManagerManagedAccountIdCompressedAirRoute
  '/$accountId/_admin/service-manager/$managedAccountId/dashboard-heat-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRoute
  '/$accountId/_admin/service-manager/$managedAccountId/dashboard-power-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRoute
  '/$accountId/_admin/service-manager/$managedAccountId/dashboard-water-basic': typeof AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRoute
  '/$accountId/_admin/service-manager/$managedAccountId/datahub-integration': typeof AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRoute
  '/$accountId/_admin/service-manager/$managedAccountId/devices': typeof AccountIdAdminServiceManagerManagedAccountIdDevicesRoute
  '/$accountId/_admin/service-manager/$managedAccountId/eforsyning-integration': typeof AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRoute
  '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer': typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRoute
  '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer-analytics': typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRoute
  '/$accountId/_admin/service-manager/$managedAccountId/jyskenergiesg': typeof AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRoute
  '/$accountId/_admin/service-manager/$managedAccountId/portfolio-analysis': typeof AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRoute
  '/$accountId/_admin/service-manager/$managedAccountId/powerbi': typeof AccountIdAdminServiceManagerManagedAccountIdPowerbiRoute
  '/$accountId/_admin/service-manager/$managedAccountId/predictive-heat-control': typeof AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRoute
  '/$accountId/_admin/service-manager/$managedAccountId/scheduler': typeof AccountIdAdminServiceManagerManagedAccountIdSchedulerRoute
  '/$accountId/_user/account/services/alarms': typeof AccountIdUserAccountServicesAlarmsRoute
  '/$accountId/_user/account/services/analytics': typeof AccountIdUserAccountServicesAnalyticsRoute
  '/$accountId/_user/account/services/basic-dashboards': typeof AccountIdUserAccountServicesBasicDashboardsRoute
  '/$accountId/_user/account/services/basis': typeof AccountIdUserAccountServicesBasisRoute
  '/$accountId/_user/account/services/compressed-air': typeof AccountIdUserAccountServicesCompressedAirRoute
  '/$accountId/_user/account/services/dashboard-heat-basic': typeof AccountIdUserAccountServicesDashboardHeatBasicRoute
  '/$accountId/_user/account/services/dashboard-power-basic': typeof AccountIdUserAccountServicesDashboardPowerBasicRoute
  '/$accountId/_user/account/services/dashboard-water-basic': typeof AccountIdUserAccountServicesDashboardWaterBasicRoute
  '/$accountId/_user/account/services/datahub-integration': typeof AccountIdUserAccountServicesDatahubIntegrationRoute
  '/$accountId/_user/account/services/devices': typeof AccountIdUserAccountServicesDevicesRoute
  '/$accountId/_user/account/services/energyxplorer': typeof AccountIdUserAccountServicesEnergyxplorerRoute
  '/$accountId/_user/account/services/energyxplorer-analytics': typeof AccountIdUserAccountServicesEnergyxplorerAnalyticsRoute
  '/$accountId/_user/account/services/jyskenergiesg': typeof AccountIdUserAccountServicesJyskenergiesgRoute
  '/$accountId/_user/account/services/portfolio-analysis': typeof AccountIdUserAccountServicesPortfolioAnalysisRoute
  '/$accountId/_user/account/services/powerbi': typeof AccountIdUserAccountServicesPowerbiRoute
  '/$accountId/_user/account/services/predictive-heat-control': typeof AccountIdUserAccountServicesPredictiveHeatControlRoute
  '/$accountId/_user/account/services/scheduler': typeof AccountIdUserAccountServicesSchedulerRoute
  '/$accountId/_user/alarms/alarm-groups/$groupId': typeof AccountIdUserAlarmsAlarmGroupsGroupIdRoute
  '/$accountId/_user/alarms/alarm-groups/create': typeof AccountIdUserAlarmsAlarmGroupsCreateRoute
  '/$accountId/_user/alarms/configuration/$alarmConfigurationId': typeof AccountIdUserAlarmsConfigurationAlarmConfigurationIdRoute
  '/$accountId/_user/eforsyning-integration/$integrationId/edit': typeof AccountIdUserEforsyningIntegrationIntegrationIdEditRoute
  '/$accountId/_user/energyxplorer/alarms/$alarmId': typeof AccountIdUserEnergyxplorerAlarmsAlarmIdRoute
  '/$accountId/_user/energyxplorer/deepdive/create': typeof AccountIdUserEnergyxplorerDeepdiveCreateRoute
  '/$accountId/_user/energyxplorer/deepdive/dashboard': typeof AccountIdUserEnergyxplorerDeepdiveDashboardRoute
  '/$accountId/_user/energyxplorer/portfolio/dashboard': typeof AccountIdUserEnergyxplorerPortfolioDashboardRoute
  '/$accountId/_user/gateways/$gatewayId/edit': typeof AccountIdUserGatewaysGatewayIdEditRoute
  '/$accountId/_user/units/$unitId/edit': typeof AccountIdUserUnitsUnitIdEditRoute
  '/$accountId/_admin/devices/$deviceId/': typeof AccountIdAdminDevicesDeviceIdIndexRoute
  '/$accountId/_admin/devices/€deviceId/': typeof AccountIdAdminDevicesChar8364deviceIdIndexRoute
  '/$accountId/_admin/operations/deep-dive/': typeof AccountIdAdminOperationsDeepDiveIndexRoute
  '/$accountId/_admin/operations/portfolio-analysis/': typeof AccountIdAdminOperationsPortfolioAnalysisIndexRoute
  '/$accountId/_admin/operations/predictive-heat-control/': typeof AccountIdAdminOperationsPredictiveHeatControlIndexRoute
  '/$accountId/_admin/operations/quality-of-service/': typeof AccountIdAdminOperationsQualityOfServiceIndexRoute
  '/$accountId/_admin/service-manager/$managedAccountId/': typeof AccountIdAdminServiceManagerManagedAccountIdIndexRoute
  '/$accountId/_user/account/services/': typeof AccountIdUserAccountServicesIndexRoute
  '/$accountId/_user/alarms/alarm-groups/': typeof AccountIdUserAlarmsAlarmGroupsIndexRoute
  '/$accountId/_user/alarms/configuration/': typeof AccountIdUserAlarmsConfigurationIndexRoute
  '/$accountId/_user/eforsyning-integration/$integrationId/': typeof AccountIdUserEforsyningIntegrationIntegrationIdIndexRoute
  '/$accountId/_user/energyxplorer/deepdive/': typeof AccountIdUserEnergyxplorerDeepdiveIndexRoute
  '/$accountId/_user/energyxplorer/portfolio/': typeof AccountIdUserEnergyxplorerPortfolioIndexRoute
  '/$accountId/_user/gateways/$gatewayId/': typeof AccountIdUserGatewaysGatewayIdIndexRoute
  '/$accountId/_user/units/$unitId/': typeof AccountIdUserUnitsUnitIdIndexRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteWithChildren
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteWithChildren
  '/$accountId/_admin/operations/predictive-heat-control/buildings/$buildingName': typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRoute
  '/$accountId/_admin/operations/predictive-heat-control/groups/$groupKey': typeof AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRoute
  '/$accountId/_user/alarms/configuration/create/$alarmTypeId': typeof AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRoute
  '/$accountId/_user/energyxplorer/alarms/advanced/$groupId': typeof AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRoute
  '/$accountId/_user/energyxplorer/alarms/advanced/create': typeof AccountIdUserEnergyxplorerAlarmsAdvancedCreateRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/child-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/comparison-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/consumption-overview': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/create-first-node': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/duration-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/edit': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/esg': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/hour-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/load-profile-analysis': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/pivot': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRoute
  '/$accountId/_user/energyxplorer/portfolio/overview/building': typeof AccountIdUserEnergyxplorerPortfolioOverviewBuildingRoute
  '/$accountId/_user/energyxplorer/portfolio/overview/standard': typeof AccountIdUserEnergyxplorerPortfolioOverviewStandardRoute
  '/$accountId/_user/energyxplorer/portfolio/site/create': typeof AccountIdUserEnergyxplorerPortfolioSiteCreateRoute
  '/$accountId/_admin/operations/predictive-heat-control/buildings/': typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRoute
  '/$accountId/_admin/operations/predictive-heat-control/groups/': typeof AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRoute
  '/$accountId/_admin/operations/predictive-heat-control/subscriptions/': typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRoute
  '/$accountId/_user/energyxplorer/alarms/advanced/': typeof AccountIdUserEnergyxplorerAlarmsAdvancedIndexRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRoute
  '/$accountId/_user/energyxplorer/portfolio/overview/': typeof AccountIdUserEnergyxplorerPortfolioOverviewIndexRoute
  '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/$providerId': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRoute
  '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/$providerId': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/esg': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/$preset': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRoute
  '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRoute
  '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/': typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRoute
  '/$accountId/_admin/operations/predictive-heat-control/subscriptions/$subscriptionName/': typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRoute
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/': typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRoute
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/': typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$accountId'
    | '/$accountId/errorboundarydevtest'
    | '/$accountId/support'
    | '/account/create'
    | '/$accountId/'
    | '/$accountId/devices'
    | '/$accountId/operations'
    | '/$accountId/service-manager'
    | '/$accountId/account'
    | '/$accountId/alarms'
    | '/$accountId/dalux-integration'
    | '/$accountId/dashboards'
    | '/$accountId/datahub-integration'
    | '/$accountId/eforsyning-integration'
    | '/$accountId/energyxplorer'
    | '/$accountId/gateways'
    | '/$accountId/predictive-heat-control'
    | '/$accountId/sensors'
    | '/$accountId/units'
    | '/$accountId/missing-service'
    | '/$accountId/view-data'
    | '/$accountId/operations/predictive-heat-control'
    | '/$accountId/alarms/alarm-groups'
    | '/$accountId/alarms/configuration'
    | '/$accountId/energyxplorer/alarms'
    | '/$accountId/energyxplorer/deepdive'
    | '/$accountId/energyxplorer/portfolio'
    | '/$accountId/gateways/$gatewayId'
    | '/$accountId/units/$unitId'
    | '/$accountId/devices/register'
    | '/$accountId/service-manager/$managedAccountId'
    | '/$accountId/account/profile'
    | '/$accountId/account/services'
    | '/$accountId/account/users'
    | '/$accountId/alarms/$alarmId'
    | '/$accountId/dashboards/compressed-air'
    | '/$accountId/dashboards/heat-basic'
    | '/$accountId/dashboards/power-basic'
    | '/$accountId/dashboards/water-basic'
    | '/$accountId/datahub-integration/$cvrNumber'
    | '/$accountId/eforsyning-integration/create'
    | '/$accountId/energyxplorer/dashboard'
    | '/$accountId/gateways/create'
    | '/$accountId/powerbi/$reportId'
    | '/$accountId/predictive-heat-control/$buildingName'
    | '/$accountId/predictive-heat-control/calendar'
    | '/$accountId/sensors/$sensorId'
    | '/$accountId/units/create'
    | '/$accountId/devices/'
    | '/$accountId/operations/'
    | '/$accountId/service-manager/'
    | '/$accountId/alarms/'
    | '/$accountId/dalux-integration/'
    | '/$accountId/dashboards/'
    | '/$accountId/datahub-integration/'
    | '/$accountId/eforsyning-integration/'
    | '/$accountId/energyxplorer/'
    | '/$accountId/export-data/'
    | '/$accountId/gateways/'
    | '/$accountId/powerbi/'
    | '/$accountId/predictive-heat-control/'
    | '/$accountId/sensors/'
    | '/$accountId/units/'
    | '/$accountId/weekschedule-manager/'
    | '/$accountId/energyxplorer/alarms/advanced'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId'
    | '/$accountId/energyxplorer/portfolio/$analysisType'
    | '/$accountId/devices/$deviceId/edit'
    | '/$accountId/operations/deep-dive/$groupId'
    | '/$accountId/service-manager/$managedAccountId/alarms'
    | '/$accountId/service-manager/$managedAccountId/analytics'
    | '/$accountId/service-manager/$managedAccountId/basic-dashboards'
    | '/$accountId/service-manager/$managedAccountId/basis'
    | '/$accountId/service-manager/$managedAccountId/compressed-air'
    | '/$accountId/service-manager/$managedAccountId/dashboard-heat-basic'
    | '/$accountId/service-manager/$managedAccountId/dashboard-power-basic'
    | '/$accountId/service-manager/$managedAccountId/dashboard-water-basic'
    | '/$accountId/service-manager/$managedAccountId/datahub-integration'
    | '/$accountId/service-manager/$managedAccountId/devices'
    | '/$accountId/service-manager/$managedAccountId/eforsyning-integration'
    | '/$accountId/service-manager/$managedAccountId/energyxplorer'
    | '/$accountId/service-manager/$managedAccountId/energyxplorer-analytics'
    | '/$accountId/service-manager/$managedAccountId/jyskenergiesg'
    | '/$accountId/service-manager/$managedAccountId/portfolio-analysis'
    | '/$accountId/service-manager/$managedAccountId/powerbi'
    | '/$accountId/service-manager/$managedAccountId/predictive-heat-control'
    | '/$accountId/service-manager/$managedAccountId/scheduler'
    | '/$accountId/account/services/alarms'
    | '/$accountId/account/services/analytics'
    | '/$accountId/account/services/basic-dashboards'
    | '/$accountId/account/services/basis'
    | '/$accountId/account/services/compressed-air'
    | '/$accountId/account/services/dashboard-heat-basic'
    | '/$accountId/account/services/dashboard-power-basic'
    | '/$accountId/account/services/dashboard-water-basic'
    | '/$accountId/account/services/datahub-integration'
    | '/$accountId/account/services/devices'
    | '/$accountId/account/services/energyxplorer'
    | '/$accountId/account/services/energyxplorer-analytics'
    | '/$accountId/account/services/jyskenergiesg'
    | '/$accountId/account/services/portfolio-analysis'
    | '/$accountId/account/services/powerbi'
    | '/$accountId/account/services/predictive-heat-control'
    | '/$accountId/account/services/scheduler'
    | '/$accountId/alarms/alarm-groups/$groupId'
    | '/$accountId/alarms/alarm-groups/create'
    | '/$accountId/alarms/configuration/$alarmConfigurationId'
    | '/$accountId/eforsyning-integration/$integrationId/edit'
    | '/$accountId/energyxplorer/alarms/$alarmId'
    | '/$accountId/energyxplorer/deepdive/create'
    | '/$accountId/energyxplorer/deepdive/dashboard'
    | '/$accountId/energyxplorer/portfolio/dashboard'
    | '/$accountId/gateways/$gatewayId/edit'
    | '/$accountId/units/$unitId/edit'
    | '/$accountId/devices/$deviceId/'
    | '/$accountId/devices/€deviceId/'
    | '/$accountId/operations/deep-dive/'
    | '/$accountId/operations/portfolio-analysis/'
    | '/$accountId/operations/predictive-heat-control/'
    | '/$accountId/operations/quality-of-service/'
    | '/$accountId/service-manager/$managedAccountId/'
    | '/$accountId/account/services/'
    | '/$accountId/alarms/alarm-groups/'
    | '/$accountId/alarms/configuration/'
    | '/$accountId/eforsyning-integration/$integrationId/'
    | '/$accountId/energyxplorer/deepdive/'
    | '/$accountId/energyxplorer/portfolio/'
    | '/$accountId/gateways/$gatewayId/'
    | '/$accountId/units/$unitId/'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId'
    | '/$accountId/operations/predictive-heat-control/buildings/$buildingName'
    | '/$accountId/operations/predictive-heat-control/groups/$groupKey'
    | '/$accountId/alarms/configuration/create/$alarmTypeId'
    | '/$accountId/energyxplorer/alarms/advanced/$groupId'
    | '/$accountId/energyxplorer/alarms/advanced/create'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/child-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/comparison-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/consumption-overview'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/create-first-node'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/duration-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/edit'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/esg'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/hour-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/load-profile-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/pivot'
    | '/$accountId/energyxplorer/portfolio/overview/building'
    | '/$accountId/energyxplorer/portfolio/overview/standard'
    | '/$accountId/energyxplorer/portfolio/site/create'
    | '/$accountId/operations/predictive-heat-control/buildings/'
    | '/$accountId/operations/predictive-heat-control/groups/'
    | '/$accountId/operations/predictive-heat-control/subscriptions/'
    | '/$accountId/energyxplorer/alarms/advanced/'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/'
    | '/$accountId/energyxplorer/portfolio/$analysisType/'
    | '/$accountId/energyxplorer/portfolio/overview/'
    | '/$accountId/operations/portfolio-analysis/utility-providers/heat/$providerId'
    | '/$accountId/operations/portfolio-analysis/utility-providers/water/$providerId'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/esg'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/analysis/$preset'
    | '/$accountId/operations/portfolio-analysis/utility-providers/heat/'
    | '/$accountId/operations/portfolio-analysis/utility-providers/water/'
    | '/$accountId/operations/predictive-heat-control/subscriptions/$subscriptionName/'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/'
    | '/$accountId/energyxplorer/portfolio/$analysisType/analysis/'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$accountId'
    | '/$accountId/errorboundarydevtest'
    | '/$accountId/support'
    | '/account/create'
    | '/$accountId/account'
    | '/$accountId/missing-service'
    | '/$accountId/view-data'
    | '/$accountId/energyxplorer/alarms'
    | '/$accountId/devices/register'
    | '/$accountId/account/profile'
    | '/$accountId/account/users'
    | '/$accountId/alarms/$alarmId'
    | '/$accountId/dashboards/compressed-air'
    | '/$accountId/dashboards/heat-basic'
    | '/$accountId/dashboards/power-basic'
    | '/$accountId/dashboards/water-basic'
    | '/$accountId/datahub-integration/$cvrNumber'
    | '/$accountId/eforsyning-integration/create'
    | '/$accountId/energyxplorer/dashboard'
    | '/$accountId/gateways/create'
    | '/$accountId/powerbi/$reportId'
    | '/$accountId/predictive-heat-control/$buildingName'
    | '/$accountId/predictive-heat-control/calendar'
    | '/$accountId/sensors/$sensorId'
    | '/$accountId/units/create'
    | '/$accountId/devices'
    | '/$accountId/operations'
    | '/$accountId/service-manager'
    | '/$accountId/alarms'
    | '/$accountId/dalux-integration'
    | '/$accountId/dashboards'
    | '/$accountId/datahub-integration'
    | '/$accountId/eforsyning-integration'
    | '/$accountId/energyxplorer'
    | '/$accountId/export-data'
    | '/$accountId/gateways'
    | '/$accountId/powerbi'
    | '/$accountId/predictive-heat-control'
    | '/$accountId/sensors'
    | '/$accountId/units'
    | '/$accountId/weekschedule-manager'
    | '/$accountId/devices/$deviceId/edit'
    | '/$accountId/operations/deep-dive/$groupId'
    | '/$accountId/service-manager/$managedAccountId/alarms'
    | '/$accountId/service-manager/$managedAccountId/analytics'
    | '/$accountId/service-manager/$managedAccountId/basic-dashboards'
    | '/$accountId/service-manager/$managedAccountId/basis'
    | '/$accountId/service-manager/$managedAccountId/compressed-air'
    | '/$accountId/service-manager/$managedAccountId/dashboard-heat-basic'
    | '/$accountId/service-manager/$managedAccountId/dashboard-power-basic'
    | '/$accountId/service-manager/$managedAccountId/dashboard-water-basic'
    | '/$accountId/service-manager/$managedAccountId/datahub-integration'
    | '/$accountId/service-manager/$managedAccountId/devices'
    | '/$accountId/service-manager/$managedAccountId/eforsyning-integration'
    | '/$accountId/service-manager/$managedAccountId/energyxplorer'
    | '/$accountId/service-manager/$managedAccountId/energyxplorer-analytics'
    | '/$accountId/service-manager/$managedAccountId/jyskenergiesg'
    | '/$accountId/service-manager/$managedAccountId/portfolio-analysis'
    | '/$accountId/service-manager/$managedAccountId/powerbi'
    | '/$accountId/service-manager/$managedAccountId/predictive-heat-control'
    | '/$accountId/service-manager/$managedAccountId/scheduler'
    | '/$accountId/account/services/alarms'
    | '/$accountId/account/services/analytics'
    | '/$accountId/account/services/basic-dashboards'
    | '/$accountId/account/services/basis'
    | '/$accountId/account/services/compressed-air'
    | '/$accountId/account/services/dashboard-heat-basic'
    | '/$accountId/account/services/dashboard-power-basic'
    | '/$accountId/account/services/dashboard-water-basic'
    | '/$accountId/account/services/datahub-integration'
    | '/$accountId/account/services/devices'
    | '/$accountId/account/services/energyxplorer'
    | '/$accountId/account/services/energyxplorer-analytics'
    | '/$accountId/account/services/jyskenergiesg'
    | '/$accountId/account/services/portfolio-analysis'
    | '/$accountId/account/services/powerbi'
    | '/$accountId/account/services/predictive-heat-control'
    | '/$accountId/account/services/scheduler'
    | '/$accountId/alarms/alarm-groups/$groupId'
    | '/$accountId/alarms/alarm-groups/create'
    | '/$accountId/alarms/configuration/$alarmConfigurationId'
    | '/$accountId/eforsyning-integration/$integrationId/edit'
    | '/$accountId/energyxplorer/alarms/$alarmId'
    | '/$accountId/energyxplorer/deepdive/create'
    | '/$accountId/energyxplorer/deepdive/dashboard'
    | '/$accountId/energyxplorer/portfolio/dashboard'
    | '/$accountId/gateways/$gatewayId/edit'
    | '/$accountId/units/$unitId/edit'
    | '/$accountId/devices/$deviceId'
    | '/$accountId/devices/€deviceId'
    | '/$accountId/operations/deep-dive'
    | '/$accountId/operations/portfolio-analysis'
    | '/$accountId/operations/predictive-heat-control'
    | '/$accountId/operations/quality-of-service'
    | '/$accountId/service-manager/$managedAccountId'
    | '/$accountId/account/services'
    | '/$accountId/alarms/alarm-groups'
    | '/$accountId/alarms/configuration'
    | '/$accountId/eforsyning-integration/$integrationId'
    | '/$accountId/energyxplorer/deepdive'
    | '/$accountId/energyxplorer/portfolio'
    | '/$accountId/gateways/$gatewayId'
    | '/$accountId/units/$unitId'
    | '/$accountId/operations/predictive-heat-control/buildings/$buildingName'
    | '/$accountId/operations/predictive-heat-control/groups/$groupKey'
    | '/$accountId/alarms/configuration/create/$alarmTypeId'
    | '/$accountId/energyxplorer/alarms/advanced/$groupId'
    | '/$accountId/energyxplorer/alarms/advanced/create'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/child-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/comparison-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/consumption-overview'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/create-first-node'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/duration-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/edit'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/esg'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/hour-analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/load-profile-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/pivot'
    | '/$accountId/energyxplorer/portfolio/overview/building'
    | '/$accountId/energyxplorer/portfolio/overview/standard'
    | '/$accountId/energyxplorer/portfolio/site/create'
    | '/$accountId/operations/predictive-heat-control/buildings'
    | '/$accountId/operations/predictive-heat-control/groups'
    | '/$accountId/operations/predictive-heat-control/subscriptions'
    | '/$accountId/energyxplorer/alarms/advanced'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId'
    | '/$accountId/energyxplorer/portfolio/$analysisType'
    | '/$accountId/energyxplorer/portfolio/overview'
    | '/$accountId/operations/portfolio-analysis/utility-providers/heat/$providerId'
    | '/$accountId/operations/portfolio-analysis/utility-providers/water/$providerId'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/esg'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis'
    | '/$accountId/energyxplorer/portfolio/$analysisType/analysis/$preset'
    | '/$accountId/operations/portfolio-analysis/utility-providers/heat'
    | '/$accountId/operations/portfolio-analysis/utility-providers/water'
    | '/$accountId/operations/predictive-heat-control/subscriptions/$subscriptionName'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives'
    | '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId'
    | '/$accountId/energyxplorer/portfolio/$analysisType/analysis'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit'
    | '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId'
  id:
    | '__root__'
    | '/'
    | '/$accountId'
    | '/$accountId/_admin'
    | '/$accountId/_user'
    | '/$accountId/errorboundarydevtest'
    | '/$accountId/support'
    | '/account/create'
    | '/$accountId/'
    | '/$accountId/_admin/devices'
    | '/$accountId/_admin/operations'
    | '/$accountId/_admin/service-manager'
    | '/$accountId/_user/account'
    | '/$accountId/_user/alarms'
    | '/$accountId/_user/dalux-integration'
    | '/$accountId/_user/dashboards'
    | '/$accountId/_user/datahub-integration'
    | '/$accountId/_user/eforsyning-integration'
    | '/$accountId/_user/energyxplorer'
    | '/$accountId/_user/gateways'
    | '/$accountId/_user/predictive-heat-control'
    | '/$accountId/_user/sensors'
    | '/$accountId/_user/units'
    | '/$accountId/_user/missing-service'
    | '/$accountId/_user/view-data'
    | '/$accountId/_admin/operations/predictive-heat-control'
    | '/$accountId/_user/alarms/alarm-groups'
    | '/$accountId/_user/alarms/configuration'
    | '/$accountId/_user/energyxplorer/alarms'
    | '/$accountId/_user/energyxplorer/deepdive'
    | '/$accountId/_user/energyxplorer/portfolio'
    | '/$accountId/_user/gateways/$gatewayId'
    | '/$accountId/_user/units/$unitId'
    | '/$accountId/_admin/devices/register'
    | '/$accountId/_admin/service-manager/$managedAccountId'
    | '/$accountId/_user/account/profile'
    | '/$accountId/_user/account/services'
    | '/$accountId/_user/account/users'
    | '/$accountId/_user/alarms/$alarmId'
    | '/$accountId/_user/dashboards/compressed-air'
    | '/$accountId/_user/dashboards/heat-basic'
    | '/$accountId/_user/dashboards/power-basic'
    | '/$accountId/_user/dashboards/water-basic'
    | '/$accountId/_user/datahub-integration/$cvrNumber'
    | '/$accountId/_user/eforsyning-integration/create'
    | '/$accountId/_user/energyxplorer/dashboard'
    | '/$accountId/_user/gateways/create'
    | '/$accountId/_user/powerbi/$reportId'
    | '/$accountId/_user/predictive-heat-control/$buildingName'
    | '/$accountId/_user/predictive-heat-control/calendar'
    | '/$accountId/_user/sensors/$sensorId'
    | '/$accountId/_user/units/create'
    | '/$accountId/_admin/devices/'
    | '/$accountId/_admin/operations/'
    | '/$accountId/_admin/service-manager/'
    | '/$accountId/_user/alarms/'
    | '/$accountId/_user/dalux-integration/'
    | '/$accountId/_user/dashboards/'
    | '/$accountId/_user/datahub-integration/'
    | '/$accountId/_user/eforsyning-integration/'
    | '/$accountId/_user/energyxplorer/'
    | '/$accountId/_user/export-data/'
    | '/$accountId/_user/gateways/'
    | '/$accountId/_user/powerbi/'
    | '/$accountId/_user/predictive-heat-control/'
    | '/$accountId/_user/sensors/'
    | '/$accountId/_user/units/'
    | '/$accountId/_user/weekschedule-manager/'
    | '/$accountId/_user/energyxplorer/alarms/advanced'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType'
    | '/$accountId/_admin/devices/$deviceId/edit'
    | '/$accountId/_admin/operations/deep-dive/$groupId'
    | '/$accountId/_admin/service-manager/$managedAccountId/alarms'
    | '/$accountId/_admin/service-manager/$managedAccountId/analytics'
    | '/$accountId/_admin/service-manager/$managedAccountId/basic-dashboards'
    | '/$accountId/_admin/service-manager/$managedAccountId/basis'
    | '/$accountId/_admin/service-manager/$managedAccountId/compressed-air'
    | '/$accountId/_admin/service-manager/$managedAccountId/dashboard-heat-basic'
    | '/$accountId/_admin/service-manager/$managedAccountId/dashboard-power-basic'
    | '/$accountId/_admin/service-manager/$managedAccountId/dashboard-water-basic'
    | '/$accountId/_admin/service-manager/$managedAccountId/datahub-integration'
    | '/$accountId/_admin/service-manager/$managedAccountId/devices'
    | '/$accountId/_admin/service-manager/$managedAccountId/eforsyning-integration'
    | '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer'
    | '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer-analytics'
    | '/$accountId/_admin/service-manager/$managedAccountId/jyskenergiesg'
    | '/$accountId/_admin/service-manager/$managedAccountId/portfolio-analysis'
    | '/$accountId/_admin/service-manager/$managedAccountId/powerbi'
    | '/$accountId/_admin/service-manager/$managedAccountId/predictive-heat-control'
    | '/$accountId/_admin/service-manager/$managedAccountId/scheduler'
    | '/$accountId/_user/account/services/alarms'
    | '/$accountId/_user/account/services/analytics'
    | '/$accountId/_user/account/services/basic-dashboards'
    | '/$accountId/_user/account/services/basis'
    | '/$accountId/_user/account/services/compressed-air'
    | '/$accountId/_user/account/services/dashboard-heat-basic'
    | '/$accountId/_user/account/services/dashboard-power-basic'
    | '/$accountId/_user/account/services/dashboard-water-basic'
    | '/$accountId/_user/account/services/datahub-integration'
    | '/$accountId/_user/account/services/devices'
    | '/$accountId/_user/account/services/energyxplorer'
    | '/$accountId/_user/account/services/energyxplorer-analytics'
    | '/$accountId/_user/account/services/jyskenergiesg'
    | '/$accountId/_user/account/services/portfolio-analysis'
    | '/$accountId/_user/account/services/powerbi'
    | '/$accountId/_user/account/services/predictive-heat-control'
    | '/$accountId/_user/account/services/scheduler'
    | '/$accountId/_user/alarms/alarm-groups/$groupId'
    | '/$accountId/_user/alarms/alarm-groups/create'
    | '/$accountId/_user/alarms/configuration/$alarmConfigurationId'
    | '/$accountId/_user/eforsyning-integration/$integrationId/edit'
    | '/$accountId/_user/energyxplorer/alarms/$alarmId'
    | '/$accountId/_user/energyxplorer/deepdive/create'
    | '/$accountId/_user/energyxplorer/deepdive/dashboard'
    | '/$accountId/_user/energyxplorer/portfolio/dashboard'
    | '/$accountId/_user/gateways/$gatewayId/edit'
    | '/$accountId/_user/units/$unitId/edit'
    | '/$accountId/_admin/devices/$deviceId/'
    | '/$accountId/_admin/devices/€deviceId/'
    | '/$accountId/_admin/operations/deep-dive/'
    | '/$accountId/_admin/operations/portfolio-analysis/'
    | '/$accountId/_admin/operations/predictive-heat-control/'
    | '/$accountId/_admin/operations/quality-of-service/'
    | '/$accountId/_admin/service-manager/$managedAccountId/'
    | '/$accountId/_user/account/services/'
    | '/$accountId/_user/alarms/alarm-groups/'
    | '/$accountId/_user/alarms/configuration/'
    | '/$accountId/_user/eforsyning-integration/$integrationId/'
    | '/$accountId/_user/energyxplorer/deepdive/'
    | '/$accountId/_user/energyxplorer/portfolio/'
    | '/$accountId/_user/gateways/$gatewayId/'
    | '/$accountId/_user/units/$unitId/'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId'
    | '/$accountId/_admin/operations/predictive-heat-control/buildings/$buildingName'
    | '/$accountId/_admin/operations/predictive-heat-control/groups/$groupKey'
    | '/$accountId/_user/alarms/configuration/create/$alarmTypeId'
    | '/$accountId/_user/energyxplorer/alarms/advanced/$groupId'
    | '/$accountId/_user/energyxplorer/alarms/advanced/create'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/child-analysis'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/comparison-analysis'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/consumption-overview'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/create-first-node'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/duration-analysis'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/edit'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-analysis'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/esg'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/hour-analysis'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/load-profile-analysis'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/pivot'
    | '/$accountId/_user/energyxplorer/portfolio/overview/building'
    | '/$accountId/_user/energyxplorer/portfolio/overview/standard'
    | '/$accountId/_user/energyxplorer/portfolio/site/create'
    | '/$accountId/_admin/operations/predictive-heat-control/buildings/'
    | '/$accountId/_admin/operations/predictive-heat-control/groups/'
    | '/$accountId/_admin/operations/predictive-heat-control/subscriptions/'
    | '/$accountId/_user/energyxplorer/alarms/advanced/'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/'
    | '/$accountId/_user/energyxplorer/portfolio/overview/'
    | '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/$providerId'
    | '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/$providerId'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/esg'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/$preset'
    | '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/'
    | '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/'
    | '/$accountId/_admin/operations/predictive-heat-control/subscriptions/$subscriptionName/'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/'
    | '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit'
    | '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountIdRouteRoute: typeof AccountIdRouteRouteWithChildren
  AccountCreateRoute: typeof AccountCreateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$accountId': {
      id: '/$accountId'
      path: '/$accountId'
      fullPath: '/$accountId'
      preLoaderRoute: typeof AccountIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$accountId/': {
      id: '/$accountId/'
      path: '/'
      fullPath: '/$accountId/'
      preLoaderRoute: typeof AccountIdIndexRouteImport
      parentRoute: typeof AccountIdRouteRoute
    }
    '/account/create': {
      id: '/account/create'
      path: '/account/create'
      fullPath: '/account/create'
      preLoaderRoute: typeof AccountCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$accountId/support': {
      id: '/$accountId/support'
      path: '/support'
      fullPath: '/$accountId/support'
      preLoaderRoute: typeof AccountIdSupportRouteImport
      parentRoute: typeof AccountIdRouteRoute
    }
    '/$accountId/errorboundarydevtest': {
      id: '/$accountId/errorboundarydevtest'
      path: '/errorboundarydevtest'
      fullPath: '/$accountId/errorboundarydevtest'
      preLoaderRoute: typeof AccountIdErrorboundarydevtestRouteImport
      parentRoute: typeof AccountIdRouteRoute
    }
    '/$accountId/_user': {
      id: '/$accountId/_user'
      path: ''
      fullPath: '/$accountId'
      preLoaderRoute: typeof AccountIdUserRouteRouteImport
      parentRoute: typeof AccountIdRouteRoute
    }
    '/$accountId/_admin': {
      id: '/$accountId/_admin'
      path: ''
      fullPath: '/$accountId'
      preLoaderRoute: typeof AccountIdAdminRouteRouteImport
      parentRoute: typeof AccountIdRouteRoute
    }
    '/$accountId/_user/view-data': {
      id: '/$accountId/_user/view-data'
      path: '/view-data'
      fullPath: '/$accountId/view-data'
      preLoaderRoute: typeof AccountIdUserViewDataRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/missing-service': {
      id: '/$accountId/_user/missing-service'
      path: '/missing-service'
      fullPath: '/$accountId/missing-service'
      preLoaderRoute: typeof AccountIdUserMissingServiceRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/units': {
      id: '/$accountId/_user/units'
      path: '/units'
      fullPath: '/$accountId/units'
      preLoaderRoute: typeof AccountIdUserUnitsRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/sensors': {
      id: '/$accountId/_user/sensors'
      path: '/sensors'
      fullPath: '/$accountId/sensors'
      preLoaderRoute: typeof AccountIdUserSensorsRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/predictive-heat-control': {
      id: '/$accountId/_user/predictive-heat-control'
      path: '/predictive-heat-control'
      fullPath: '/$accountId/predictive-heat-control'
      preLoaderRoute: typeof AccountIdUserPredictiveHeatControlRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/gateways': {
      id: '/$accountId/_user/gateways'
      path: '/gateways'
      fullPath: '/$accountId/gateways'
      preLoaderRoute: typeof AccountIdUserGatewaysRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/energyxplorer': {
      id: '/$accountId/_user/energyxplorer'
      path: '/energyxplorer'
      fullPath: '/$accountId/energyxplorer'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/eforsyning-integration': {
      id: '/$accountId/_user/eforsyning-integration'
      path: '/eforsyning-integration'
      fullPath: '/$accountId/eforsyning-integration'
      preLoaderRoute: typeof AccountIdUserEforsyningIntegrationRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/datahub-integration': {
      id: '/$accountId/_user/datahub-integration'
      path: '/datahub-integration'
      fullPath: '/$accountId/datahub-integration'
      preLoaderRoute: typeof AccountIdUserDatahubIntegrationRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/dashboards': {
      id: '/$accountId/_user/dashboards'
      path: '/dashboards'
      fullPath: '/$accountId/dashboards'
      preLoaderRoute: typeof AccountIdUserDashboardsRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/dalux-integration': {
      id: '/$accountId/_user/dalux-integration'
      path: '/dalux-integration'
      fullPath: '/$accountId/dalux-integration'
      preLoaderRoute: typeof AccountIdUserDaluxIntegrationRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/alarms': {
      id: '/$accountId/_user/alarms'
      path: '/alarms'
      fullPath: '/$accountId/alarms'
      preLoaderRoute: typeof AccountIdUserAlarmsRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/account': {
      id: '/$accountId/_user/account'
      path: '/account'
      fullPath: '/$accountId/account'
      preLoaderRoute: typeof AccountIdUserAccountRouteRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_admin/service-manager': {
      id: '/$accountId/_admin/service-manager'
      path: '/service-manager'
      fullPath: '/$accountId/service-manager'
      preLoaderRoute: typeof AccountIdAdminServiceManagerRouteRouteImport
      parentRoute: typeof AccountIdAdminRouteRoute
    }
    '/$accountId/_admin/operations': {
      id: '/$accountId/_admin/operations'
      path: '/operations'
      fullPath: '/$accountId/operations'
      preLoaderRoute: typeof AccountIdAdminOperationsRouteRouteImport
      parentRoute: typeof AccountIdAdminRouteRoute
    }
    '/$accountId/_admin/devices': {
      id: '/$accountId/_admin/devices'
      path: '/devices'
      fullPath: '/$accountId/devices'
      preLoaderRoute: typeof AccountIdAdminDevicesRouteRouteImport
      parentRoute: typeof AccountIdAdminRouteRoute
    }
    '/$accountId/_user/weekschedule-manager/': {
      id: '/$accountId/_user/weekschedule-manager/'
      path: '/weekschedule-manager'
      fullPath: '/$accountId/weekschedule-manager/'
      preLoaderRoute: typeof AccountIdUserWeekscheduleManagerIndexRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/units/': {
      id: '/$accountId/_user/units/'
      path: '/'
      fullPath: '/$accountId/units/'
      preLoaderRoute: typeof AccountIdUserUnitsIndexRouteImport
      parentRoute: typeof AccountIdUserUnitsRouteRoute
    }
    '/$accountId/_user/sensors/': {
      id: '/$accountId/_user/sensors/'
      path: '/'
      fullPath: '/$accountId/sensors/'
      preLoaderRoute: typeof AccountIdUserSensorsIndexRouteImport
      parentRoute: typeof AccountIdUserSensorsRouteRoute
    }
    '/$accountId/_user/predictive-heat-control/': {
      id: '/$accountId/_user/predictive-heat-control/'
      path: '/'
      fullPath: '/$accountId/predictive-heat-control/'
      preLoaderRoute: typeof AccountIdUserPredictiveHeatControlIndexRouteImport
      parentRoute: typeof AccountIdUserPredictiveHeatControlRouteRoute
    }
    '/$accountId/_user/powerbi/': {
      id: '/$accountId/_user/powerbi/'
      path: '/powerbi'
      fullPath: '/$accountId/powerbi/'
      preLoaderRoute: typeof AccountIdUserPowerbiIndexRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/gateways/': {
      id: '/$accountId/_user/gateways/'
      path: '/'
      fullPath: '/$accountId/gateways/'
      preLoaderRoute: typeof AccountIdUserGatewaysIndexRouteImport
      parentRoute: typeof AccountIdUserGatewaysRouteRoute
    }
    '/$accountId/_user/export-data/': {
      id: '/$accountId/_user/export-data/'
      path: '/export-data'
      fullPath: '/$accountId/export-data/'
      preLoaderRoute: typeof AccountIdUserExportDataIndexRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/energyxplorer/': {
      id: '/$accountId/_user/energyxplorer/'
      path: '/'
      fullPath: '/$accountId/energyxplorer/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerRouteRoute
    }
    '/$accountId/_user/eforsyning-integration/': {
      id: '/$accountId/_user/eforsyning-integration/'
      path: '/'
      fullPath: '/$accountId/eforsyning-integration/'
      preLoaderRoute: typeof AccountIdUserEforsyningIntegrationIndexRouteImport
      parentRoute: typeof AccountIdUserEforsyningIntegrationRouteRoute
    }
    '/$accountId/_user/datahub-integration/': {
      id: '/$accountId/_user/datahub-integration/'
      path: '/'
      fullPath: '/$accountId/datahub-integration/'
      preLoaderRoute: typeof AccountIdUserDatahubIntegrationIndexRouteImport
      parentRoute: typeof AccountIdUserDatahubIntegrationRouteRoute
    }
    '/$accountId/_user/dashboards/': {
      id: '/$accountId/_user/dashboards/'
      path: '/'
      fullPath: '/$accountId/dashboards/'
      preLoaderRoute: typeof AccountIdUserDashboardsIndexRouteImport
      parentRoute: typeof AccountIdUserDashboardsRouteRoute
    }
    '/$accountId/_user/dalux-integration/': {
      id: '/$accountId/_user/dalux-integration/'
      path: '/'
      fullPath: '/$accountId/dalux-integration/'
      preLoaderRoute: typeof AccountIdUserDaluxIntegrationIndexRouteImport
      parentRoute: typeof AccountIdUserDaluxIntegrationRouteRoute
    }
    '/$accountId/_user/alarms/': {
      id: '/$accountId/_user/alarms/'
      path: '/'
      fullPath: '/$accountId/alarms/'
      preLoaderRoute: typeof AccountIdUserAlarmsIndexRouteImport
      parentRoute: typeof AccountIdUserAlarmsRouteRoute
    }
    '/$accountId/_admin/service-manager/': {
      id: '/$accountId/_admin/service-manager/'
      path: '/'
      fullPath: '/$accountId/service-manager/'
      preLoaderRoute: typeof AccountIdAdminServiceManagerIndexRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerRouteRoute
    }
    '/$accountId/_admin/operations/': {
      id: '/$accountId/_admin/operations/'
      path: '/'
      fullPath: '/$accountId/operations/'
      preLoaderRoute: typeof AccountIdAdminOperationsIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_admin/devices/': {
      id: '/$accountId/_admin/devices/'
      path: '/'
      fullPath: '/$accountId/devices/'
      preLoaderRoute: typeof AccountIdAdminDevicesIndexRouteImport
      parentRoute: typeof AccountIdAdminDevicesRouteRoute
    }
    '/$accountId/_user/units/create': {
      id: '/$accountId/_user/units/create'
      path: '/create'
      fullPath: '/$accountId/units/create'
      preLoaderRoute: typeof AccountIdUserUnitsCreateRouteImport
      parentRoute: typeof AccountIdUserUnitsRouteRoute
    }
    '/$accountId/_user/sensors/$sensorId': {
      id: '/$accountId/_user/sensors/$sensorId'
      path: '/$sensorId'
      fullPath: '/$accountId/sensors/$sensorId'
      preLoaderRoute: typeof AccountIdUserSensorsSensorIdRouteImport
      parentRoute: typeof AccountIdUserSensorsRouteRoute
    }
    '/$accountId/_user/predictive-heat-control/calendar': {
      id: '/$accountId/_user/predictive-heat-control/calendar'
      path: '/calendar'
      fullPath: '/$accountId/predictive-heat-control/calendar'
      preLoaderRoute: typeof AccountIdUserPredictiveHeatControlCalendarRouteImport
      parentRoute: typeof AccountIdUserPredictiveHeatControlRouteRoute
    }
    '/$accountId/_user/predictive-heat-control/$buildingName': {
      id: '/$accountId/_user/predictive-heat-control/$buildingName'
      path: '/$buildingName'
      fullPath: '/$accountId/predictive-heat-control/$buildingName'
      preLoaderRoute: typeof AccountIdUserPredictiveHeatControlBuildingNameRouteImport
      parentRoute: typeof AccountIdUserPredictiveHeatControlRouteRoute
    }
    '/$accountId/_user/powerbi/$reportId': {
      id: '/$accountId/_user/powerbi/$reportId'
      path: '/powerbi/$reportId'
      fullPath: '/$accountId/powerbi/$reportId'
      preLoaderRoute: typeof AccountIdUserPowerbiReportIdRouteImport
      parentRoute: typeof AccountIdUserRouteRoute
    }
    '/$accountId/_user/gateways/create': {
      id: '/$accountId/_user/gateways/create'
      path: '/create'
      fullPath: '/$accountId/gateways/create'
      preLoaderRoute: typeof AccountIdUserGatewaysCreateRouteImport
      parentRoute: typeof AccountIdUserGatewaysRouteRoute
    }
    '/$accountId/_user/energyxplorer/dashboard': {
      id: '/$accountId/_user/energyxplorer/dashboard'
      path: '/dashboard'
      fullPath: '/$accountId/energyxplorer/dashboard'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDashboardRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerRouteRoute
    }
    '/$accountId/_user/eforsyning-integration/create': {
      id: '/$accountId/_user/eforsyning-integration/create'
      path: '/create'
      fullPath: '/$accountId/eforsyning-integration/create'
      preLoaderRoute: typeof AccountIdUserEforsyningIntegrationCreateRouteImport
      parentRoute: typeof AccountIdUserEforsyningIntegrationRouteRoute
    }
    '/$accountId/_user/datahub-integration/$cvrNumber': {
      id: '/$accountId/_user/datahub-integration/$cvrNumber'
      path: '/$cvrNumber'
      fullPath: '/$accountId/datahub-integration/$cvrNumber'
      preLoaderRoute: typeof AccountIdUserDatahubIntegrationCvrNumberRouteImport
      parentRoute: typeof AccountIdUserDatahubIntegrationRouteRoute
    }
    '/$accountId/_user/dashboards/water-basic': {
      id: '/$accountId/_user/dashboards/water-basic'
      path: '/water-basic'
      fullPath: '/$accountId/dashboards/water-basic'
      preLoaderRoute: typeof AccountIdUserDashboardsWaterBasicRouteImport
      parentRoute: typeof AccountIdUserDashboardsRouteRoute
    }
    '/$accountId/_user/dashboards/power-basic': {
      id: '/$accountId/_user/dashboards/power-basic'
      path: '/power-basic'
      fullPath: '/$accountId/dashboards/power-basic'
      preLoaderRoute: typeof AccountIdUserDashboardsPowerBasicRouteImport
      parentRoute: typeof AccountIdUserDashboardsRouteRoute
    }
    '/$accountId/_user/dashboards/heat-basic': {
      id: '/$accountId/_user/dashboards/heat-basic'
      path: '/heat-basic'
      fullPath: '/$accountId/dashboards/heat-basic'
      preLoaderRoute: typeof AccountIdUserDashboardsHeatBasicRouteImport
      parentRoute: typeof AccountIdUserDashboardsRouteRoute
    }
    '/$accountId/_user/dashboards/compressed-air': {
      id: '/$accountId/_user/dashboards/compressed-air'
      path: '/compressed-air'
      fullPath: '/$accountId/dashboards/compressed-air'
      preLoaderRoute: typeof AccountIdUserDashboardsCompressedAirRouteImport
      parentRoute: typeof AccountIdUserDashboardsRouteRoute
    }
    '/$accountId/_user/alarms/$alarmId': {
      id: '/$accountId/_user/alarms/$alarmId'
      path: '/$alarmId'
      fullPath: '/$accountId/alarms/$alarmId'
      preLoaderRoute: typeof AccountIdUserAlarmsAlarmIdRouteImport
      parentRoute: typeof AccountIdUserAlarmsRouteRoute
    }
    '/$accountId/_user/account/users': {
      id: '/$accountId/_user/account/users'
      path: '/users'
      fullPath: '/$accountId/account/users'
      preLoaderRoute: typeof AccountIdUserAccountUsersRouteImport
      parentRoute: typeof AccountIdUserAccountRouteRoute
    }
    '/$accountId/_user/account/services': {
      id: '/$accountId/_user/account/services'
      path: '/services'
      fullPath: '/$accountId/account/services'
      preLoaderRoute: typeof AccountIdUserAccountServicesRouteImport
      parentRoute: typeof AccountIdUserAccountRouteRoute
    }
    '/$accountId/_user/account/profile': {
      id: '/$accountId/_user/account/profile'
      path: '/profile'
      fullPath: '/$accountId/account/profile'
      preLoaderRoute: typeof AccountIdUserAccountProfileRouteImport
      parentRoute: typeof AccountIdUserAccountRouteRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId': {
      id: '/$accountId/_admin/service-manager/$managedAccountId'
      path: '/$managedAccountId'
      fullPath: '/$accountId/service-manager/$managedAccountId'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerRouteRoute
    }
    '/$accountId/_admin/devices/register': {
      id: '/$accountId/_admin/devices/register'
      path: '/register'
      fullPath: '/$accountId/devices/register'
      preLoaderRoute: typeof AccountIdAdminDevicesRegisterRouteImport
      parentRoute: typeof AccountIdAdminDevicesRouteRoute
    }
    '/$accountId/_user/units/$unitId': {
      id: '/$accountId/_user/units/$unitId'
      path: '/$unitId'
      fullPath: '/$accountId/units/$unitId'
      preLoaderRoute: typeof AccountIdUserUnitsUnitIdRouteRouteImport
      parentRoute: typeof AccountIdUserUnitsRouteRoute
    }
    '/$accountId/_user/gateways/$gatewayId': {
      id: '/$accountId/_user/gateways/$gatewayId'
      path: '/$gatewayId'
      fullPath: '/$accountId/gateways/$gatewayId'
      preLoaderRoute: typeof AccountIdUserGatewaysGatewayIdRouteRouteImport
      parentRoute: typeof AccountIdUserGatewaysRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio': {
      id: '/$accountId/_user/energyxplorer/portfolio'
      path: '/portfolio'
      fullPath: '/$accountId/energyxplorer/portfolio'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive': {
      id: '/$accountId/_user/energyxplorer/deepdive'
      path: '/deepdive'
      fullPath: '/$accountId/energyxplorer/deepdive'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveRouteRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerRouteRoute
    }
    '/$accountId/_user/energyxplorer/alarms': {
      id: '/$accountId/_user/energyxplorer/alarms'
      path: '/alarms'
      fullPath: '/$accountId/energyxplorer/alarms'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerAlarmsRouteRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerRouteRoute
    }
    '/$accountId/_user/alarms/configuration': {
      id: '/$accountId/_user/alarms/configuration'
      path: '/configuration'
      fullPath: '/$accountId/alarms/configuration'
      preLoaderRoute: typeof AccountIdUserAlarmsConfigurationRouteRouteImport
      parentRoute: typeof AccountIdUserAlarmsRouteRoute
    }
    '/$accountId/_user/alarms/alarm-groups': {
      id: '/$accountId/_user/alarms/alarm-groups'
      path: '/alarm-groups'
      fullPath: '/$accountId/alarms/alarm-groups'
      preLoaderRoute: typeof AccountIdUserAlarmsAlarmGroupsRouteRouteImport
      parentRoute: typeof AccountIdUserAlarmsRouteRoute
    }
    '/$accountId/_admin/operations/predictive-heat-control': {
      id: '/$accountId/_admin/operations/predictive-heat-control'
      path: '/predictive-heat-control'
      fullPath: '/$accountId/operations/predictive-heat-control'
      preLoaderRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_user/units/$unitId/': {
      id: '/$accountId/_user/units/$unitId/'
      path: '/'
      fullPath: '/$accountId/units/$unitId/'
      preLoaderRoute: typeof AccountIdUserUnitsUnitIdIndexRouteImport
      parentRoute: typeof AccountIdUserUnitsUnitIdRouteRoute
    }
    '/$accountId/_user/gateways/$gatewayId/': {
      id: '/$accountId/_user/gateways/$gatewayId/'
      path: '/'
      fullPath: '/$accountId/gateways/$gatewayId/'
      preLoaderRoute: typeof AccountIdUserGatewaysGatewayIdIndexRouteImport
      parentRoute: typeof AccountIdUserGatewaysGatewayIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/': {
      id: '/$accountId/_user/energyxplorer/portfolio/'
      path: '/'
      fullPath: '/$accountId/energyxplorer/portfolio/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/': {
      id: '/$accountId/_user/energyxplorer/deepdive/'
      path: '/'
      fullPath: '/$accountId/energyxplorer/deepdive/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveRouteRoute
    }
    '/$accountId/_user/eforsyning-integration/$integrationId/': {
      id: '/$accountId/_user/eforsyning-integration/$integrationId/'
      path: '/$integrationId'
      fullPath: '/$accountId/eforsyning-integration/$integrationId/'
      preLoaderRoute: typeof AccountIdUserEforsyningIntegrationIntegrationIdIndexRouteImport
      parentRoute: typeof AccountIdUserEforsyningIntegrationRouteRoute
    }
    '/$accountId/_user/alarms/configuration/': {
      id: '/$accountId/_user/alarms/configuration/'
      path: '/'
      fullPath: '/$accountId/alarms/configuration/'
      preLoaderRoute: typeof AccountIdUserAlarmsConfigurationIndexRouteImport
      parentRoute: typeof AccountIdUserAlarmsConfigurationRouteRoute
    }
    '/$accountId/_user/alarms/alarm-groups/': {
      id: '/$accountId/_user/alarms/alarm-groups/'
      path: '/'
      fullPath: '/$accountId/alarms/alarm-groups/'
      preLoaderRoute: typeof AccountIdUserAlarmsAlarmGroupsIndexRouteImport
      parentRoute: typeof AccountIdUserAlarmsAlarmGroupsRouteRoute
    }
    '/$accountId/_user/account/services/': {
      id: '/$accountId/_user/account/services/'
      path: '/'
      fullPath: '/$accountId/account/services/'
      preLoaderRoute: typeof AccountIdUserAccountServicesIndexRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/'
      path: '/'
      fullPath: '/$accountId/service-manager/$managedAccountId/'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdIndexRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/operations/quality-of-service/': {
      id: '/$accountId/_admin/operations/quality-of-service/'
      path: '/quality-of-service'
      fullPath: '/$accountId/operations/quality-of-service/'
      preLoaderRoute: typeof AccountIdAdminOperationsQualityOfServiceIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_admin/operations/predictive-heat-control/': {
      id: '/$accountId/_admin/operations/predictive-heat-control/'
      path: '/'
      fullPath: '/$accountId/operations/predictive-heat-control/'
      preLoaderRoute: typeof AccountIdAdminOperationsPredictiveHeatControlIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRoute
    }
    '/$accountId/_admin/operations/portfolio-analysis/': {
      id: '/$accountId/_admin/operations/portfolio-analysis/'
      path: '/portfolio-analysis'
      fullPath: '/$accountId/operations/portfolio-analysis/'
      preLoaderRoute: typeof AccountIdAdminOperationsPortfolioAnalysisIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_admin/operations/deep-dive/': {
      id: '/$accountId/_admin/operations/deep-dive/'
      path: '/deep-dive'
      fullPath: '/$accountId/operations/deep-dive/'
      preLoaderRoute: typeof AccountIdAdminOperationsDeepDiveIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_admin/devices/€deviceId/': {
      id: '/$accountId/_admin/devices/€deviceId/'
      path: '/€deviceId'
      fullPath: '/$accountId/devices/€deviceId/'
      preLoaderRoute: typeof AccountIdAdminDevicesChar8364deviceIdIndexRouteImport
      parentRoute: typeof AccountIdAdminDevicesRouteRoute
    }
    '/$accountId/_admin/devices/$deviceId/': {
      id: '/$accountId/_admin/devices/$deviceId/'
      path: '/$deviceId'
      fullPath: '/$accountId/devices/$deviceId/'
      preLoaderRoute: typeof AccountIdAdminDevicesDeviceIdIndexRouteImport
      parentRoute: typeof AccountIdAdminDevicesRouteRoute
    }
    '/$accountId/_user/units/$unitId/edit': {
      id: '/$accountId/_user/units/$unitId/edit'
      path: '/edit'
      fullPath: '/$accountId/units/$unitId/edit'
      preLoaderRoute: typeof AccountIdUserUnitsUnitIdEditRouteImport
      parentRoute: typeof AccountIdUserUnitsUnitIdRouteRoute
    }
    '/$accountId/_user/gateways/$gatewayId/edit': {
      id: '/$accountId/_user/gateways/$gatewayId/edit'
      path: '/edit'
      fullPath: '/$accountId/gateways/$gatewayId/edit'
      preLoaderRoute: typeof AccountIdUserGatewaysGatewayIdEditRouteImport
      parentRoute: typeof AccountIdUserGatewaysGatewayIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/dashboard': {
      id: '/$accountId/_user/energyxplorer/portfolio/dashboard'
      path: '/dashboard'
      fullPath: '/$accountId/energyxplorer/portfolio/dashboard'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioDashboardRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/dashboard': {
      id: '/$accountId/_user/energyxplorer/deepdive/dashboard'
      path: '/dashboard'
      fullPath: '/$accountId/energyxplorer/deepdive/dashboard'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveDashboardRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/create': {
      id: '/$accountId/_user/energyxplorer/deepdive/create'
      path: '/create'
      fullPath: '/$accountId/energyxplorer/deepdive/create'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveCreateRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveRouteRoute
    }
    '/$accountId/_user/energyxplorer/alarms/$alarmId': {
      id: '/$accountId/_user/energyxplorer/alarms/$alarmId'
      path: '/$alarmId'
      fullPath: '/$accountId/energyxplorer/alarms/$alarmId'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerAlarmsAlarmIdRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerAlarmsRouteRoute
    }
    '/$accountId/_user/eforsyning-integration/$integrationId/edit': {
      id: '/$accountId/_user/eforsyning-integration/$integrationId/edit'
      path: '/$integrationId/edit'
      fullPath: '/$accountId/eforsyning-integration/$integrationId/edit'
      preLoaderRoute: typeof AccountIdUserEforsyningIntegrationIntegrationIdEditRouteImport
      parentRoute: typeof AccountIdUserEforsyningIntegrationRouteRoute
    }
    '/$accountId/_user/alarms/configuration/$alarmConfigurationId': {
      id: '/$accountId/_user/alarms/configuration/$alarmConfigurationId'
      path: '/$alarmConfigurationId'
      fullPath: '/$accountId/alarms/configuration/$alarmConfigurationId'
      preLoaderRoute: typeof AccountIdUserAlarmsConfigurationAlarmConfigurationIdRouteImport
      parentRoute: typeof AccountIdUserAlarmsConfigurationRouteRoute
    }
    '/$accountId/_user/alarms/alarm-groups/create': {
      id: '/$accountId/_user/alarms/alarm-groups/create'
      path: '/create'
      fullPath: '/$accountId/alarms/alarm-groups/create'
      preLoaderRoute: typeof AccountIdUserAlarmsAlarmGroupsCreateRouteImport
      parentRoute: typeof AccountIdUserAlarmsAlarmGroupsRouteRoute
    }
    '/$accountId/_user/alarms/alarm-groups/$groupId': {
      id: '/$accountId/_user/alarms/alarm-groups/$groupId'
      path: '/$groupId'
      fullPath: '/$accountId/alarms/alarm-groups/$groupId'
      preLoaderRoute: typeof AccountIdUserAlarmsAlarmGroupsGroupIdRouteImport
      parentRoute: typeof AccountIdUserAlarmsAlarmGroupsRouteRoute
    }
    '/$accountId/_user/account/services/scheduler': {
      id: '/$accountId/_user/account/services/scheduler'
      path: '/scheduler'
      fullPath: '/$accountId/account/services/scheduler'
      preLoaderRoute: typeof AccountIdUserAccountServicesSchedulerRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/predictive-heat-control': {
      id: '/$accountId/_user/account/services/predictive-heat-control'
      path: '/predictive-heat-control'
      fullPath: '/$accountId/account/services/predictive-heat-control'
      preLoaderRoute: typeof AccountIdUserAccountServicesPredictiveHeatControlRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/powerbi': {
      id: '/$accountId/_user/account/services/powerbi'
      path: '/powerbi'
      fullPath: '/$accountId/account/services/powerbi'
      preLoaderRoute: typeof AccountIdUserAccountServicesPowerbiRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/portfolio-analysis': {
      id: '/$accountId/_user/account/services/portfolio-analysis'
      path: '/portfolio-analysis'
      fullPath: '/$accountId/account/services/portfolio-analysis'
      preLoaderRoute: typeof AccountIdUserAccountServicesPortfolioAnalysisRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/jyskenergiesg': {
      id: '/$accountId/_user/account/services/jyskenergiesg'
      path: '/jyskenergiesg'
      fullPath: '/$accountId/account/services/jyskenergiesg'
      preLoaderRoute: typeof AccountIdUserAccountServicesJyskenergiesgRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/energyxplorer-analytics': {
      id: '/$accountId/_user/account/services/energyxplorer-analytics'
      path: '/energyxplorer-analytics'
      fullPath: '/$accountId/account/services/energyxplorer-analytics'
      preLoaderRoute: typeof AccountIdUserAccountServicesEnergyxplorerAnalyticsRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/energyxplorer': {
      id: '/$accountId/_user/account/services/energyxplorer'
      path: '/energyxplorer'
      fullPath: '/$accountId/account/services/energyxplorer'
      preLoaderRoute: typeof AccountIdUserAccountServicesEnergyxplorerRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/devices': {
      id: '/$accountId/_user/account/services/devices'
      path: '/devices'
      fullPath: '/$accountId/account/services/devices'
      preLoaderRoute: typeof AccountIdUserAccountServicesDevicesRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/datahub-integration': {
      id: '/$accountId/_user/account/services/datahub-integration'
      path: '/datahub-integration'
      fullPath: '/$accountId/account/services/datahub-integration'
      preLoaderRoute: typeof AccountIdUserAccountServicesDatahubIntegrationRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/dashboard-water-basic': {
      id: '/$accountId/_user/account/services/dashboard-water-basic'
      path: '/dashboard-water-basic'
      fullPath: '/$accountId/account/services/dashboard-water-basic'
      preLoaderRoute: typeof AccountIdUserAccountServicesDashboardWaterBasicRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/dashboard-power-basic': {
      id: '/$accountId/_user/account/services/dashboard-power-basic'
      path: '/dashboard-power-basic'
      fullPath: '/$accountId/account/services/dashboard-power-basic'
      preLoaderRoute: typeof AccountIdUserAccountServicesDashboardPowerBasicRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/dashboard-heat-basic': {
      id: '/$accountId/_user/account/services/dashboard-heat-basic'
      path: '/dashboard-heat-basic'
      fullPath: '/$accountId/account/services/dashboard-heat-basic'
      preLoaderRoute: typeof AccountIdUserAccountServicesDashboardHeatBasicRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/compressed-air': {
      id: '/$accountId/_user/account/services/compressed-air'
      path: '/compressed-air'
      fullPath: '/$accountId/account/services/compressed-air'
      preLoaderRoute: typeof AccountIdUserAccountServicesCompressedAirRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/basis': {
      id: '/$accountId/_user/account/services/basis'
      path: '/basis'
      fullPath: '/$accountId/account/services/basis'
      preLoaderRoute: typeof AccountIdUserAccountServicesBasisRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/basic-dashboards': {
      id: '/$accountId/_user/account/services/basic-dashboards'
      path: '/basic-dashboards'
      fullPath: '/$accountId/account/services/basic-dashboards'
      preLoaderRoute: typeof AccountIdUserAccountServicesBasicDashboardsRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/analytics': {
      id: '/$accountId/_user/account/services/analytics'
      path: '/analytics'
      fullPath: '/$accountId/account/services/analytics'
      preLoaderRoute: typeof AccountIdUserAccountServicesAnalyticsRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_user/account/services/alarms': {
      id: '/$accountId/_user/account/services/alarms'
      path: '/alarms'
      fullPath: '/$accountId/account/services/alarms'
      preLoaderRoute: typeof AccountIdUserAccountServicesAlarmsRouteImport
      parentRoute: typeof AccountIdUserAccountServicesRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/scheduler': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/scheduler'
      path: '/scheduler'
      fullPath: '/$accountId/service-manager/$managedAccountId/scheduler'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdSchedulerRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/predictive-heat-control': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/predictive-heat-control'
      path: '/predictive-heat-control'
      fullPath: '/$accountId/service-manager/$managedAccountId/predictive-heat-control'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/powerbi': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/powerbi'
      path: '/powerbi'
      fullPath: '/$accountId/service-manager/$managedAccountId/powerbi'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdPowerbiRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/portfolio-analysis': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/portfolio-analysis'
      path: '/portfolio-analysis'
      fullPath: '/$accountId/service-manager/$managedAccountId/portfolio-analysis'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/jyskenergiesg': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/jyskenergiesg'
      path: '/jyskenergiesg'
      fullPath: '/$accountId/service-manager/$managedAccountId/jyskenergiesg'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer-analytics': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer-analytics'
      path: '/energyxplorer-analytics'
      fullPath: '/$accountId/service-manager/$managedAccountId/energyxplorer-analytics'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer'
      path: '/energyxplorer'
      fullPath: '/$accountId/service-manager/$managedAccountId/energyxplorer'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/eforsyning-integration': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/eforsyning-integration'
      path: '/eforsyning-integration'
      fullPath: '/$accountId/service-manager/$managedAccountId/eforsyning-integration'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/devices': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/devices'
      path: '/devices'
      fullPath: '/$accountId/service-manager/$managedAccountId/devices'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDevicesRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/datahub-integration': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/datahub-integration'
      path: '/datahub-integration'
      fullPath: '/$accountId/service-manager/$managedAccountId/datahub-integration'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/dashboard-water-basic': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/dashboard-water-basic'
      path: '/dashboard-water-basic'
      fullPath: '/$accountId/service-manager/$managedAccountId/dashboard-water-basic'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/dashboard-power-basic': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/dashboard-power-basic'
      path: '/dashboard-power-basic'
      fullPath: '/$accountId/service-manager/$managedAccountId/dashboard-power-basic'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/dashboard-heat-basic': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/dashboard-heat-basic'
      path: '/dashboard-heat-basic'
      fullPath: '/$accountId/service-manager/$managedAccountId/dashboard-heat-basic'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/compressed-air': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/compressed-air'
      path: '/compressed-air'
      fullPath: '/$accountId/service-manager/$managedAccountId/compressed-air'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdCompressedAirRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/basis': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/basis'
      path: '/basis'
      fullPath: '/$accountId/service-manager/$managedAccountId/basis'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdBasisRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/basic-dashboards': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/basic-dashboards'
      path: '/basic-dashboards'
      fullPath: '/$accountId/service-manager/$managedAccountId/basic-dashboards'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/analytics': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/analytics'
      path: '/analytics'
      fullPath: '/$accountId/service-manager/$managedAccountId/analytics'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdAnalyticsRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/service-manager/$managedAccountId/alarms': {
      id: '/$accountId/_admin/service-manager/$managedAccountId/alarms'
      path: '/alarms'
      fullPath: '/$accountId/service-manager/$managedAccountId/alarms'
      preLoaderRoute: typeof AccountIdAdminServiceManagerManagedAccountIdAlarmsRouteImport
      parentRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRoute
    }
    '/$accountId/_admin/operations/deep-dive/$groupId': {
      id: '/$accountId/_admin/operations/deep-dive/$groupId'
      path: '/deep-dive/$groupId'
      fullPath: '/$accountId/operations/deep-dive/$groupId'
      preLoaderRoute: typeof AccountIdAdminOperationsDeepDiveGroupIdRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_admin/devices/$deviceId/edit': {
      id: '/$accountId/_admin/devices/$deviceId/edit'
      path: '/$deviceId/edit'
      fullPath: '/$accountId/devices/$deviceId/edit'
      preLoaderRoute: typeof AccountIdAdminDevicesDeviceIdEditRouteImport
      parentRoute: typeof AccountIdAdminDevicesRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType'
      path: '/$analysisType'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId'
      path: '/$energyGroupId'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveRouteRoute
    }
    '/$accountId/_user/energyxplorer/alarms/advanced': {
      id: '/$accountId/_user/energyxplorer/alarms/advanced'
      path: '/advanced'
      fullPath: '/$accountId/energyxplorer/alarms/advanced'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerAlarmsRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/overview/': {
      id: '/$accountId/_user/energyxplorer/portfolio/overview/'
      path: '/overview'
      fullPath: '/$accountId/energyxplorer/portfolio/overview/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioOverviewIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/'
      path: '/'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/'
      path: '/'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/alarms/advanced/': {
      id: '/$accountId/_user/energyxplorer/alarms/advanced/'
      path: '/'
      fullPath: '/$accountId/energyxplorer/alarms/advanced/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute
    }
    '/$accountId/_admin/operations/predictive-heat-control/subscriptions/': {
      id: '/$accountId/_admin/operations/predictive-heat-control/subscriptions/'
      path: '/subscriptions'
      fullPath: '/$accountId/operations/predictive-heat-control/subscriptions/'
      preLoaderRoute: typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRoute
    }
    '/$accountId/_admin/operations/predictive-heat-control/groups/': {
      id: '/$accountId/_admin/operations/predictive-heat-control/groups/'
      path: '/groups'
      fullPath: '/$accountId/operations/predictive-heat-control/groups/'
      preLoaderRoute: typeof AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRoute
    }
    '/$accountId/_admin/operations/predictive-heat-control/buildings/': {
      id: '/$accountId/_admin/operations/predictive-heat-control/buildings/'
      path: '/buildings'
      fullPath: '/$accountId/operations/predictive-heat-control/buildings/'
      preLoaderRoute: typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/site/create': {
      id: '/$accountId/_user/energyxplorer/portfolio/site/create'
      path: '/site/create'
      fullPath: '/$accountId/energyxplorer/portfolio/site/create'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioSiteCreateRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/overview/standard': {
      id: '/$accountId/_user/energyxplorer/portfolio/overview/standard'
      path: '/overview/standard'
      fullPath: '/$accountId/energyxplorer/portfolio/overview/standard'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioOverviewStandardRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/overview/building': {
      id: '/$accountId/_user/energyxplorer/portfolio/overview/building'
      path: '/overview/building'
      fullPath: '/$accountId/energyxplorer/portfolio/overview/building'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioOverviewBuildingRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/pivot': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/pivot'
      path: '/pivot'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/pivot'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/load-profile-analysis': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/load-profile-analysis'
      path: '/load-profile-analysis'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/load-profile-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/hour-analysis': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/hour-analysis'
      path: '/hour-analysis'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/hour-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/esg': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/esg'
      path: '/esg'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/esg'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table'
      path: '/energy-breakdown-table'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown-table'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-breakdown'
      path: '/energy-breakdown'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-breakdown'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-analysis': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-analysis'
      path: '/energy-analysis'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/edit': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/edit'
      path: '/edit'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/edit'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/duration-analysis': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/duration-analysis'
      path: '/duration-analysis'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/duration-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/create-first-node': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/create-first-node'
      path: '/create-first-node'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/create-first-node'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/consumption-overview': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/consumption-overview'
      path: '/consumption-overview'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/consumption-overview'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/comparison-analysis': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/comparison-analysis'
      path: '/comparison-analysis'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/comparison-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/child-analysis': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/child-analysis'
      path: '/child-analysis'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/child-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/alarms/advanced/create': {
      id: '/$accountId/_user/energyxplorer/alarms/advanced/create'
      path: '/create'
      fullPath: '/$accountId/energyxplorer/alarms/advanced/create'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedCreateRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute
    }
    '/$accountId/_user/energyxplorer/alarms/advanced/$groupId': {
      id: '/$accountId/_user/energyxplorer/alarms/advanced/$groupId'
      path: '/$groupId'
      fullPath: '/$accountId/energyxplorer/alarms/advanced/$groupId'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute
    }
    '/$accountId/_user/alarms/configuration/create/$alarmTypeId': {
      id: '/$accountId/_user/alarms/configuration/create/$alarmTypeId'
      path: '/create/$alarmTypeId'
      fullPath: '/$accountId/alarms/configuration/create/$alarmTypeId'
      preLoaderRoute: typeof AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRouteImport
      parentRoute: typeof AccountIdUserAlarmsConfigurationRouteRoute
    }
    '/$accountId/_admin/operations/predictive-heat-control/groups/$groupKey': {
      id: '/$accountId/_admin/operations/predictive-heat-control/groups/$groupKey'
      path: '/groups/$groupKey'
      fullPath: '/$accountId/operations/predictive-heat-control/groups/$groupKey'
      preLoaderRoute: typeof AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRouteImport
      parentRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRoute
    }
    '/$accountId/_admin/operations/predictive-heat-control/buildings/$buildingName': {
      id: '/$accountId/_admin/operations/predictive-heat-control/buildings/$buildingName'
      path: '/buildings/$buildingName'
      fullPath: '/$accountId/operations/predictive-heat-control/buildings/$buildingName'
      preLoaderRoute: typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRouteImport
      parentRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId'
      path: '/$energyGroupId'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives'
      path: '/energy-initiatives'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/'
      path: '/analysis'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/analysis/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/'
      path: '/'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/'
      path: '/'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute
    }
    '/$accountId/_admin/operations/predictive-heat-control/subscriptions/$subscriptionName/': {
      id: '/$accountId/_admin/operations/predictive-heat-control/subscriptions/$subscriptionName/'
      path: '/subscriptions/$subscriptionName'
      fullPath: '/$accountId/operations/predictive-heat-control/subscriptions/$subscriptionName/'
      preLoaderRoute: typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRoute
    }
    '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/': {
      id: '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/'
      path: '/portfolio-analysis/utility-providers/water'
      fullPath: '/$accountId/operations/portfolio-analysis/utility-providers/water/'
      preLoaderRoute: typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/': {
      id: '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/'
      path: '/portfolio-analysis/utility-providers/heat'
      fullPath: '/$accountId/operations/portfolio-analysis/utility-providers/heat/'
      preLoaderRoute: typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/$preset': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/analysis/$preset'
      path: '/analysis/$preset'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/analysis/$preset'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis'
      path: '/load-profile-analysis'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/load-profile-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis'
      path: '/hour-analysis'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/hour-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/esg': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/esg'
      path: '/esg'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/esg'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table'
      path: '/energy-breakdown-table'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown-table'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown'
      path: '/energy-breakdown'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis'
      path: '/energy-analysis'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis'
      path: '/duration-analysis'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis'
      path: '/comparison-analysis'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis': {
      id: '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis'
      path: '/child-analysis'
      fullPath: '/$accountId/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create'
      path: '/create'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/create'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute
    }
    '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/$providerId': {
      id: '/$accountId/_admin/operations/portfolio-analysis/utility-providers/water/$providerId'
      path: '/portfolio-analysis/utility-providers/water/$providerId'
      fullPath: '/$accountId/operations/portfolio-analysis/utility-providers/water/$providerId'
      preLoaderRoute: typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/$providerId': {
      id: '/$accountId/_admin/operations/portfolio-analysis/utility-providers/heat/$providerId'
      path: '/portfolio-analysis/utility-providers/heat/$providerId'
      fullPath: '/$accountId/operations/portfolio-analysis/utility-providers/heat/$providerId'
      preLoaderRoute: typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRouteImport
      parentRoute: typeof AccountIdAdminOperationsRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/'
      path: '/$initiativeId'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute
    }
    '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit': {
      id: '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit'
      path: '/$initiativeId/edit'
      fullPath: '/$accountId/energyxplorer/deepdive/$energyGroupId/energy-initiatives/$initiativeId/edit'
      preLoaderRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRouteImport
      parentRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute
    }
  }
}

interface AccountIdAdminDevicesRouteRouteChildren {
  AccountIdAdminDevicesRegisterRoute: typeof AccountIdAdminDevicesRegisterRoute
  AccountIdAdminDevicesIndexRoute: typeof AccountIdAdminDevicesIndexRoute
  AccountIdAdminDevicesDeviceIdEditRoute: typeof AccountIdAdminDevicesDeviceIdEditRoute
  AccountIdAdminDevicesDeviceIdIndexRoute: typeof AccountIdAdminDevicesDeviceIdIndexRoute
  AccountIdAdminDevicesChar8364deviceIdIndexRoute: typeof AccountIdAdminDevicesChar8364deviceIdIndexRoute
}

const AccountIdAdminDevicesRouteRouteChildren: AccountIdAdminDevicesRouteRouteChildren =
  {
    AccountIdAdminDevicesRegisterRoute: AccountIdAdminDevicesRegisterRoute,
    AccountIdAdminDevicesIndexRoute: AccountIdAdminDevicesIndexRoute,
    AccountIdAdminDevicesDeviceIdEditRoute:
      AccountIdAdminDevicesDeviceIdEditRoute,
    AccountIdAdminDevicesDeviceIdIndexRoute:
      AccountIdAdminDevicesDeviceIdIndexRoute,
    AccountIdAdminDevicesChar8364deviceIdIndexRoute:
      AccountIdAdminDevicesChar8364deviceIdIndexRoute,
  }

const AccountIdAdminDevicesRouteRouteWithChildren =
  AccountIdAdminDevicesRouteRoute._addFileChildren(
    AccountIdAdminDevicesRouteRouteChildren,
  )

interface AccountIdAdminOperationsPredictiveHeatControlRouteRouteChildren {
  AccountIdAdminOperationsPredictiveHeatControlIndexRoute: typeof AccountIdAdminOperationsPredictiveHeatControlIndexRoute
  AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRoute: typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRoute
  AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRoute: typeof AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRoute
  AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRoute: typeof AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRoute
  AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRoute: typeof AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRoute
  AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRoute: typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRoute
  AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRoute: typeof AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRoute
}

const AccountIdAdminOperationsPredictiveHeatControlRouteRouteChildren: AccountIdAdminOperationsPredictiveHeatControlRouteRouteChildren =
  {
    AccountIdAdminOperationsPredictiveHeatControlIndexRoute:
      AccountIdAdminOperationsPredictiveHeatControlIndexRoute,
    AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRoute:
      AccountIdAdminOperationsPredictiveHeatControlBuildingsBuildingNameRoute,
    AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRoute:
      AccountIdAdminOperationsPredictiveHeatControlGroupsGroupKeyRoute,
    AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRoute:
      AccountIdAdminOperationsPredictiveHeatControlBuildingsIndexRoute,
    AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRoute:
      AccountIdAdminOperationsPredictiveHeatControlGroupsIndexRoute,
    AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRoute:
      AccountIdAdminOperationsPredictiveHeatControlSubscriptionsIndexRoute,
    AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRoute:
      AccountIdAdminOperationsPredictiveHeatControlSubscriptionsSubscriptionNameIndexRoute,
  }

const AccountIdAdminOperationsPredictiveHeatControlRouteRouteWithChildren =
  AccountIdAdminOperationsPredictiveHeatControlRouteRoute._addFileChildren(
    AccountIdAdminOperationsPredictiveHeatControlRouteRouteChildren,
  )

interface AccountIdAdminOperationsRouteRouteChildren {
  AccountIdAdminOperationsPredictiveHeatControlRouteRoute: typeof AccountIdAdminOperationsPredictiveHeatControlRouteRouteWithChildren
  AccountIdAdminOperationsIndexRoute: typeof AccountIdAdminOperationsIndexRoute
  AccountIdAdminOperationsDeepDiveGroupIdRoute: typeof AccountIdAdminOperationsDeepDiveGroupIdRoute
  AccountIdAdminOperationsDeepDiveIndexRoute: typeof AccountIdAdminOperationsDeepDiveIndexRoute
  AccountIdAdminOperationsPortfolioAnalysisIndexRoute: typeof AccountIdAdminOperationsPortfolioAnalysisIndexRoute
  AccountIdAdminOperationsQualityOfServiceIndexRoute: typeof AccountIdAdminOperationsQualityOfServiceIndexRoute
  AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRoute: typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRoute
  AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRoute: typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRoute
  AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRoute: typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRoute
  AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRoute: typeof AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRoute
}

const AccountIdAdminOperationsRouteRouteChildren: AccountIdAdminOperationsRouteRouteChildren =
  {
    AccountIdAdminOperationsPredictiveHeatControlRouteRoute:
      AccountIdAdminOperationsPredictiveHeatControlRouteRouteWithChildren,
    AccountIdAdminOperationsIndexRoute: AccountIdAdminOperationsIndexRoute,
    AccountIdAdminOperationsDeepDiveGroupIdRoute:
      AccountIdAdminOperationsDeepDiveGroupIdRoute,
    AccountIdAdminOperationsDeepDiveIndexRoute:
      AccountIdAdminOperationsDeepDiveIndexRoute,
    AccountIdAdminOperationsPortfolioAnalysisIndexRoute:
      AccountIdAdminOperationsPortfolioAnalysisIndexRoute,
    AccountIdAdminOperationsQualityOfServiceIndexRoute:
      AccountIdAdminOperationsQualityOfServiceIndexRoute,
    AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRoute:
      AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatProviderIdRoute,
    AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRoute:
      AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterProviderIdRoute,
    AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRoute:
      AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersHeatIndexRoute,
    AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRoute:
      AccountIdAdminOperationsPortfolioAnalysisUtilityProvidersWaterIndexRoute,
  }

const AccountIdAdminOperationsRouteRouteWithChildren =
  AccountIdAdminOperationsRouteRoute._addFileChildren(
    AccountIdAdminOperationsRouteRouteChildren,
  )

interface AccountIdAdminServiceManagerManagedAccountIdRouteChildren {
  AccountIdAdminServiceManagerManagedAccountIdAlarmsRoute: typeof AccountIdAdminServiceManagerManagedAccountIdAlarmsRoute
  AccountIdAdminServiceManagerManagedAccountIdAnalyticsRoute: typeof AccountIdAdminServiceManagerManagedAccountIdAnalyticsRoute
  AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRoute: typeof AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRoute
  AccountIdAdminServiceManagerManagedAccountIdBasisRoute: typeof AccountIdAdminServiceManagerManagedAccountIdBasisRoute
  AccountIdAdminServiceManagerManagedAccountIdCompressedAirRoute: typeof AccountIdAdminServiceManagerManagedAccountIdCompressedAirRoute
  AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRoute
  AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRoute
  AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRoute
  AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRoute
  AccountIdAdminServiceManagerManagedAccountIdDevicesRoute: typeof AccountIdAdminServiceManagerManagedAccountIdDevicesRoute
  AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRoute: typeof AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRoute
  AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRoute: typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRoute
  AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRoute: typeof AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRoute
  AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRoute: typeof AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRoute
  AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRoute: typeof AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRoute
  AccountIdAdminServiceManagerManagedAccountIdPowerbiRoute: typeof AccountIdAdminServiceManagerManagedAccountIdPowerbiRoute
  AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRoute: typeof AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRoute
  AccountIdAdminServiceManagerManagedAccountIdSchedulerRoute: typeof AccountIdAdminServiceManagerManagedAccountIdSchedulerRoute
  AccountIdAdminServiceManagerManagedAccountIdIndexRoute: typeof AccountIdAdminServiceManagerManagedAccountIdIndexRoute
}

const AccountIdAdminServiceManagerManagedAccountIdRouteChildren: AccountIdAdminServiceManagerManagedAccountIdRouteChildren =
  {
    AccountIdAdminServiceManagerManagedAccountIdAlarmsRoute:
      AccountIdAdminServiceManagerManagedAccountIdAlarmsRoute,
    AccountIdAdminServiceManagerManagedAccountIdAnalyticsRoute:
      AccountIdAdminServiceManagerManagedAccountIdAnalyticsRoute,
    AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRoute:
      AccountIdAdminServiceManagerManagedAccountIdBasicDashboardsRoute,
    AccountIdAdminServiceManagerManagedAccountIdBasisRoute:
      AccountIdAdminServiceManagerManagedAccountIdBasisRoute,
    AccountIdAdminServiceManagerManagedAccountIdCompressedAirRoute:
      AccountIdAdminServiceManagerManagedAccountIdCompressedAirRoute,
    AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRoute:
      AccountIdAdminServiceManagerManagedAccountIdDashboardHeatBasicRoute,
    AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRoute:
      AccountIdAdminServiceManagerManagedAccountIdDashboardPowerBasicRoute,
    AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRoute:
      AccountIdAdminServiceManagerManagedAccountIdDashboardWaterBasicRoute,
    AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRoute:
      AccountIdAdminServiceManagerManagedAccountIdDatahubIntegrationRoute,
    AccountIdAdminServiceManagerManagedAccountIdDevicesRoute:
      AccountIdAdminServiceManagerManagedAccountIdDevicesRoute,
    AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRoute:
      AccountIdAdminServiceManagerManagedAccountIdEforsyningIntegrationRoute,
    AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRoute:
      AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerRoute,
    AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRoute:
      AccountIdAdminServiceManagerManagedAccountIdEnergyxplorerAnalyticsRoute,
    AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRoute:
      AccountIdAdminServiceManagerManagedAccountIdJyskenergiesgRoute,
    AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRoute:
      AccountIdAdminServiceManagerManagedAccountIdPortfolioAnalysisRoute,
    AccountIdAdminServiceManagerManagedAccountIdPowerbiRoute:
      AccountIdAdminServiceManagerManagedAccountIdPowerbiRoute,
    AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRoute:
      AccountIdAdminServiceManagerManagedAccountIdPredictiveHeatControlRoute,
    AccountIdAdminServiceManagerManagedAccountIdSchedulerRoute:
      AccountIdAdminServiceManagerManagedAccountIdSchedulerRoute,
    AccountIdAdminServiceManagerManagedAccountIdIndexRoute:
      AccountIdAdminServiceManagerManagedAccountIdIndexRoute,
  }

const AccountIdAdminServiceManagerManagedAccountIdRouteWithChildren =
  AccountIdAdminServiceManagerManagedAccountIdRoute._addFileChildren(
    AccountIdAdminServiceManagerManagedAccountIdRouteChildren,
  )

interface AccountIdAdminServiceManagerRouteRouteChildren {
  AccountIdAdminServiceManagerManagedAccountIdRoute: typeof AccountIdAdminServiceManagerManagedAccountIdRouteWithChildren
  AccountIdAdminServiceManagerIndexRoute: typeof AccountIdAdminServiceManagerIndexRoute
}

const AccountIdAdminServiceManagerRouteRouteChildren: AccountIdAdminServiceManagerRouteRouteChildren =
  {
    AccountIdAdminServiceManagerManagedAccountIdRoute:
      AccountIdAdminServiceManagerManagedAccountIdRouteWithChildren,
    AccountIdAdminServiceManagerIndexRoute:
      AccountIdAdminServiceManagerIndexRoute,
  }

const AccountIdAdminServiceManagerRouteRouteWithChildren =
  AccountIdAdminServiceManagerRouteRoute._addFileChildren(
    AccountIdAdminServiceManagerRouteRouteChildren,
  )

interface AccountIdAdminRouteRouteChildren {
  AccountIdAdminDevicesRouteRoute: typeof AccountIdAdminDevicesRouteRouteWithChildren
  AccountIdAdminOperationsRouteRoute: typeof AccountIdAdminOperationsRouteRouteWithChildren
  AccountIdAdminServiceManagerRouteRoute: typeof AccountIdAdminServiceManagerRouteRouteWithChildren
}

const AccountIdAdminRouteRouteChildren: AccountIdAdminRouteRouteChildren = {
  AccountIdAdminDevicesRouteRoute: AccountIdAdminDevicesRouteRouteWithChildren,
  AccountIdAdminOperationsRouteRoute:
    AccountIdAdminOperationsRouteRouteWithChildren,
  AccountIdAdminServiceManagerRouteRoute:
    AccountIdAdminServiceManagerRouteRouteWithChildren,
}

const AccountIdAdminRouteRouteWithChildren =
  AccountIdAdminRouteRoute._addFileChildren(AccountIdAdminRouteRouteChildren)

interface AccountIdUserAccountServicesRouteChildren {
  AccountIdUserAccountServicesAlarmsRoute: typeof AccountIdUserAccountServicesAlarmsRoute
  AccountIdUserAccountServicesAnalyticsRoute: typeof AccountIdUserAccountServicesAnalyticsRoute
  AccountIdUserAccountServicesBasicDashboardsRoute: typeof AccountIdUserAccountServicesBasicDashboardsRoute
  AccountIdUserAccountServicesBasisRoute: typeof AccountIdUserAccountServicesBasisRoute
  AccountIdUserAccountServicesCompressedAirRoute: typeof AccountIdUserAccountServicesCompressedAirRoute
  AccountIdUserAccountServicesDashboardHeatBasicRoute: typeof AccountIdUserAccountServicesDashboardHeatBasicRoute
  AccountIdUserAccountServicesDashboardPowerBasicRoute: typeof AccountIdUserAccountServicesDashboardPowerBasicRoute
  AccountIdUserAccountServicesDashboardWaterBasicRoute: typeof AccountIdUserAccountServicesDashboardWaterBasicRoute
  AccountIdUserAccountServicesDatahubIntegrationRoute: typeof AccountIdUserAccountServicesDatahubIntegrationRoute
  AccountIdUserAccountServicesDevicesRoute: typeof AccountIdUserAccountServicesDevicesRoute
  AccountIdUserAccountServicesEnergyxplorerRoute: typeof AccountIdUserAccountServicesEnergyxplorerRoute
  AccountIdUserAccountServicesEnergyxplorerAnalyticsRoute: typeof AccountIdUserAccountServicesEnergyxplorerAnalyticsRoute
  AccountIdUserAccountServicesJyskenergiesgRoute: typeof AccountIdUserAccountServicesJyskenergiesgRoute
  AccountIdUserAccountServicesPortfolioAnalysisRoute: typeof AccountIdUserAccountServicesPortfolioAnalysisRoute
  AccountIdUserAccountServicesPowerbiRoute: typeof AccountIdUserAccountServicesPowerbiRoute
  AccountIdUserAccountServicesPredictiveHeatControlRoute: typeof AccountIdUserAccountServicesPredictiveHeatControlRoute
  AccountIdUserAccountServicesSchedulerRoute: typeof AccountIdUserAccountServicesSchedulerRoute
  AccountIdUserAccountServicesIndexRoute: typeof AccountIdUserAccountServicesIndexRoute
}

const AccountIdUserAccountServicesRouteChildren: AccountIdUserAccountServicesRouteChildren =
  {
    AccountIdUserAccountServicesAlarmsRoute:
      AccountIdUserAccountServicesAlarmsRoute,
    AccountIdUserAccountServicesAnalyticsRoute:
      AccountIdUserAccountServicesAnalyticsRoute,
    AccountIdUserAccountServicesBasicDashboardsRoute:
      AccountIdUserAccountServicesBasicDashboardsRoute,
    AccountIdUserAccountServicesBasisRoute:
      AccountIdUserAccountServicesBasisRoute,
    AccountIdUserAccountServicesCompressedAirRoute:
      AccountIdUserAccountServicesCompressedAirRoute,
    AccountIdUserAccountServicesDashboardHeatBasicRoute:
      AccountIdUserAccountServicesDashboardHeatBasicRoute,
    AccountIdUserAccountServicesDashboardPowerBasicRoute:
      AccountIdUserAccountServicesDashboardPowerBasicRoute,
    AccountIdUserAccountServicesDashboardWaterBasicRoute:
      AccountIdUserAccountServicesDashboardWaterBasicRoute,
    AccountIdUserAccountServicesDatahubIntegrationRoute:
      AccountIdUserAccountServicesDatahubIntegrationRoute,
    AccountIdUserAccountServicesDevicesRoute:
      AccountIdUserAccountServicesDevicesRoute,
    AccountIdUserAccountServicesEnergyxplorerRoute:
      AccountIdUserAccountServicesEnergyxplorerRoute,
    AccountIdUserAccountServicesEnergyxplorerAnalyticsRoute:
      AccountIdUserAccountServicesEnergyxplorerAnalyticsRoute,
    AccountIdUserAccountServicesJyskenergiesgRoute:
      AccountIdUserAccountServicesJyskenergiesgRoute,
    AccountIdUserAccountServicesPortfolioAnalysisRoute:
      AccountIdUserAccountServicesPortfolioAnalysisRoute,
    AccountIdUserAccountServicesPowerbiRoute:
      AccountIdUserAccountServicesPowerbiRoute,
    AccountIdUserAccountServicesPredictiveHeatControlRoute:
      AccountIdUserAccountServicesPredictiveHeatControlRoute,
    AccountIdUserAccountServicesSchedulerRoute:
      AccountIdUserAccountServicesSchedulerRoute,
    AccountIdUserAccountServicesIndexRoute:
      AccountIdUserAccountServicesIndexRoute,
  }

const AccountIdUserAccountServicesRouteWithChildren =
  AccountIdUserAccountServicesRoute._addFileChildren(
    AccountIdUserAccountServicesRouteChildren,
  )

interface AccountIdUserAccountRouteRouteChildren {
  AccountIdUserAccountProfileRoute: typeof AccountIdUserAccountProfileRoute
  AccountIdUserAccountServicesRoute: typeof AccountIdUserAccountServicesRouteWithChildren
  AccountIdUserAccountUsersRoute: typeof AccountIdUserAccountUsersRoute
}

const AccountIdUserAccountRouteRouteChildren: AccountIdUserAccountRouteRouteChildren =
  {
    AccountIdUserAccountProfileRoute: AccountIdUserAccountProfileRoute,
    AccountIdUserAccountServicesRoute:
      AccountIdUserAccountServicesRouteWithChildren,
    AccountIdUserAccountUsersRoute: AccountIdUserAccountUsersRoute,
  }

const AccountIdUserAccountRouteRouteWithChildren =
  AccountIdUserAccountRouteRoute._addFileChildren(
    AccountIdUserAccountRouteRouteChildren,
  )

interface AccountIdUserAlarmsAlarmGroupsRouteRouteChildren {
  AccountIdUserAlarmsAlarmGroupsGroupIdRoute: typeof AccountIdUserAlarmsAlarmGroupsGroupIdRoute
  AccountIdUserAlarmsAlarmGroupsCreateRoute: typeof AccountIdUserAlarmsAlarmGroupsCreateRoute
  AccountIdUserAlarmsAlarmGroupsIndexRoute: typeof AccountIdUserAlarmsAlarmGroupsIndexRoute
}

const AccountIdUserAlarmsAlarmGroupsRouteRouteChildren: AccountIdUserAlarmsAlarmGroupsRouteRouteChildren =
  {
    AccountIdUserAlarmsAlarmGroupsGroupIdRoute:
      AccountIdUserAlarmsAlarmGroupsGroupIdRoute,
    AccountIdUserAlarmsAlarmGroupsCreateRoute:
      AccountIdUserAlarmsAlarmGroupsCreateRoute,
    AccountIdUserAlarmsAlarmGroupsIndexRoute:
      AccountIdUserAlarmsAlarmGroupsIndexRoute,
  }

const AccountIdUserAlarmsAlarmGroupsRouteRouteWithChildren =
  AccountIdUserAlarmsAlarmGroupsRouteRoute._addFileChildren(
    AccountIdUserAlarmsAlarmGroupsRouteRouteChildren,
  )

interface AccountIdUserAlarmsConfigurationRouteRouteChildren {
  AccountIdUserAlarmsConfigurationAlarmConfigurationIdRoute: typeof AccountIdUserAlarmsConfigurationAlarmConfigurationIdRoute
  AccountIdUserAlarmsConfigurationIndexRoute: typeof AccountIdUserAlarmsConfigurationIndexRoute
  AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRoute: typeof AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRoute
}

const AccountIdUserAlarmsConfigurationRouteRouteChildren: AccountIdUserAlarmsConfigurationRouteRouteChildren =
  {
    AccountIdUserAlarmsConfigurationAlarmConfigurationIdRoute:
      AccountIdUserAlarmsConfigurationAlarmConfigurationIdRoute,
    AccountIdUserAlarmsConfigurationIndexRoute:
      AccountIdUserAlarmsConfigurationIndexRoute,
    AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRoute:
      AccountIdUserAlarmsConfigurationCreateAlarmTypeIdRoute,
  }

const AccountIdUserAlarmsConfigurationRouteRouteWithChildren =
  AccountIdUserAlarmsConfigurationRouteRoute._addFileChildren(
    AccountIdUserAlarmsConfigurationRouteRouteChildren,
  )

interface AccountIdUserAlarmsRouteRouteChildren {
  AccountIdUserAlarmsAlarmGroupsRouteRoute: typeof AccountIdUserAlarmsAlarmGroupsRouteRouteWithChildren
  AccountIdUserAlarmsConfigurationRouteRoute: typeof AccountIdUserAlarmsConfigurationRouteRouteWithChildren
  AccountIdUserAlarmsAlarmIdRoute: typeof AccountIdUserAlarmsAlarmIdRoute
  AccountIdUserAlarmsIndexRoute: typeof AccountIdUserAlarmsIndexRoute
}

const AccountIdUserAlarmsRouteRouteChildren: AccountIdUserAlarmsRouteRouteChildren =
  {
    AccountIdUserAlarmsAlarmGroupsRouteRoute:
      AccountIdUserAlarmsAlarmGroupsRouteRouteWithChildren,
    AccountIdUserAlarmsConfigurationRouteRoute:
      AccountIdUserAlarmsConfigurationRouteRouteWithChildren,
    AccountIdUserAlarmsAlarmIdRoute: AccountIdUserAlarmsAlarmIdRoute,
    AccountIdUserAlarmsIndexRoute: AccountIdUserAlarmsIndexRoute,
  }

const AccountIdUserAlarmsRouteRouteWithChildren =
  AccountIdUserAlarmsRouteRoute._addFileChildren(
    AccountIdUserAlarmsRouteRouteChildren,
  )

interface AccountIdUserDaluxIntegrationRouteRouteChildren {
  AccountIdUserDaluxIntegrationIndexRoute: typeof AccountIdUserDaluxIntegrationIndexRoute
}

const AccountIdUserDaluxIntegrationRouteRouteChildren: AccountIdUserDaluxIntegrationRouteRouteChildren =
  {
    AccountIdUserDaluxIntegrationIndexRoute:
      AccountIdUserDaluxIntegrationIndexRoute,
  }

const AccountIdUserDaluxIntegrationRouteRouteWithChildren =
  AccountIdUserDaluxIntegrationRouteRoute._addFileChildren(
    AccountIdUserDaluxIntegrationRouteRouteChildren,
  )

interface AccountIdUserDashboardsRouteRouteChildren {
  AccountIdUserDashboardsCompressedAirRoute: typeof AccountIdUserDashboardsCompressedAirRoute
  AccountIdUserDashboardsHeatBasicRoute: typeof AccountIdUserDashboardsHeatBasicRoute
  AccountIdUserDashboardsPowerBasicRoute: typeof AccountIdUserDashboardsPowerBasicRoute
  AccountIdUserDashboardsWaterBasicRoute: typeof AccountIdUserDashboardsWaterBasicRoute
  AccountIdUserDashboardsIndexRoute: typeof AccountIdUserDashboardsIndexRoute
}

const AccountIdUserDashboardsRouteRouteChildren: AccountIdUserDashboardsRouteRouteChildren =
  {
    AccountIdUserDashboardsCompressedAirRoute:
      AccountIdUserDashboardsCompressedAirRoute,
    AccountIdUserDashboardsHeatBasicRoute:
      AccountIdUserDashboardsHeatBasicRoute,
    AccountIdUserDashboardsPowerBasicRoute:
      AccountIdUserDashboardsPowerBasicRoute,
    AccountIdUserDashboardsWaterBasicRoute:
      AccountIdUserDashboardsWaterBasicRoute,
    AccountIdUserDashboardsIndexRoute: AccountIdUserDashboardsIndexRoute,
  }

const AccountIdUserDashboardsRouteRouteWithChildren =
  AccountIdUserDashboardsRouteRoute._addFileChildren(
    AccountIdUserDashboardsRouteRouteChildren,
  )

interface AccountIdUserDatahubIntegrationRouteRouteChildren {
  AccountIdUserDatahubIntegrationCvrNumberRoute: typeof AccountIdUserDatahubIntegrationCvrNumberRoute
  AccountIdUserDatahubIntegrationIndexRoute: typeof AccountIdUserDatahubIntegrationIndexRoute
}

const AccountIdUserDatahubIntegrationRouteRouteChildren: AccountIdUserDatahubIntegrationRouteRouteChildren =
  {
    AccountIdUserDatahubIntegrationCvrNumberRoute:
      AccountIdUserDatahubIntegrationCvrNumberRoute,
    AccountIdUserDatahubIntegrationIndexRoute:
      AccountIdUserDatahubIntegrationIndexRoute,
  }

const AccountIdUserDatahubIntegrationRouteRouteWithChildren =
  AccountIdUserDatahubIntegrationRouteRoute._addFileChildren(
    AccountIdUserDatahubIntegrationRouteRouteChildren,
  )

interface AccountIdUserEforsyningIntegrationRouteRouteChildren {
  AccountIdUserEforsyningIntegrationCreateRoute: typeof AccountIdUserEforsyningIntegrationCreateRoute
  AccountIdUserEforsyningIntegrationIndexRoute: typeof AccountIdUserEforsyningIntegrationIndexRoute
  AccountIdUserEforsyningIntegrationIntegrationIdEditRoute: typeof AccountIdUserEforsyningIntegrationIntegrationIdEditRoute
  AccountIdUserEforsyningIntegrationIntegrationIdIndexRoute: typeof AccountIdUserEforsyningIntegrationIntegrationIdIndexRoute
}

const AccountIdUserEforsyningIntegrationRouteRouteChildren: AccountIdUserEforsyningIntegrationRouteRouteChildren =
  {
    AccountIdUserEforsyningIntegrationCreateRoute:
      AccountIdUserEforsyningIntegrationCreateRoute,
    AccountIdUserEforsyningIntegrationIndexRoute:
      AccountIdUserEforsyningIntegrationIndexRoute,
    AccountIdUserEforsyningIntegrationIntegrationIdEditRoute:
      AccountIdUserEforsyningIntegrationIntegrationIdEditRoute,
    AccountIdUserEforsyningIntegrationIntegrationIdIndexRoute:
      AccountIdUserEforsyningIntegrationIntegrationIdIndexRoute,
  }

const AccountIdUserEforsyningIntegrationRouteRouteWithChildren =
  AccountIdUserEforsyningIntegrationRouteRoute._addFileChildren(
    AccountIdUserEforsyningIntegrationRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteChildren {
  AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRoute
  AccountIdUserEnergyxplorerAlarmsAdvancedCreateRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedCreateRoute
  AccountIdUserEnergyxplorerAlarmsAdvancedIndexRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedIndexRoute
}

const AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteChildren: AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRoute:
      AccountIdUserEnergyxplorerAlarmsAdvancedGroupIdRoute,
    AccountIdUserEnergyxplorerAlarmsAdvancedCreateRoute:
      AccountIdUserEnergyxplorerAlarmsAdvancedCreateRoute,
    AccountIdUserEnergyxplorerAlarmsAdvancedIndexRoute:
      AccountIdUserEnergyxplorerAlarmsAdvancedIndexRoute,
  }

const AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteWithChildren =
  AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerAlarmsRouteRouteChildren {
  AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute: typeof AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteWithChildren
  AccountIdUserEnergyxplorerAlarmsAlarmIdRoute: typeof AccountIdUserEnergyxplorerAlarmsAlarmIdRoute
}

const AccountIdUserEnergyxplorerAlarmsRouteRouteChildren: AccountIdUserEnergyxplorerAlarmsRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerAlarmsAdvancedRouteRoute:
      AccountIdUserEnergyxplorerAlarmsAdvancedRouteRouteWithChildren,
    AccountIdUserEnergyxplorerAlarmsAlarmIdRoute:
      AccountIdUserEnergyxplorerAlarmsAlarmIdRoute,
  }

const AccountIdUserEnergyxplorerAlarmsRouteRouteWithChildren =
  AccountIdUserEnergyxplorerAlarmsRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerAlarmsRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteChildren {
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRoute
}

const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteChildren: AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesCreateRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesIndexRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdEditRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesInitiativeIdIndexRoute,
  }

const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteWithChildren =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteChildren {
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteWithChildren
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRoute
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRoute
}

const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteChildren: AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyInitiativesRouteRouteWithChildren,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdChildAnalysisRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdComparisonAnalysisRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdConsumptionOverviewRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdCreateFirstNodeRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdDurationAnalysisRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEditRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyAnalysisRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEnergyBreakdownTableRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdEsgRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdHourAnalysisRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdLoadProfileAnalysisRoute,
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdIndexRoute,
  }

const AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteWithChildren =
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerDeepdiveRouteRouteChildren {
  AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute: typeof AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteWithChildren
  AccountIdUserEnergyxplorerDeepdiveCreateRoute: typeof AccountIdUserEnergyxplorerDeepdiveCreateRoute
  AccountIdUserEnergyxplorerDeepdiveDashboardRoute: typeof AccountIdUserEnergyxplorerDeepdiveDashboardRoute
  AccountIdUserEnergyxplorerDeepdiveIndexRoute: typeof AccountIdUserEnergyxplorerDeepdiveIndexRoute
}

const AccountIdUserEnergyxplorerDeepdiveRouteRouteChildren: AccountIdUserEnergyxplorerDeepdiveRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRoute:
      AccountIdUserEnergyxplorerDeepdiveEnergyGroupIdRouteRouteWithChildren,
    AccountIdUserEnergyxplorerDeepdiveCreateRoute:
      AccountIdUserEnergyxplorerDeepdiveCreateRoute,
    AccountIdUserEnergyxplorerDeepdiveDashboardRoute:
      AccountIdUserEnergyxplorerDeepdiveDashboardRoute,
    AccountIdUserEnergyxplorerDeepdiveIndexRoute:
      AccountIdUserEnergyxplorerDeepdiveIndexRoute,
  }

const AccountIdUserEnergyxplorerDeepdiveRouteRouteWithChildren =
  AccountIdUserEnergyxplorerDeepdiveRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerDeepdiveRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteChildren {
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRoute
}

const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteChildren: AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdChildAnalysisRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdComparisonAnalysisRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdDurationAnalysisRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyAnalysisRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEnergyBreakdownTableRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdEsgRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdHourAnalysisRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdLoadProfileAnalysisRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdIndexRoute,
  }

const AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteWithChildren =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteChildren {
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteWithChildren
  AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRoute
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRoute
}

const AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteChildren: AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeEnergyGroupIdRouteRouteWithChildren,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypePivotRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeIndexRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisPresetRoute,
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeAnalysisIndexRoute,
  }

const AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteWithChildren =
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerPortfolioRouteRouteChildren {
  AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute: typeof AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteWithChildren
  AccountIdUserEnergyxplorerPortfolioDashboardRoute: typeof AccountIdUserEnergyxplorerPortfolioDashboardRoute
  AccountIdUserEnergyxplorerPortfolioIndexRoute: typeof AccountIdUserEnergyxplorerPortfolioIndexRoute
  AccountIdUserEnergyxplorerPortfolioOverviewBuildingRoute: typeof AccountIdUserEnergyxplorerPortfolioOverviewBuildingRoute
  AccountIdUserEnergyxplorerPortfolioOverviewStandardRoute: typeof AccountIdUserEnergyxplorerPortfolioOverviewStandardRoute
  AccountIdUserEnergyxplorerPortfolioSiteCreateRoute: typeof AccountIdUserEnergyxplorerPortfolioSiteCreateRoute
  AccountIdUserEnergyxplorerPortfolioOverviewIndexRoute: typeof AccountIdUserEnergyxplorerPortfolioOverviewIndexRoute
}

const AccountIdUserEnergyxplorerPortfolioRouteRouteChildren: AccountIdUserEnergyxplorerPortfolioRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRoute:
      AccountIdUserEnergyxplorerPortfolioAnalysisTypeRouteRouteWithChildren,
    AccountIdUserEnergyxplorerPortfolioDashboardRoute:
      AccountIdUserEnergyxplorerPortfolioDashboardRoute,
    AccountIdUserEnergyxplorerPortfolioIndexRoute:
      AccountIdUserEnergyxplorerPortfolioIndexRoute,
    AccountIdUserEnergyxplorerPortfolioOverviewBuildingRoute:
      AccountIdUserEnergyxplorerPortfolioOverviewBuildingRoute,
    AccountIdUserEnergyxplorerPortfolioOverviewStandardRoute:
      AccountIdUserEnergyxplorerPortfolioOverviewStandardRoute,
    AccountIdUserEnergyxplorerPortfolioSiteCreateRoute:
      AccountIdUserEnergyxplorerPortfolioSiteCreateRoute,
    AccountIdUserEnergyxplorerPortfolioOverviewIndexRoute:
      AccountIdUserEnergyxplorerPortfolioOverviewIndexRoute,
  }

const AccountIdUserEnergyxplorerPortfolioRouteRouteWithChildren =
  AccountIdUserEnergyxplorerPortfolioRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerPortfolioRouteRouteChildren,
  )

interface AccountIdUserEnergyxplorerRouteRouteChildren {
  AccountIdUserEnergyxplorerAlarmsRouteRoute: typeof AccountIdUserEnergyxplorerAlarmsRouteRouteWithChildren
  AccountIdUserEnergyxplorerDeepdiveRouteRoute: typeof AccountIdUserEnergyxplorerDeepdiveRouteRouteWithChildren
  AccountIdUserEnergyxplorerPortfolioRouteRoute: typeof AccountIdUserEnergyxplorerPortfolioRouteRouteWithChildren
  AccountIdUserEnergyxplorerDashboardRoute: typeof AccountIdUserEnergyxplorerDashboardRoute
  AccountIdUserEnergyxplorerIndexRoute: typeof AccountIdUserEnergyxplorerIndexRoute
}

const AccountIdUserEnergyxplorerRouteRouteChildren: AccountIdUserEnergyxplorerRouteRouteChildren =
  {
    AccountIdUserEnergyxplorerAlarmsRouteRoute:
      AccountIdUserEnergyxplorerAlarmsRouteRouteWithChildren,
    AccountIdUserEnergyxplorerDeepdiveRouteRoute:
      AccountIdUserEnergyxplorerDeepdiveRouteRouteWithChildren,
    AccountIdUserEnergyxplorerPortfolioRouteRoute:
      AccountIdUserEnergyxplorerPortfolioRouteRouteWithChildren,
    AccountIdUserEnergyxplorerDashboardRoute:
      AccountIdUserEnergyxplorerDashboardRoute,
    AccountIdUserEnergyxplorerIndexRoute: AccountIdUserEnergyxplorerIndexRoute,
  }

const AccountIdUserEnergyxplorerRouteRouteWithChildren =
  AccountIdUserEnergyxplorerRouteRoute._addFileChildren(
    AccountIdUserEnergyxplorerRouteRouteChildren,
  )

interface AccountIdUserGatewaysGatewayIdRouteRouteChildren {
  AccountIdUserGatewaysGatewayIdEditRoute: typeof AccountIdUserGatewaysGatewayIdEditRoute
  AccountIdUserGatewaysGatewayIdIndexRoute: typeof AccountIdUserGatewaysGatewayIdIndexRoute
}

const AccountIdUserGatewaysGatewayIdRouteRouteChildren: AccountIdUserGatewaysGatewayIdRouteRouteChildren =
  {
    AccountIdUserGatewaysGatewayIdEditRoute:
      AccountIdUserGatewaysGatewayIdEditRoute,
    AccountIdUserGatewaysGatewayIdIndexRoute:
      AccountIdUserGatewaysGatewayIdIndexRoute,
  }

const AccountIdUserGatewaysGatewayIdRouteRouteWithChildren =
  AccountIdUserGatewaysGatewayIdRouteRoute._addFileChildren(
    AccountIdUserGatewaysGatewayIdRouteRouteChildren,
  )

interface AccountIdUserGatewaysRouteRouteChildren {
  AccountIdUserGatewaysGatewayIdRouteRoute: typeof AccountIdUserGatewaysGatewayIdRouteRouteWithChildren
  AccountIdUserGatewaysCreateRoute: typeof AccountIdUserGatewaysCreateRoute
  AccountIdUserGatewaysIndexRoute: typeof AccountIdUserGatewaysIndexRoute
}

const AccountIdUserGatewaysRouteRouteChildren: AccountIdUserGatewaysRouteRouteChildren =
  {
    AccountIdUserGatewaysGatewayIdRouteRoute:
      AccountIdUserGatewaysGatewayIdRouteRouteWithChildren,
    AccountIdUserGatewaysCreateRoute: AccountIdUserGatewaysCreateRoute,
    AccountIdUserGatewaysIndexRoute: AccountIdUserGatewaysIndexRoute,
  }

const AccountIdUserGatewaysRouteRouteWithChildren =
  AccountIdUserGatewaysRouteRoute._addFileChildren(
    AccountIdUserGatewaysRouteRouteChildren,
  )

interface AccountIdUserPredictiveHeatControlRouteRouteChildren {
  AccountIdUserPredictiveHeatControlBuildingNameRoute: typeof AccountIdUserPredictiveHeatControlBuildingNameRoute
  AccountIdUserPredictiveHeatControlCalendarRoute: typeof AccountIdUserPredictiveHeatControlCalendarRoute
  AccountIdUserPredictiveHeatControlIndexRoute: typeof AccountIdUserPredictiveHeatControlIndexRoute
}

const AccountIdUserPredictiveHeatControlRouteRouteChildren: AccountIdUserPredictiveHeatControlRouteRouteChildren =
  {
    AccountIdUserPredictiveHeatControlBuildingNameRoute:
      AccountIdUserPredictiveHeatControlBuildingNameRoute,
    AccountIdUserPredictiveHeatControlCalendarRoute:
      AccountIdUserPredictiveHeatControlCalendarRoute,
    AccountIdUserPredictiveHeatControlIndexRoute:
      AccountIdUserPredictiveHeatControlIndexRoute,
  }

const AccountIdUserPredictiveHeatControlRouteRouteWithChildren =
  AccountIdUserPredictiveHeatControlRouteRoute._addFileChildren(
    AccountIdUserPredictiveHeatControlRouteRouteChildren,
  )

interface AccountIdUserSensorsRouteRouteChildren {
  AccountIdUserSensorsSensorIdRoute: typeof AccountIdUserSensorsSensorIdRoute
  AccountIdUserSensorsIndexRoute: typeof AccountIdUserSensorsIndexRoute
}

const AccountIdUserSensorsRouteRouteChildren: AccountIdUserSensorsRouteRouteChildren =
  {
    AccountIdUserSensorsSensorIdRoute: AccountIdUserSensorsSensorIdRoute,
    AccountIdUserSensorsIndexRoute: AccountIdUserSensorsIndexRoute,
  }

const AccountIdUserSensorsRouteRouteWithChildren =
  AccountIdUserSensorsRouteRoute._addFileChildren(
    AccountIdUserSensorsRouteRouteChildren,
  )

interface AccountIdUserUnitsUnitIdRouteRouteChildren {
  AccountIdUserUnitsUnitIdEditRoute: typeof AccountIdUserUnitsUnitIdEditRoute
  AccountIdUserUnitsUnitIdIndexRoute: typeof AccountIdUserUnitsUnitIdIndexRoute
}

const AccountIdUserUnitsUnitIdRouteRouteChildren: AccountIdUserUnitsUnitIdRouteRouteChildren =
  {
    AccountIdUserUnitsUnitIdEditRoute: AccountIdUserUnitsUnitIdEditRoute,
    AccountIdUserUnitsUnitIdIndexRoute: AccountIdUserUnitsUnitIdIndexRoute,
  }

const AccountIdUserUnitsUnitIdRouteRouteWithChildren =
  AccountIdUserUnitsUnitIdRouteRoute._addFileChildren(
    AccountIdUserUnitsUnitIdRouteRouteChildren,
  )

interface AccountIdUserUnitsRouteRouteChildren {
  AccountIdUserUnitsUnitIdRouteRoute: typeof AccountIdUserUnitsUnitIdRouteRouteWithChildren
  AccountIdUserUnitsCreateRoute: typeof AccountIdUserUnitsCreateRoute
  AccountIdUserUnitsIndexRoute: typeof AccountIdUserUnitsIndexRoute
}

const AccountIdUserUnitsRouteRouteChildren: AccountIdUserUnitsRouteRouteChildren =
  {
    AccountIdUserUnitsUnitIdRouteRoute:
      AccountIdUserUnitsUnitIdRouteRouteWithChildren,
    AccountIdUserUnitsCreateRoute: AccountIdUserUnitsCreateRoute,
    AccountIdUserUnitsIndexRoute: AccountIdUserUnitsIndexRoute,
  }

const AccountIdUserUnitsRouteRouteWithChildren =
  AccountIdUserUnitsRouteRoute._addFileChildren(
    AccountIdUserUnitsRouteRouteChildren,
  )

interface AccountIdUserRouteRouteChildren {
  AccountIdUserAccountRouteRoute: typeof AccountIdUserAccountRouteRouteWithChildren
  AccountIdUserAlarmsRouteRoute: typeof AccountIdUserAlarmsRouteRouteWithChildren
  AccountIdUserDaluxIntegrationRouteRoute: typeof AccountIdUserDaluxIntegrationRouteRouteWithChildren
  AccountIdUserDashboardsRouteRoute: typeof AccountIdUserDashboardsRouteRouteWithChildren
  AccountIdUserDatahubIntegrationRouteRoute: typeof AccountIdUserDatahubIntegrationRouteRouteWithChildren
  AccountIdUserEforsyningIntegrationRouteRoute: typeof AccountIdUserEforsyningIntegrationRouteRouteWithChildren
  AccountIdUserEnergyxplorerRouteRoute: typeof AccountIdUserEnergyxplorerRouteRouteWithChildren
  AccountIdUserGatewaysRouteRoute: typeof AccountIdUserGatewaysRouteRouteWithChildren
  AccountIdUserPredictiveHeatControlRouteRoute: typeof AccountIdUserPredictiveHeatControlRouteRouteWithChildren
  AccountIdUserSensorsRouteRoute: typeof AccountIdUserSensorsRouteRouteWithChildren
  AccountIdUserUnitsRouteRoute: typeof AccountIdUserUnitsRouteRouteWithChildren
  AccountIdUserMissingServiceRoute: typeof AccountIdUserMissingServiceRoute
  AccountIdUserViewDataRoute: typeof AccountIdUserViewDataRoute
  AccountIdUserPowerbiReportIdRoute: typeof AccountIdUserPowerbiReportIdRoute
  AccountIdUserExportDataIndexRoute: typeof AccountIdUserExportDataIndexRoute
  AccountIdUserPowerbiIndexRoute: typeof AccountIdUserPowerbiIndexRoute
  AccountIdUserWeekscheduleManagerIndexRoute: typeof AccountIdUserWeekscheduleManagerIndexRoute
}

const AccountIdUserRouteRouteChildren: AccountIdUserRouteRouteChildren = {
  AccountIdUserAccountRouteRoute: AccountIdUserAccountRouteRouteWithChildren,
  AccountIdUserAlarmsRouteRoute: AccountIdUserAlarmsRouteRouteWithChildren,
  AccountIdUserDaluxIntegrationRouteRoute:
    AccountIdUserDaluxIntegrationRouteRouteWithChildren,
  AccountIdUserDashboardsRouteRoute:
    AccountIdUserDashboardsRouteRouteWithChildren,
  AccountIdUserDatahubIntegrationRouteRoute:
    AccountIdUserDatahubIntegrationRouteRouteWithChildren,
  AccountIdUserEforsyningIntegrationRouteRoute:
    AccountIdUserEforsyningIntegrationRouteRouteWithChildren,
  AccountIdUserEnergyxplorerRouteRoute:
    AccountIdUserEnergyxplorerRouteRouteWithChildren,
  AccountIdUserGatewaysRouteRoute: AccountIdUserGatewaysRouteRouteWithChildren,
  AccountIdUserPredictiveHeatControlRouteRoute:
    AccountIdUserPredictiveHeatControlRouteRouteWithChildren,
  AccountIdUserSensorsRouteRoute: AccountIdUserSensorsRouteRouteWithChildren,
  AccountIdUserUnitsRouteRoute: AccountIdUserUnitsRouteRouteWithChildren,
  AccountIdUserMissingServiceRoute: AccountIdUserMissingServiceRoute,
  AccountIdUserViewDataRoute: AccountIdUserViewDataRoute,
  AccountIdUserPowerbiReportIdRoute: AccountIdUserPowerbiReportIdRoute,
  AccountIdUserExportDataIndexRoute: AccountIdUserExportDataIndexRoute,
  AccountIdUserPowerbiIndexRoute: AccountIdUserPowerbiIndexRoute,
  AccountIdUserWeekscheduleManagerIndexRoute:
    AccountIdUserWeekscheduleManagerIndexRoute,
}

const AccountIdUserRouteRouteWithChildren =
  AccountIdUserRouteRoute._addFileChildren(AccountIdUserRouteRouteChildren)

interface AccountIdRouteRouteChildren {
  AccountIdAdminRouteRoute: typeof AccountIdAdminRouteRouteWithChildren
  AccountIdUserRouteRoute: typeof AccountIdUserRouteRouteWithChildren
  AccountIdErrorboundarydevtestRoute: typeof AccountIdErrorboundarydevtestRoute
  AccountIdSupportRoute: typeof AccountIdSupportRoute
  AccountIdIndexRoute: typeof AccountIdIndexRoute
}

const AccountIdRouteRouteChildren: AccountIdRouteRouteChildren = {
  AccountIdAdminRouteRoute: AccountIdAdminRouteRouteWithChildren,
  AccountIdUserRouteRoute: AccountIdUserRouteRouteWithChildren,
  AccountIdErrorboundarydevtestRoute: AccountIdErrorboundarydevtestRoute,
  AccountIdSupportRoute: AccountIdSupportRoute,
  AccountIdIndexRoute: AccountIdIndexRoute,
}

const AccountIdRouteRouteWithChildren = AccountIdRouteRoute._addFileChildren(
  AccountIdRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountIdRouteRoute: AccountIdRouteRouteWithChildren,
  AccountCreateRoute: AccountCreateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
